var OMFE = OMFE || {}; OMFE["OMFECore"] =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/omc/x/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 552);
/******/ })
/************************************************************************/
/******/ ({

/***/ 11:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__combineReducers__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compose__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_warning__ = __webpack_require__(21);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createStore", function() { return __WEBPACK_IMPORTED_MODULE_0__createStore__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "combineReducers", function() { return __WEBPACK_IMPORTED_MODULE_1__combineReducers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bindActionCreators", function() { return __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "applyMiddleware", function() { return __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return __WEBPACK_IMPORTED_MODULE_4__compose__["a"]; });







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),

/***/ 119:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

///////////////////////////////////////////////////////////////////////////////
//
//  AutobahnJS - http://autobahn.ws, http://wamp.ws
//
//  A JavaScript library for WAMP ("The Web Application Messaging Protocol").
//
//  Copyright (C) 2011-2014 Tavendo GmbH, http://tavendo.com
//
//  Licensed under the MIT License.
//  http://www.opensource.org/licenses/mit-license.php
//
///////////////////////////////////////////////////////////////////////////////

/* eslint spaced-comment:0,vars-on-top:0,no-var:0,camelcase:0,func-names:0,one-var:0,one-var-declaration-per-line:0,eqeqeq:0,
no-multiple-empty-lines:0,prefer-rest-params:0,block-scoped-var:0,no-use-before-define:0,prefer-template:0,no-restricted-syntax:0,
no-debugger:0,padded-blocks:0,no-else-return:0,quotes:0,object-curly-spacing:0,semi:0,space-infix-ops:0,no-console:0 */
/* global AUTOBAHN_DEBUG:true */

if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) === 'object' && window !== null) {
    window.Promise = window.Promise || __webpack_require__(198).Promise;
}
var util = __webpack_require__(60);
var session = __webpack_require__(121);
var connection = __webpack_require__(179);
var configure = __webpack_require__(178);
var serializer = __webpack_require__(120);

exports.transports = configure.transports;

exports.Connection = connection.Connection;

exports.Session = session.Session;
exports.Invocation = session.Invocation;
exports.Event = session.Event;
exports.Result = session.Result;
exports.Error = session.Error;
exports.Subscription = session.Subscription;
exports.Registration = session.Registration;
exports.Publication = session.Publication;

exports.serializer = serializer;

exports.util = util;

/***/ }),

/***/ 12:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(38);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = isPlainObject;


/***/ }),

/***/ 120:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


///////////////////////////////////////////////////////////////////////////////
//
//  AutobahnJS - http://autobahn.ws, http://wamp.ws
//
//  A JavaScript library for WAMP ("The Web Application Messaging Protocol").
//
//  Copyright (C) 2011-2016 Tavendo GmbH, http://tavendo.com
//
//  Licensed under the MIT License.
//  http://www.opensource.org/licenses/mit-license.php
//
///////////////////////////////////////////////////////////////////////////////

/* eslint spaced-comment:0,vars-on-top:0,no-var:0,camelcase:0,func-names:0,one-var:0,one-var-declaration-per-line:0,eqeqeq:0,
no-multiple-empty-lines:0,prefer-rest-params:0,block-scoped-var:0,no-use-before-define:0,prefer-template:0,no-restricted-syntax:0,
no-debugger:0,padded-blocks:0,no-else-return:0,quotes:0,object-curly-spacing:0,semi:0,space-infix-ops:0,no-console:0,no-underscore-dangle:0,
no-throw-literal:0,no-unneeded-ternary:0,guard-for-in:0,space-before-function-paren:0, new-cap:0,prefer-arrow-callback:0,comma-dangle:0,
no-multi-spaces:0,keyword-spacing:0,no-shadow:0,object-shorthand:0,global-require:0,no-inner-declarations:0 */
/* global AUTOBAHN_DEBUG:true */
function JSONSerializer(replacer, reviver) {
    this.replacer = replacer;
    this.reviver = reviver;
    this.SERIALIZER_ID = 'json';
    this.BINARY = false;
}

JSONSerializer.prototype.serialize = function (obj) {
    return JSON.stringify(obj, this.replacer);
};

JSONSerializer.prototype.unserialize = function (payload) {
    return JSON.parse(payload, this.reviver);
};

exports.JSONSerializer = JSONSerializer;

exports.MsgpackSerializer = null;

/***/ }),

/***/ 121:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


///////////////////////////////////////////////////////////////////////////////
//
//  AutobahnJS - http://autobahn.ws, http://wamp.ws
//
//  A JavaScript library for WAMP ("The Web Application Messaging Protocol").
//
//  Copyright (C) 2011-2014 Tavendo GmbH, http://tavendo.com
//
//  Licensed under the MIT License.
//  http://www.opensource.org/licenses/mit-license.php
//
///////////////////////////////////////////////////////////////////////////////
/* eslint spaced-comment:0,vars-on-top:0,no-var:0,camelcase:0,func-names:0,one-var:0,one-var-declaration-per-line:0,eqeqeq:0,
no-multiple-empty-lines:0,prefer-rest-params:0,block-scoped-var:0,no-use-before-define:0,prefer-template:0,no-restricted-syntax:0,
no-debugger:0,padded-blocks:0,no-else-return:0,quotes:0,object-curly-spacing:0,semi:0,space-infix-ops:0,no-console:0,no-underscore-dangle:0,
no-throw-literal:0,no-unneeded-ternary:0,guard-for-in:0,space-before-function-paren:0, new-cap:0,prefer-arrow-callback:0,comma-dangle:0,
no-multi-spaces:0,keyword-spacing:0,no-shadow:0,object-shorthand:0,global-require:0,no-inner-declarations:0,no-redeclare:0,
no-param-reassign:0,no-extra-semi:0,consistent-return:0 */
/* global AUTOBAHN_DEBUG:true */
// require('assert') would be nice .. but it does not
// work with Google Closure after Browserify


var util = __webpack_require__(60);

// IE fallback (http://afuchs.tumblr.com/post/23550124774/date-now-in-ie8)
Date.now = Date.now || function () {
    return +new Date();
};

// WAMP "Advanced Profile" support in AutobahnJS per role
//
var WAMP_FEATURES = {
    caller: {
        features: {
            caller_identification: true,
            //call_timeout: true,
            //call_canceling: true,
            progressive_call_results: true
        }
    },
    callee: {
        features: {
            caller_identification: true,
            //call_trustlevels: true,
            pattern_based_registration: true,
            shared_registration: true,
            //call_timeout: true,
            //call_canceling: true,
            progressive_call_results: true,
            registration_revocation: true
        }
    },
    publisher: {
        features: {
            publisher_identification: true,
            subscriber_blackwhite_listing: true,
            publisher_exclusion: true
        }
    },
    subscriber: {
        features: {
            publisher_identification: true,
            //publication_trustlevels: true,
            pattern_based_subscription: true,
            subscription_revocation: true
            //event_history: true,
        }
    }
};

// generate a WAMP ID
//
function newid() {
    return Math.floor(Math.random() * 9007199254740992);
}

var Invocation = function Invocation(procedure, progress, caller, caller_authid, caller_authrole) {

    var self = this;

    self.procedure = procedure;
    self.progress = progress;
    self.caller = caller;
    self.caller_authid = caller_authid;
    self.caller_authrole = caller_authrole;
};

var Event = function Event(publication, topic, publisher, publisher_authid, publisher_authrole) {

    var self = this;

    self.publication = publication;
    self.topic = topic;
    self.publisher = publisher;
    self.publisher_authid = publisher_authid;
    self.publisher_authrole = publisher_authrole;
};

var Result = function Result(args, kwargs) {

    var self = this;

    self.args = args || [];
    self.kwargs = kwargs || {};
};

var Error = function Error(error, args, kwargs) {

    var self = this;

    self.error = error;
    self.args = args || [];
    self.kwargs = kwargs || {};
};

var Subscription = function Subscription(topic, handler, options, session, id) {

    var self = this;

    self.topic = topic;
    self.handler = handler;
    self.options = options || {};
    self.session = session;
    self.id = id;

    self.active = true;

    // this will fire when the handler is unsubscribed
    self._on_unsubscribe = session._defer();

    if (self._on_unsubscribe.promise.then) {
        // whenjs has the actual user promise in an attribute
        self.on_unsubscribe = self._on_unsubscribe.promise;
    } else {
        self.on_unsubscribe = self._on_unsubscribe;
    }
};

Subscription.prototype.unsubscribe = function () {

    var self = this;
    return self.session.unsubscribe(self);
};

var Registration = function Registration(procedure, endpoint, options, session, id) {

    var self = this;

    self.procedure = procedure;
    self.endpoint = endpoint;
    self.options = options || {};
    self.session = session;
    self.id = id;

    self.active = true;

    // this will fire when the endpoint is unregistered
    self._on_unregister = session._defer();

    if (self._on_unregister.promise.then) {
        // whenjs has the actual user promise in an attribute
        self.on_unregister = self._on_unregister.promise;
    } else {
        self.on_unregister = self._on_unregister;
    }
};

Registration.prototype.unregister = function () {

    var self = this;
    return self.session.unregister(self);
};

var Publication = function Publication(id) {

    var self = this;
    self.id = id;
};

var MSG_TYPE = {
    HELLO: 1,
    WELCOME: 2,
    ABORT: 3,
    CHALLENGE: 4,
    AUTHENTICATE: 5,
    GOODBYE: 6,
    HEARTBEAT: 7,
    ERROR: 8,
    PUBLISH: 16,
    PUBLISHED: 17,
    SUBSCRIBE: 32,
    SUBSCRIBED: 33,
    UNSUBSCRIBE: 34,
    UNSUBSCRIBED: 35,
    EVENT: 36,
    CALL: 48,
    CANCEL: 49,
    RESULT: 50,
    REGISTER: 64,
    REGISTERED: 65,
    UNREGISTER: 66,
    UNREGISTERED: 67,
    INVOCATION: 68,
    INTERRUPT: 69,
    YIELD: 70
};

var Session = function Session(socket, defer, onchallenge) {

    var self = this;

    // the transport connection (WebSocket object)
    self._socket = socket;

    // the Deferred factory to use
    self._defer = defer;

    // the WAMP authentication challenge handler
    self._onchallenge = onchallenge;

    // the WAMP session ID
    self._id = null;

    // the WAMP realm joined
    self._realm = null;

    // the WAMP features in use
    self._features = null;

    // closing state
    self._goodbye_sent = false;
    self._transport_is_closing = false;

    // outstanding requests;
    self._publish_reqs = {};
    self._subscribe_reqs = {};
    self._unsubscribe_reqs = {};
    self._call_reqs = {};
    self._register_reqs = {};
    self._unregister_reqs = {};

    // subscriptions in place;
    self._subscriptions = {};

    // registrations in place;
    self._registrations = {};

    // incoming invocations;
    self._invocations = {};

    // prefix shortcuts for URIs
    self._prefixes = {};

    // the defaults for 'disclose_me'
    self._caller_disclose_me = false;
    self._publisher_disclose_me = false;

    self._send_wamp = function (msg) {
        // forward WAMP message to be sent to WAMP transport
        self._socket.send(msg);
    };

    self._protocol_violation = function (reason) {
        self._socket.close(1002, "protocol violation: " + reason);
    };

    self._MESSAGE_MAP = {};
    self._MESSAGE_MAP[MSG_TYPE.ERROR] = {};

    self._process_SUBSCRIBED = function (msg) {
        //
        // process SUBSCRIBED reply to SUBSCRIBE
        //
        var request = msg[1];
        var subscription = msg[2];

        if (request in self._subscribe_reqs) {

            var r = self._subscribe_reqs[request];

            var d = r[0];
            var topic = r[1];
            var handler = r[2];
            var options = r[3];

            if (!(subscription in self._subscriptions)) {
                self._subscriptions[subscription] = [];
            }
            var sub = new Subscription(topic, handler, options, self, subscription);
            self._subscriptions[subscription].push(sub);

            d.resolve(sub);

            delete self._subscribe_reqs[request];
        } else {
            self._protocol_violation("SUBSCRIBED received for non-pending request ID " + request);
        }
    };
    self._MESSAGE_MAP[MSG_TYPE.SUBSCRIBED] = self._process_SUBSCRIBED;

    self._process_SUBSCRIBE_ERROR = function (msg) {
        //
        // process ERROR reply to SUBSCRIBE
        //
        var request = msg[2];
        if (request in self._subscribe_reqs) {

            //var details = msg[3];
            var error = new Error(msg[4], msg[5], msg[6]);

            var r = self._subscribe_reqs[request];

            var d = r[0];

            d.reject(error);

            delete self._subscribe_reqs[request];
        } else {
            self._protocol_violation("SUBSCRIBE-ERROR received for non-pending request ID " + request);
        }
    };
    self._MESSAGE_MAP[MSG_TYPE.ERROR][MSG_TYPE.SUBSCRIBE] = self._process_SUBSCRIBE_ERROR;

    self._process_UNSUBSCRIBED = function (msg) {
        //
        // process UNSUBSCRIBED reply to UNSUBSCRIBE
        //
        var request = msg[1];

        if (request in self._unsubscribe_reqs) {

            var r = self._unsubscribe_reqs[request];

            var d = r[0];
            var subscription_id = r[1];

            if (subscription_id in self._subscriptions) {
                var subs = self._subscriptions[subscription_id];
                // the following should actually be NOP, since UNSUBSCRIBE was
                // only sent when subs got empty
                for (var i = 0; i < subs.length; ++i) {
                    subs[i].active = false;
                    subs[i].on_unsubscribe.resolve();
                }
                delete self._subscriptions[subscription_id];
            }

            d.resolve(true);

            delete self._unsubscribe_reqs[request];
        } else if (request === 0) {

            // router actively revoked our subscription
            //
            var details = msg[2];
            var subscription_id = details.subscription;
            var reason = details.reason;

            if (subscription_id in self._subscriptions) {
                var subs = self._subscriptions[subscription_id];
                for (var i = 0; i < subs.length; ++i) {
                    subs[i].active = false;
                    subs[i]._on_unsubscribe.resolve(reason);
                }
                delete self._subscriptions[subscription_id];
            } else {
                self._protocol_violation("non-voluntary UNSUBSCRIBED received for non-existing subscription ID " + subscription_id);
            }
        } else {
            self._protocol_violation("UNSUBSCRIBED received for non-pending request ID " + request);
        }
    };
    self._MESSAGE_MAP[MSG_TYPE.UNSUBSCRIBED] = self._process_UNSUBSCRIBED;

    self._process_UNSUBSCRIBE_ERROR = function (msg) {
        //
        // process ERROR reply to UNSUBSCRIBE
        //
        var request = msg[2];
        if (request in self._unsubscribe_reqs) {

            //var details = msg[3];
            var error = new Error(msg[4], msg[5], msg[6]);

            var r = self._unsubscribe_reqs[request];

            var d = r[0];
            //var subscription = r[1];

            d.reject(error);

            delete self._unsubscribe_reqs[request];
        } else {
            self._protocol_violation("UNSUBSCRIBE-ERROR received for non-pending request ID " + request);
        }
    };
    self._MESSAGE_MAP[MSG_TYPE.ERROR][MSG_TYPE.UNSUBSCRIBE] = self._process_UNSUBSCRIBE_ERROR;

    self._process_PUBLISHED = function (msg) {
        //
        // process PUBLISHED reply to PUBLISH
        //
        var request = msg[1];
        var publication = msg[2];

        if (request in self._publish_reqs) {

            var r = self._publish_reqs[request];

            var d = r[0];
            //var options = r[1];

            var pub = new Publication(publication);
            d.resolve(pub);

            delete self._publish_reqs[request];
        } else {
            self._protocol_violation("PUBLISHED received for non-pending request ID " + request);
        }
    };
    self._MESSAGE_MAP[MSG_TYPE.PUBLISHED] = self._process_PUBLISHED;

    self._process_PUBLISH_ERROR = function (msg) {
        //
        // process ERROR reply to PUBLISH
        //
        var request = msg[2];
        if (request in self._publish_reqs) {

            //var details = msg[3];
            var error = new Error(msg[4], msg[5], msg[6]);

            var r = self._publish_reqs[request];

            var d = r[0];
            //var options = r[1];

            d.reject(error);

            delete self._publish_reqs[request];
        } else {
            self._protocol_violation("PUBLISH-ERROR received for non-pending request ID " + request);
        }
    };
    self._MESSAGE_MAP[MSG_TYPE.ERROR][MSG_TYPE.PUBLISH] = self._process_PUBLISH_ERROR;

    self._process_EVENT = function (msg) {
        //
        // process EVENT message
        //
        // [EVENT, SUBSCRIBED.Subscription|id, PUBLISHED.Publication|id, Details|dict, PUBLISH.Arguments|list, PUBLISH.ArgumentsKw|dict]

        var subscription = msg[1];

        if (subscription in self._subscriptions) {

            var publication = msg[2];
            var details = msg[3];

            var args = msg[4] || [];
            var kwargs = msg[5] || {};

            var subs = self._subscriptions[subscription];

            // we want to provide the subscription topic to the handler, and may need to get this
            // from one of the subscription handler objects attached to the subscription
            // since for non-pattern subscriptions this is not sent over the wire
            var ed = new Event(publication, details.topic || subs[0].topic, details.publisher, details.publisher_authid, details.publisher_authrole);

            for (var i = 0; i < subs.length; ++i) {
                try {
                    subs[i].handler(args, kwargs, ed);
                } catch (e) {
                    //
                }
            }
        } else {
            self._protocol_violation("EVENT received for non-subscribed subscription ID " + subscription);
        }
    };
    self._MESSAGE_MAP[MSG_TYPE.EVENT] = self._process_EVENT;

    self._process_REGISTERED = function (msg) {
        //
        // process REGISTERED reply to REGISTER
        //
        var request = msg[1];
        var registration = msg[2];

        if (request in self._register_reqs) {

            var r = self._register_reqs[request];

            var d = r[0];
            var procedure = r[1];
            var endpoint = r[2];
            var options = r[3];

            var reg = new Registration(procedure, endpoint, options, self, registration);

            self._registrations[registration] = reg;

            d.resolve(reg);

            delete self._register_reqs[request];
        } else {
            self._protocol_violation("REGISTERED received for non-pending request ID " + request);
        }
    };
    self._MESSAGE_MAP[MSG_TYPE.REGISTERED] = self._process_REGISTERED;

    self._process_REGISTER_ERROR = function (msg) {
        //
        // process ERROR reply to REGISTER
        //
        var request = msg[2];
        if (request in self._register_reqs) {

            //var details = msg[3];
            var error = new Error(msg[4], msg[5], msg[6]);

            var r = self._register_reqs[request];

            var d = r[0];

            d.reject(error);

            delete self._register_reqs[request];
        } else {
            self._protocol_violation("REGISTER-ERROR received for non-pending request ID " + request);
        }
    };
    self._MESSAGE_MAP[MSG_TYPE.ERROR][MSG_TYPE.REGISTER] = self._process_REGISTER_ERROR;

    self._process_UNREGISTERED = function (msg) {
        //
        // process UNREGISTERED reply to UNREGISTER
        //
        var request = msg[1];

        if (request in self._unregister_reqs) {

            var r = self._unregister_reqs[request];

            var d = r[0];
            var registration = r[1];

            if (registration.id in self._registrations) {
                delete self._registrations[registration.id];
            }

            registration.active = false;
            d.resolve();

            delete self._unregister_reqs[request];
        } else if (request === 0) {

            // the router actively revoked our registration
            //
            var details = msg[2];
            var registration_id = details.registration;
            var reason = details.reason;

            if (registration_id in self._registrations) {
                var registration = self._registrations[registration_id];
                registration.active = false;
                registration._on_unregister.resolve(reason);
                delete self._registrations[registration_id];
            } else {
                self._protocol_violation("non-voluntary UNREGISTERED received for non-existing registration ID " + registration_id);
            }
        } else {
            self._protocol_violation("UNREGISTERED received for non-pending request ID " + request);
        }
    };
    self._MESSAGE_MAP[MSG_TYPE.UNREGISTERED] = self._process_UNREGISTERED;

    self._process_UNREGISTER_ERROR = function (msg) {
        //
        // process ERROR reply to UNREGISTER
        //
        var request = msg[2];
        if (request in self._unregister_reqs) {

            //var details = msg[3];
            var error = new Error(msg[4], msg[5], msg[6]);

            var r = self._unregister_reqs[request];

            var d = r[0];
            //var registration = r[1];

            d.reject(error);

            delete self._unregister_reqs[request];
        } else {
            self._protocol_violation("UNREGISTER-ERROR received for non-pending request ID " + request);
        }
    };
    self._MESSAGE_MAP[MSG_TYPE.ERROR][MSG_TYPE.UNREGISTER] = self._process_UNREGISTER_ERROR;

    self._process_RESULT = function (msg) {
        //
        // process RESULT reply to CALL
        //
        var request = msg[1];
        if (request in self._call_reqs) {

            var details = msg[2];

            var args = msg[3] || [];
            var kwargs = msg[4] || {};

            // maybe wrap complex result:
            var result = null;
            if (args.length > 1 || Object.keys(kwargs).length > 0) {
                // wrap complex result is more than 1 positional result OR
                // non-empty keyword result
                result = new Result(args, kwargs);
            } else if (args.length > 0) {
                // single positional result
                result = args[0];
            }

            var r = self._call_reqs[request];

            var d = r[0];
            var options = r[1];

            if (details.progress) {
                if (options && options.receive_progress) {
                    d.notify(result);
                }
            } else {
                d.resolve(result);
                delete self._call_reqs[request];
            }
        } else {
            self._protocol_violation("CALL-RESULT received for non-pending request ID " + request);
        }
    };
    self._MESSAGE_MAP[MSG_TYPE.RESULT] = self._process_RESULT;

    self._process_CALL_ERROR = function (msg) {
        //
        // process ERROR reply to CALL
        //
        var request = msg[2];
        if (request in self._call_reqs) {

            //var details = msg[3];
            var error = new Error(msg[4], msg[5], msg[6]);

            var r = self._call_reqs[request];

            var d = r[0];
            //var options = r[1];

            d.reject(error);

            delete self._call_reqs[request];
        } else {
            self._protocol_violation("CALL-ERROR received for non-pending request ID " + request);
        }
    };
    self._MESSAGE_MAP[MSG_TYPE.ERROR][MSG_TYPE.CALL] = self._process_CALL_ERROR;

    self._process_INVOCATION = function (msg) {
        //
        // process INVOCATION message
        //
        // [INVOCATION, Request|id, REGISTERED.Registration|id, Details|dict, CALL.Arguments|list, CALL.ArgumentsKw|dict]
        //
        var request = msg[1];
        var registration = msg[2];

        var details = msg[3];
        // receive_progress
        // timeout
        // caller

        if (registration in self._registrations) {

            var reg = self._registrations[registration];

            var args = msg[4] || [];
            var kwargs = msg[5] || {};

            // create progress function for invocation
            //
            var progress = null;
            if (details.receive_progress) {

                progress = function progress(args, kwargs) {
                    var progress_msg = [MSG_TYPE.YIELD, request, { progress: true }];

                    args = args || [];
                    kwargs = kwargs || {};

                    var kwargs_len = Object.keys(kwargs).length;
                    if (args.length || kwargs_len) {
                        progress_msg.push(args);
                        if (kwargs_len) {
                            progress_msg.push(kwargs);
                        }
                    }
                    self._send_wamp(progress_msg);
                };
            };

            // we want to provide the regitration procedure to the handler and may
            // need to get this from the registration object attached to the registration
            // since for non-pattern registrations this is not sent over the wire
            var cd = new Invocation(details.procedure || reg.procedure, progress, details.caller, details.caller_authid, details.caller_authrole);

            // We use the following whenjs call wrapper, which automatically
            // wraps a plain, non-promise value in a (immediately resolved) promise
            //
            // See: https://github.com/cujojs/when/blob/master/docs/api.md#fncall
            //
            new Promise(function (resolve, reject) {
                try {
                    resolve(reg.endpoint(args, kwargs, cd));
                } catch (e) {
                    reject(e);
                }
            }).then(function (res) {
                // construct YIELD message
                // FIXME: Options
                //
                var reply = [MSG_TYPE.YIELD, request, {}];

                if (res instanceof Result) {
                    var kwargs_len = Object.keys(res.kwargs).length;
                    if (res.args.length || kwargs_len) {
                        reply.push(res.args);
                        if (kwargs_len) {
                            reply.push(res.kwargs);
                        }
                    }
                } else {
                    reply.push([res]);
                }

                // send WAMP message
                //
                self._send_wamp(reply);
            }, function (err) {
                // construct ERROR message
                // [ERROR, REQUEST.Type|int, REQUEST.Request|id, Details|dict, Error|uri, Arguments|list, ArgumentsKw|dict]

                var reply = [MSG_TYPE.ERROR, MSG_TYPE.INVOCATION, request, {}];

                if (err instanceof Error) {

                    reply.push(err.error);

                    var kwargs_len = Object.keys(err.kwargs).length;
                    if (err.args.length || kwargs_len) {
                        reply.push(err.args);
                        if (kwargs_len) {
                            reply.push(err.kwargs);
                        }
                    }
                } else {
                    reply.push('wamp.error.runtime_error');
                    reply.push([err]);
                }

                // send WAMP message
                //
                self._send_wamp(reply);
            });
        } else {
            self._protocol_violation("INVOCATION received for non-registered registration ID " + request);
        }
    };
    self._MESSAGE_MAP[MSG_TYPE.INVOCATION] = self._process_INVOCATION;

    // callback fired by WAMP transport on receiving a WAMP message
    //
    self._socket.onmessage = function (msg) {

        var msg_type = msg[0];

        // WAMP session not yet open
        //
        if (!self._id) {

            // the first message must be WELCOME, ABORT or CHALLENGE ..
            //
            if (msg_type === MSG_TYPE.WELCOME) {

                self._id = msg[1];

                // determine actual set of advanced features that can be used
                //
                var rf = msg[2];
                self._features = {};

                if (rf.roles.broker) {
                    // "Basic Profile" is mandatory
                    self._features.subscriber = {};
                    self._features.publisher = {};

                    // fill in features that both peers support
                    if (rf.roles.broker.features) {

                        for (var att in WAMP_FEATURES.publisher.features) {
                            self._features.publisher[att] = WAMP_FEATURES.publisher.features[att] && rf.roles.broker.features[att];
                        }

                        for (var att in WAMP_FEATURES.subscriber.features) {
                            self._features.subscriber[att] = WAMP_FEATURES.subscriber.features[att] && rf.roles.broker.features[att];
                        }
                    }
                }

                if (rf.roles.dealer) {
                    // "Basic Profile" is mandatory
                    self._features.caller = {};
                    self._features.callee = {};

                    // fill in features that both peers support
                    if (rf.roles.dealer.features) {

                        for (var att in WAMP_FEATURES.caller.features) {
                            self._features.caller[att] = WAMP_FEATURES.caller.features[att] && rf.roles.dealer.features[att];
                        }

                        for (var att in WAMP_FEATURES.callee.features) {
                            self._features.callee[att] = WAMP_FEATURES.callee.features[att] && rf.roles.dealer.features[att];
                        }
                    }
                }

                if (self.onjoin) {
                    self.onjoin(msg[2]);
                }
            } else if (msg_type === MSG_TYPE.ABORT) {

                var details = msg[1];
                var reason = msg[2];

                if (self.onleave) {
                    self.onleave(reason, details);
                }
            } else if (msg_type === MSG_TYPE.CHALLENGE) {

                if (self._onchallenge) {

                    var method = msg[1];
                    var extra = msg[2];

                    new Promise(function (resolve, reject) {
                        try {
                            resolve(self._onchallenge(self, method, extra));
                        } catch (e) {
                            reject(e);
                        }
                    }).then(function (signature) {
                        var msg = [MSG_TYPE.AUTHENTICATE, signature, {}];
                        self._send_wamp(msg);
                    }, function () {
                        var msg = [MSG_TYPE.ABORT, { message: "sorry, I cannot authenticate (onchallenge handler raised an exception)" }, "wamp.error.cannot_authenticate"];
                        self._send_wamp(msg);
                        self._socket.close(1000);
                    });
                } else {
                    var msg = [MSG_TYPE.ABORT, { message: "sorry, I cannot authenticate (no onchallenge handler set)" }, "wamp.error.cannot_authenticate"];
                    self._send_wamp(msg);
                    self._socket.close(1000);
                }
            } else {
                self._protocol_violation("unexpected message type " + msg_type);
            }

            // WAMP session is open
            //
        } else if (msg_type === MSG_TYPE.GOODBYE) {

            if (!self._goodbye_sent) {

                var reply = [MSG_TYPE.GOODBYE, {}, "wamp.error.goodbye_and_out"];
                self._send_wamp(reply);
            }

            self._id = null;
            self._realm = null;
            self._features = null;

            var details = msg[1];
            var reason = msg[2];

            if (self.onleave) {
                self.onleave(reason, details);
            }
        } else if (msg_type === MSG_TYPE.ERROR) {

            var request_type = msg[1];
            if (request_type in self._MESSAGE_MAP[MSG_TYPE.ERROR]) {

                self._MESSAGE_MAP[msg_type][request_type](msg);
            } else {

                self._protocol_violation("unexpected ERROR message with request_type " + request_type);
            }
        } else if (msg_type in self._MESSAGE_MAP) {

            self._MESSAGE_MAP[msg_type](msg);
        } else {

            self._protocol_violation("unexpected message type " + msg_type);
        }
    };

    // session object constructed .. track creation time
    //
    if ('performance' in window && 'now' in performance) {
        self._created = performance.now();
    } else {
        self._created = Date.now();
    }
};

Object.defineProperty(Session.prototype, "defer", {
    get: function get() {
        return this._defer;
    }
});

Object.defineProperty(Session.prototype, "id", {
    get: function get() {
        return this._id;
    }
});

Object.defineProperty(Session.prototype, "realm", {
    get: function get() {
        return this._realm;
    }
});

Object.defineProperty(Session.prototype, "isOpen", {
    get: function get() {
        return this.id !== null;
    }
});

Object.defineProperty(Session.prototype, "features", {
    get: function get() {
        return this._features;
    }
});

Object.defineProperty(Session.prototype, "caller_disclose_me", {
    get: function get() {
        return this._caller_disclose_me;
    },
    set: function set(newValue) {
        this._caller_disclose_me = newValue;
    }
});

Object.defineProperty(Session.prototype, "publisher_disclose_me", {
    get: function get() {
        return this._publisher_disclose_me;
    },
    set: function set(newValue) {
        this._publisher_disclose_me = newValue;
    }
});

Object.defineProperty(Session.prototype, "subscriptions", {
    get: function get() {
        var keys = Object.keys(this._subscriptions);
        var vals = [];
        for (var i = 0; i < keys.length; ++i) {
            vals.push(this._subscriptions[keys[i]]);
        }
        return vals;
    }
});

Object.defineProperty(Session.prototype, "registrations", {
    get: function get() {
        var keys = Object.keys(this._registrations);
        var vals = [];
        for (var i = 0; i < keys.length; ++i) {
            vals.push(this._registrations[keys[i]]);
        }
        return vals;
    }
});

Session.prototype.log = function () {
    var self = this;

    if ('console' in window) {

        var header = null;
        if (self._id && self._created) {

            var now = null;
            if ('performance' in window && 'now' in performance) {
                now = performance.now() - self._created;
            } else {
                now = Date.now() - self._created;
            }

            header = "WAMP session " + self._id + " on '" + self._realm + "' at " + Math.round(now * 1000) / 1000 + " ms";
        } else {
            header = "WAMP session";
        }

        if ('group' in console) {
            console.group(header);
            for (var i = 0; i < arguments.length; i += 1) {
                console.log(arguments[i]);
            }
            console.groupEnd();
        } else {
            var items = [header + ": "];
            for (var i = 0; i < arguments.length; i += 1) {
                items.push(arguments[i]);
            }
            console.log.apply(console, items);
        }
    }
};

Session.prototype.join = function (realm, authmethods, authid) {

    util.assert(typeof realm === 'string', "Session.join: <realm> must be a string");
    util.assert(!authmethods || Array.isArray(authmethods), "Session.join: <authmethods> must be an array []");
    util.assert(!authid || typeof authid === 'string', "Session.join: <authid> must be a string");

    var self = this;

    if (self.isOpen) {
        throw "session already open";
    }

    self._goodbye_sent = false;
    self._realm = realm;

    var details = {};
    details.roles = WAMP_FEATURES;

    if (authmethods) {
        details.authmethods = authmethods;
    }
    if (authid) {
        details.authid = authid;
    }

    var msg = [MSG_TYPE.HELLO, realm, details];
    self._send_wamp(msg);
};

Session.prototype.leave = function (reason, message) {

    util.assert(!reason || typeof reason === 'string', "Session.leave: <reason> must be a string");
    util.assert(!message || typeof message === 'string', "Session.leave: <message> must be a string");

    var self = this;

    if (!self.isOpen) {
        throw "session not open";
    }

    if (!reason) {
        reason = "wamp.close.normal";
    }

    var details = {};
    if (message) {
        details.message = message;
    }

    var msg = [MSG_TYPE.GOODBYE, details, reason];
    self._send_wamp(msg);
    self._goodbye_sent = true;
};

Session.prototype.call = function (procedure, args, kwargs, options) {

    util.assert(typeof procedure === 'string', "Session.call: <procedure> must be a string");
    util.assert(!args || Array.isArray(args), "Session.call: <args> must be an array []");
    util.assert(!kwargs || kwargs instanceof Object, "Session.call: <kwargs> must be an object {}");
    util.assert(!options || options instanceof Object, "Session.call: <options> must be an object {}");

    var self = this;

    if (!self.isOpen) {
        throw "session not open";
    }

    options = options || {};

    // only set option if user hasn't set a value and global option is "on"
    if (typeof options.disclose_me === 'undefined' && self._caller_disclose_me) {
        options.disclose_me = true;
    }

    // create and remember new CALL request
    //
    var d = self._defer();
    var request = newid();
    self._call_reqs[request] = [d, options];

    // construct CALL message
    //
    var msg = [MSG_TYPE.CALL, request, options, self.resolve(procedure)];
    if (args) {
        msg.push(args);
        if (kwargs) {
            msg.push(kwargs);
        }
    } else if (kwargs) {
        msg.push([]);
        msg.push(kwargs);
    }

    // send WAMP message
    //
    self._send_wamp(msg);

    if (d.promise.then) {
        // whenjs has the actual user promise in an attribute
        return d.promise;
    } else {
        return d;
    }
};

Session.prototype.subscribe = function (topic, handler, options) {

    util.assert(typeof topic === 'string', "Session.subscribe: <topic> must be a string");
    util.assert(typeof handler === 'function', "Session.subscribe: <handler> must be a function");
    util.assert(!options || options instanceof Object, "Session.subscribe: <options> must be an object {}");

    var self = this;

    if (!self.isOpen) {
        throw "session not open";
    }

    // create an remember new SUBSCRIBE request
    //
    var request = newid();
    var d = self._defer();
    self._subscribe_reqs[request] = [d, topic, handler, options];

    // construct SUBSCRIBE message
    //
    var msg = [MSG_TYPE.SUBSCRIBE, request];
    if (options) {
        msg.push(options);
    } else {
        msg.push({});
    }
    msg.push(self.resolve(topic));

    // send WAMP message
    //
    self._send_wamp(msg);

    if (d.promise.then) {
        // whenjs has the actual user promise in an attribute
        return d.promise;
    } else {
        return d;
    }
};

Session.prototype.unsubscribe = function (subscription) {

    util.assert(subscription instanceof Subscription, "Session.unsubscribe: <subscription> must be an instance of class autobahn.Subscription");

    var self = this;

    if (!self.isOpen) {
        throw "session not open";
    }

    if (!subscription.active || !(subscription.id in self._subscriptions)) {
        throw "subscription not active";
    }

    var subs = self._subscriptions[subscription.id];
    var i = subs.indexOf(subscription);

    if (i === -1) {
        throw "subscription not active";
    }

    // remove handler subscription
    subs.splice(i, 1);
    subscription.active = false;

    var d = self._defer();

    if (subs.length) {
        // there are still handlers on the subscription ..
        d.resolve(false);
    } else {

        // no handlers left ..

        // create and remember new UNSUBSCRIBE request
        //
        var request = newid();
        self._unsubscribe_reqs[request] = [d, subscription.id];

        // construct UNSUBSCRIBE message
        //
        var msg = [MSG_TYPE.UNSUBSCRIBE, request, subscription.id];

        // send WAMP message
        //
        self._send_wamp(msg);
    }

    if (d.promise.then) {
        // whenjs has the actual user promise in an attribute
        return d.promise;
    } else {
        return d;
    }
};

Session.prototype.register = function (procedure, endpoint, options) {

    util.assert(typeof procedure === 'string', "Session.register: <procedure> must be a string");
    util.assert(typeof endpoint === 'function', "Session.register: <endpoint> must be a function");
    util.assert(!options || options instanceof Object, "Session.register: <options> must be an object {}");

    var self = this;

    if (!self.isOpen) {
        throw "session not open";
    }

    // create an remember new REGISTER request
    //
    var request = newid();
    var d = self._defer();
    self._register_reqs[request] = [d, procedure, endpoint, options];

    // construct REGISTER message
    //
    var msg = [MSG_TYPE.REGISTER, request];
    if (options) {
        msg.push(options);
    } else {
        msg.push({});
    }
    msg.push(self.resolve(procedure));

    // send WAMP message
    //
    self._send_wamp(msg);

    if (d.promise.then) {
        // whenjs has the actual user promise in an attribute
        return d.promise;
    } else {
        return d;
    }
};

Session.prototype.unregister = function (registration) {

    util.assert(registration instanceof Registration, "Session.unregister: <registration> must be an instance of class autobahn.Registration");

    var self = this;

    if (!self.isOpen) {
        throw "session not open";
    }

    if (!registration.active || !(registration.id in self._registrations)) {
        throw "registration not active";
    }

    // create and remember new UNREGISTER request
    //
    var request = newid();
    var d = self._defer();
    self._unregister_reqs[request] = [d, registration];

    // construct UNREGISTER message
    //
    var msg = [MSG_TYPE.UNREGISTER, request, registration.id];

    // send WAMP message
    //
    self._send_wamp(msg);

    if (d.promise.then) {
        // whenjs has the actual user promise in an attribute
        return d.promise;
    } else {
        return d;
    }
};

Session.prototype.prefix = function (prefix, uri) {

    util.assert(typeof prefix === 'string', "Session.prefix: <prefix> must be a string");
    util.assert(!uri || typeof uri === 'string', "Session.prefix: <uri> must be a string or falsy");

    var self = this;

    if (uri) {
        self._prefixes[prefix] = uri;
    } else if (prefix in self._prefixes) {
        delete self._prefixes[prefix];
    }
};

Session.prototype.resolve = function (curie) {

    util.assert(typeof curie === 'string', "Session.resolve: <curie> must be a string");

    var self = this;

    // skip if not a CURIE
    var i = curie.indexOf(":");
    if (i >= 0) {
        var prefix = curie.substring(0, i);
        if (prefix in self._prefixes) {
            return self._prefixes[prefix] + '.' + curie.substring(i + 1);
        } else {
            throw "cannot resolve CURIE prefix '" + prefix + "'";
        }
    } else {
        return curie;
    }
};

exports.Session = Session;

exports.Invocation = Invocation;
exports.Event = Event;
exports.Result = Result;
exports.Error = Error;
exports.Subscription = Subscription;
exports.Registration = Registration;
exports.Publication = Publication;

/***/ }),

/***/ 14:
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ 17:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(37);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = Symbol;


/***/ }),

/***/ 178:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


///////////////////////////////////////////////////////////////////////////////
//
//  AutobahnJS - http://autobahn.ws, http://wamp.ws
//
//  A JavaScript library for WAMP ("The Web Application Messaging Protocol").
//
//  Copyright (C) 2011-2014 Tavendo GmbH, http://tavendo.com
//
//  Licensed under the MIT License.
//  http://www.opensource.org/licenses/mit-license.php
//
///////////////////////////////////////////////////////////////////////////////
/* eslint spaced-comment:0,vars-on-top:0,no-var:0,camelcase:0,func-names:0,one-var:0,one-var-declaration-per-line:0,eqeqeq:0,
no-multiple-empty-lines:0,prefer-rest-params:0,block-scoped-var:0,no-use-before-define:0,prefer-template:0,no-restricted-syntax:0,
no-debugger:0,padded-blocks:0,no-else-return:0,quotes:0,object-curly-spacing:0,semi:0,space-infix-ops:0,no-console:0,no-underscore-dangle:0,
no-throw-literal:0,no-unneeded-ternary:0,guard-for-in:0,space-before-function-paren:0 */
/* global AUTOBAHN_DEBUG:true */

function Transports() {
    this._repository = {};
}

Transports.prototype.register = function (name, factory) {
    this._repository[name] = factory;
};

Transports.prototype.isRegistered = function (name) {
    return this._repository[name] ? true : false;
};

Transports.prototype.get = function (name) {
    if (this._repository[name] !== undefined) {
        return this._repository[name];
    } else {
        throw "no such transport: " + name;
    }
};

Transports.prototype.list = function () {
    var items = [];
    for (var name in this._repository) {
        items.push(name);
    }
    return items;
};

var _transports = new Transports();

// register default transports
var websocket = __webpack_require__(181);
_transports.register("websocket", websocket.Factory);

var longpoll = __webpack_require__(180);
_transports.register("longpoll", longpoll.Factory);

exports.transports = _transports;

/***/ }),

/***/ 179:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


///////////////////////////////////////////////////////////////////////////////
//
//  AutobahnJS - http://autobahn.ws, http://wamp.ws
//
//  A JavaScript library for WAMP ("The Web Application Messaging Protocol").
//
//  Copyright (C) 2011-2014 Tavendo GmbH, http://tavendo.com
//
//  Licensed under the MIT License.
//  http://www.opensource.org/licenses/mit-license.php
//
///////////////////////////////////////////////////////////////////////////////
/* eslint spaced-comment:0,vars-on-top:0,no-var:0,camelcase:0,func-names:0,one-var:0,one-var-declaration-per-line:0,eqeqeq:0,
no-multiple-empty-lines:0,prefer-rest-params:0,block-scoped-var:0,no-use-before-define:0,prefer-template:0,no-restricted-syntax:0,
no-debugger:0,padded-blocks:0,no-else-return:0,quotes:0,object-curly-spacing:0,semi:0,space-infix-ops:0,no-console:0,no-underscore-dangle:0,
no-throw-literal:0,no-unneeded-ternary:0,guard-for-in:0,space-before-function-paren:0, new-cap:0,prefer-arrow-callback:0,comma-dangle:0,
no-multi-spaces:0,keyword-spacing:0,no-shadow:0,object-shorthand:0 */
/* global AUTOBAHN_DEBUG:true */

var session = __webpack_require__(121);
var util = __webpack_require__(60);
var autobahn = __webpack_require__(119);

var Connection = function Connection(options) {

    var self = this;

    self._options = options;

    // Deferred factory
    //

    // ES6-based deferred factory
    //
    self._defer = function () {
        var deferred = {};

        deferred.promise = new Promise(function (resolve, reject) {
            deferred.resolve = resolve;
            deferred.reject = reject;
        });

        return deferred;
    };

    // WAMP transport
    //
    // backward compatiblity
    if (!self._options.transports) {
        self._options.transports = [{
            type: 'websocket',
            url: self._options.url
        }];
    }
    self._transport_factories = [];
    self._init_transport_factories();

    // WAMP session
    //
    self._session = null;
    self._session_close_reason = null;
    self._session_close_message = null;

    // automatic reconnection configuration
    //

    // enable automatic reconnect if host is unreachable
    if (typeof self._options.retry_if_unreachable !== 'undefined') {
        self._retry_if_unreachable = self._options.retry_if_unreachable;
    } else {
        self._retry_if_unreachable = true;
    }

    // maximum number of reconnection attempts
    self._max_retries = typeof self._options.max_retries !== 'undefined' ? self._options.max_retries : -1;

    // initial retry delay in seconds
    self._initial_retry_delay = self._options.initial_retry_delay || 1.5;

    // maximum seconds between reconnection attempts
    self._max_retry_delay = self._options.max_retry_delay || 300;

    // the growth factor applied to the retry delay on each retry cycle
    self._retry_delay_growth = self._options.retry_delay_growth || 1.5;

    // the SD of a Gaussian to jitter the delay on each retry cycle
    // as a fraction of the mean
    self._retry_delay_jitter = self._options.retry_delay_jitter || 0.1;

    // reconnection tracking
    //

    // total number of successful connections
    self._connect_successes = 0;

    // controls if we should try to reconnect
    self._retry = false;

    // current number of reconnect cycles we went through
    self._retry_count = 0;

    // the current retry delay
    self._retry_delay = self._initial_retry_delay;

    // flag indicating if we are currently in a reconnect cycle
    self._is_retrying = false;

    // when retrying, this is the timer object returned from window.setTimeout()
    self._retry_timer = null;
};

Connection.prototype._create_transport = function () {
    var self = this;
    if (self._current_transport_index < 0 || self._current_transport_index > this._transport_factories.length - 1) {
        self._current_transport_index = 0;
    }

    for (var i = self._current_transport_index; i < this._transport_factories.length; ++i) {
        var transport_factory = this._transport_factories[i];
        try {
            var transport = transport_factory.create();
            if (transport) {
                return transport;
            }
        } catch (e) {
            // ignore
        }
    }

    // could not create any WAMP transport
    return null;
};

Connection.prototype._init_transport_factories = function () {
    // WAMP transport
    //
    var /* transports,*/transport_options, transport_factory, transport_factory_klass;

    util.assert(this._options.transports, "No transport.factory specified");
    //transports = this._options.transports;
    //if(typeof transports === "object") {
    //    this._options.transports = [transports];
    //}
    for (var i = 0; i < this._options.transports.length; ++i) {
        // cascading transports until we find one which works
        transport_options = this._options.transports[i];

        if (!transport_options.url) {
            // defaulting to options.url if none is provided
            transport_options.url = this._options.url;
        }
        if (!transport_options.serializers) {
            transport_options.serializers = this._options.serializers;
        }
        if (!transport_options.protocols) {
            transport_options.protocols = this._options.protocols;
        }
        util.assert(transport_options.type, "No transport.type specified");
        util.assert(typeof transport_options.type === "string", "transport.type must be a string");
        try {
            transport_factory_klass = autobahn.transports.get(transport_options.type);
            if (transport_factory_klass) {
                transport_factory = new transport_factory_klass(transport_options);
                this._transport_factories.push(transport_factory);
            }
        } catch (exc) {
            console.error(exc);
        }
    }
};

Connection.prototype._autoreconnect_reset_timer = function () {

    var self = this;

    if (self._retry_timer) {
        clearTimeout(self._retry_timer);
    }
    self._retry_timer = null;
};

Connection.prototype._autoreconnect_reset = function () {

    var self = this;

    self._autoreconnect_reset_timer();

    self._retry_count = 0;
    self._retry_delay = self._initial_retry_delay;
    self._is_retrying = false;
};

Connection.prototype._autoreconnect_advance = function () {

    var self = this;

    // jitter retry delay
    if (self._retry_delay_jitter) {
        self._retry_delay = util.rand_normal(self._retry_delay, self._retry_delay * self._retry_delay_jitter);
    }

    // cap the retry delay
    if (self._retry_delay > self._max_retry_delay) {
        self._retry_delay = self._max_retry_delay;
    }

    // count number of retries
    self._retry_count += 1;

    var res;
    if (self._retry && (self._max_retries === -1 || self._retry_count <= self._max_retries)) {
        res = {
            count: self._retry_count,
            delay: self._retry_delay,
            will_retry: true
        };
    } else {
        res = {
            count: null,
            delay: null,
            will_retry: false
        };
    }

    // retry delay growth for next retry cycle
    if (self._retry_delay_growth) {
        self._retry_delay = self._retry_delay * self._retry_delay_growth;
    }

    return res;
};

Connection.prototype.open = function () {

    var self = this;

    if (self._transport) {
        throw "connection already open (or opening)";
    }

    self._autoreconnect_reset();
    self._retry = true;
    self._current_transport_index = 0;

    function retry() {

        // create a WAMP transport
        self._transport = self._create_transport();

        if (!self._transport) {
            // failed to create a WAMP transport
            self._retry = false;
            if (self.onclose) {
                var details = {
                    reason: null,
                    message: null,
                    retry_delay: null,
                    retry_count: null,
                    will_retry: false
                };
                self.onclose("unsupported", details);
                self._current_transport_index++;
            }
            return;
        }

        // create a new WAMP session using the WebSocket connection as transport
        self._session = new session.Session(self._transport, self._defer, self._options.onchallenge);
        self._session_close_reason = null;
        self._session_close_message = null;

        self._transport.onopen = function () {

            // reset auto-reconnect timer and tracking
            self._autoreconnect_reset();

            // log successful connections
            self._connect_successes += 1;

            // start WAMP session
            self._session.join(self._options.realm, self._options.authmethods, self._options.authid);
        };

        self._session.onjoin = function (details) {
            if (self.onopen) {
                try {
                    self.onopen(self._session, details);
                } catch (e) {
                    //
                }
            }
        };

        //
        // ... WAMP session is now attached to realm.
        //

        self._session.onleave = function (reason, details) {
            self._session_close_reason = reason;
            self._session_close_message = details.message || "";
            self._retry = false;
            self._transport.close(1000);
        };

        self._transport.onclose = function (evt) {

            // remove any pending reconnect timer
            self._autoreconnect_reset_timer();

            self._transport = null;

            var reason = null;
            if (self._connect_successes === 0) {
                reason = "unreachable";
                self._current_transport_index++;
                if (!self._retry_if_unreachable) {
                    self._retry = false;
                }
            } else if (!evt.wasClean) {
                reason = "lost";
            } else {
                reason = "closed";
            }

            var next_retry = self._autoreconnect_advance();

            // fire app code handler
            //
            if (self.onclose) {
                var details = {
                    reason: self._session_close_reason,
                    message: self._session_close_message,
                    retry_delay: next_retry.delay,
                    retry_count: next_retry.count,
                    will_retry: next_retry.will_retry
                };
                try {
                    // Connection.onclose() allows to cancel any subsequent retry attempt
                    var stop_retrying = self.onclose(reason, details);
                } catch (e) {
                    //
                }
            }

            // reset session info
            //
            if (self._session) {
                self._session._id = null;
                self._session = null;
                self._session_close_reason = null;
                self._session_close_message = null;
            }

            // automatic reconnection
            //
            if (self._retry && !stop_retrying) {

                if (next_retry.will_retry) {

                    self._is_retrying = true;

                    self._retry_timer = setTimeout(retry, next_retry.delay * 1000);
                }
            }
        };
    }

    retry();
};

Connection.prototype.close = function (reason, message) {
    var self = this;

    if (!self._transport && !self._is_retrying) {
        throw "connection already closed";
    }

    // the app wants to close .. don't retry
    self._retry = false;

    if (self._session && self._session.isOpen) {
        // if there is an open session, close that first.
        self._session.leave(reason, message);
    } else if (self._transport && self._transport.close) {
        // no session active: just close the transport
        self._transport.close(1000);
    }
};

Object.defineProperty(Connection.prototype, "defer", {
    get: function get() {
        return this._defer;
    }
});

Object.defineProperty(Connection.prototype, "session", {
    get: function get() {
        return this._session;
    }
});

Object.defineProperty(Connection.prototype, "isOpen", {
    get: function get() {
        if (this._session && this._session.isOpen) {
            return true;
        } else {
            return false;
        }
    }
});

Object.defineProperty(Connection.prototype, "isConnected", {
    get: function get() {
        if (this._transport) {
            return true;
        } else {
            return false;
        }
    }
});

Object.defineProperty(Connection.prototype, "transport", {
    get: function get() {
        if (this._transport) {
            return this._transport;
        } else {
            return { info: { type: 'none', url: null, protocol: null } };
        }
    }
});

Object.defineProperty(Connection.prototype, "isRetrying", {
    get: function get() {
        return this._is_retrying;
    }
});

exports.Connection = Connection;

/***/ }),

/***/ 180:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

///////////////////////////////////////////////////////////////////////////////
//
//  AutobahnJS - http://autobahn.ws, http://wamp.ws
//
//  A JavaScript library for WAMP ('The Web Application Messaging Protocol').
//
//  Copyright (C) 2011-2014 Tavendo GmbH, http://tavendo.com
//
//  Licensed under the MIT License.
//  http://www.opensource.org/licenses/mit-license.php
//
///////////////////////////////////////////////////////////////////////////////
/* eslint spaced-comment:0,vars-on-top:0,no-var:0,camelcase:0,func-names:0,one-var:0,one-var-declaration-per-line:0,eqeqeq:0,
no-multiple-empty-lines:0,prefer-rest-params:0,block-scoped-var:0,no-use-before-define:0,prefer-template:0,no-restricted-syntax:0,
no-debugger:0,padded-blocks:0,no-else-return:0,quotes:0,object-curly-spacing:0,semi:0,space-infix-ops:0,no-console:0,no-underscore-dangle:0,
no-throw-literal:0,no-unneeded-ternary:0,guard-for-in:0,space-before-function-paren:0, new-cap:0,prefer-arrow-callback:0,comma-dangle:0,
no-multi-spaces:0,keyword-spacing:0,no-shadow:0,object-shorthand:0,global-require:0,no-inner-declarations:0,no-redeclare:0,
no-param-reassign:0,no-extra-semi:0,consistent-return:0,quote-props:0 */
/* global AUTOBAHN_DEBUG:true */
var util = __webpack_require__(60);

function Factory(options) {
    var self = this;

    util.assert(typeof options.url !== 'undefined', 'options.url missing');
    util.assert(typeof options.url === 'string', 'options.url must be a string');

    self._options = options;
};

Factory.prototype.type = 'longpoll';

Factory.prototype.create = function () {

    var self = this;

    // the WAMP transport we create
    var transport = {};

    // these will get overridden by the WAMP session using this transport
    transport.onmessage = function () {};
    transport.onopen = function () {};
    transport.onclose = function () {};

    transport.info = {
        type: 'longpoll',
        url: null,
        protocol: 'wamp.2.json'
    };

    transport._run = function () {

        var is_closing = false;
        var request_timeout = self._options.request_timeout || 30000; // timeout here > than the 10s default in Crossbar.io

        // Transport Closing
        var closeConnection = function closeConnection(code, reason, wasClean) {
            var details = { code: code, reason: reason, wasClean: wasClean };
            transport.onclose(details);
        };

        // Attempt to Connect First, allows ample room for the window to load properly
        setTimeout(function () {
            util.http_get_jsonp(self._options.url + '/api/connect?v=2&jsoncallback=%s', '%s', request_timeout).then(function (payload) {

                // Parse Connection Response
                var session_info = JSON.parse(payload);
                var session_id = (typeof session_info === 'undefined' ? 'undefined' : _typeof(session_info)) === _typeof([]) && session_info.length > 1 && session_info[0] === 0 && session_info[1];
                var base_url = self._options.url;

                // Check Valid Session
                if (!session_id) {
                    is_closing = true;
                    closeConnection(1001, 'transport connect failure (Invalid session ID received)', false);
                    return;
                }

                // WebAPI URL
                transport.info.url = base_url;

                // Closing
                transport.close = function () /* code, reason */{

                    if (is_closing) {
                        throw 'transport is already closing';
                    }

                    is_closing = true;
                    closeConnection(1000, 'transport closed', true);
                };

                // Sending Data
                transport.send = function (msg) {

                    if (is_closing) {
                        throw 'transport is closing or closed already';
                    }

                    var payload = JSON.stringify(msg);

                    util.http_post_json(base_url + '/api/send?sid=' + session_id, { message: payload }, request_timeout).then(function () {
                        // OK, Message Sent
                    }, function () {
                        is_closing = true;
                        closeConnection(1001, 'transport send failure (HTTP/POST probably timed out)', false);
                    });
                };

                // Receiving Data
                function receive() {

                    util.http_get_jsonp(base_url + '/api/messages?sid=' + session_id + '&jsoncallback=%s', '%s', request_timeout).then(function (payload) {
                        if (payload && payload.messages && payload.messages.length) {
                            for (var i = 0; i < payload.messages.length; i++) {
                                transport.onmessage(JSON.parse(payload.messages[i]));
                            }
                        }

                        if (!is_closing) {
                            receive();
                        }
                    }, function () {
                        is_closing = true;
                        closeConnection(1001, 'transport receive failure (HTTP/GET probably timed out)', false);
                    });
                }

                // Start Receiving Data
                receive();

                // Announce Transport Opening
                transport.onopen();

                // Connection Error
            }, function () {
                is_closing = true;
                closeConnection(1001, 'transport open failure (HTTP/GET request failed or timed out)', false);
            });
        }, 60);
    };

    transport._run();
    return transport;
};

exports.Factory = Factory;

/***/ }),

/***/ 181:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

///////////////////////////////////////////////////////////////////////////////
//
//  AutobahnJS - http://autobahn.ws, http://wamp.ws
//
//  A JavaScript library for WAMP ("The Web Application Messaging Protocol").
//
//  Copyright (C) 2011-2014 Tavendo GmbH, http://tavendo.com
//
//  Licensed under the MIT License.
//  http://www.opensource.org/licenses/mit-license.php
//
///////////////////////////////////////////////////////////////////////////////

/* eslint spaced-comment:0,vars-on-top:0,no-var:0,camelcase:0,func-names:0,one-var:0,one-var-declaration-per-line:0,eqeqeq:0,
no-multiple-empty-lines:0,prefer-rest-params:0,block-scoped-var:0,no-use-before-define:0,prefer-template:0,no-restricted-syntax:0,
no-debugger:0,padded-blocks:0,no-else-return:0,quotes:0,object-curly-spacing:0,semi:0,space-infix-ops:0,no-console:0,no-underscore-dangle:0,
no-throw-literal:0,no-unneeded-ternary:0,guard-for-in:0,space-before-function-paren:0, new-cap:0,prefer-arrow-callback:0,comma-dangle:0,
no-multi-spaces:0,keyword-spacing:0,no-shadow:0,object-shorthand:0,global-require:0,no-inner-declarations:0,no-redeclare:0,
no-param-reassign:0,no-extra-semi:0,consistent-return:0,wrap-iife:0 */
/* global AUTOBAHN_DEBUG:true */

var util = __webpack_require__(60);
var serializer = __webpack_require__(120);

function Factory(options) {
    var self = this;

    util.assert(typeof options.url !== 'undefined', "options.url missing");
    util.assert(typeof options.url === "string", "options.url must be a string");

    if (!options.serializers) {
        options.serializers = [new serializer.JSONSerializer()];
    } else {
        util.assert(Array.isArray(options.serializers), "options.serializers must be an array");
    }

    if (!options.protocols) {
        options.protocols = [];
        options.serializers.forEach(function (ser) {
            options.protocols.push("wamp.2." + ser.SERIALIZER_ID);
        });
    } else {
        util.assert(Array.isArray(options.protocols), "options.protocols must be an array");
    }

    self._options = options;
}

Factory.prototype.type = "websocket";

Factory.prototype.create = function () {

    var self = this;

    // the WAMP transport we create
    var transport = {};

    // these will get overridden by the WAMP session using this transport
    transport.onmessage = function () {};
    transport.onopen = function () {};
    transport.onclose = function () {};

    transport.info = {
        type: 'websocket',
        url: self._options.url,
        protocol: null
    };

    //
    // running in the browser
    //
    (function () {

        var websocket;

        // Chrome, MSIE, newer Firefox
        if ("WebSocket" in window) {

            if (self._options.protocols) {
                websocket = new global.WebSocket(self._options.url, self._options.protocols);
            } else {
                websocket = new global.WebSocket(self._options.url);
            }
            websocket.binaryType = 'arraybuffer';

            // older versions of Firefox prefix the WebSocket object
        } else if ("MozWebSocket" in window) {

            if (self._options.protocols) {
                websocket = new global.MozWebSocket(self._options.url, self._options.protocols);
            } else {
                websocket = new global.MozWebSocket(self._options.url);
            }
        } else {
            throw "browser does not support WebSocket or WebSocket in Web workers";
        }

        websocket.onmessage = function (evt) {

            var msg = transport.serializer.unserialize(evt.data);
            transport.onmessage(msg);
        };

        websocket.onopen = function () {
            var serializer_part = websocket.protocol.split('.')[2];
            for (var index in self._options.serializers) {
                var serializer = self._options.serializers[index];
                if (serializer.SERIALIZER_ID == serializer_part) {
                    transport.serializer = serializer;
                    break;
                }
            }

            transport.info.protocol = websocket.protocol;
            transport.onopen();
        };

        websocket.onclose = function (evt) {
            var details = {
                code: evt.code,
                reason: evt.message,
                wasClean: evt.wasClean
            };
            transport.onclose(details);
        };

        // do NOT do the following, since that will make
        // transport.onclose() fire twice (browsers already fire
        // websocket.onclose() for errors also)
        //websocket.onerror = websocket.onclose;

        transport.send = function (msg) {
            var payload = transport.serializer.serialize(msg);
            websocket.send(payload);
        };

        transport.close = function (code, reason) {
            websocket.close(code, reason);
        };
    })();

    return transport;
};

exports.Factory = Factory;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),

/***/ 19:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  var last = funcs[funcs.length - 1];
  var rest = funcs.slice(0, -1);
  return function () {
    return rest.reduceRight(function (composed, f) {
      return f(composed);
    }, last.apply(undefined, arguments));
  };
}

/***/ }),

/***/ 198:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, setImmediate) {var __WEBPACK_AMD_DEFINE_RESULT__;(function(global){

//
// Check for native Promise and it has correct interface
//

var NativePromise = global['Promise'];
var nativePromiseSupported =
  NativePromise &&
  // Some of these methods are missing from
  // Firefox/Chrome experimental implementations
  'resolve' in NativePromise &&
  'reject' in NativePromise &&
  'all' in NativePromise &&
  'race' in NativePromise &&
  // Older version of the spec had a resolver object
  // as the arg rather than a function
  (function(){
    var resolve;
    new NativePromise(function(r){ resolve = r; });
    return typeof resolve === 'function';
  })();


//
// export if necessary
//

if (typeof exports !== 'undefined' && exports)
{
  // node.js
  exports.Promise = nativePromiseSupported ? NativePromise : Promise;
  exports.Polyfill = Promise;
}
else
{
  // AMD
  if (true)
  {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function(){
      return nativePromiseSupported ? NativePromise : Promise;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  else
  {
    // in browser add to global
    if (!nativePromiseSupported)
      global['Promise'] = Promise;
  }
}


//
// Polyfill
//

var PENDING = 'pending';
var SEALED = 'sealed';
var FULFILLED = 'fulfilled';
var REJECTED = 'rejected';
var NOOP = function(){};

function isArray(value) {
  return Object.prototype.toString.call(value) === '[object Array]';
}

// async calls
var asyncSetTimer = typeof setImmediate !== 'undefined' ? setImmediate : setTimeout;
var asyncQueue = [];
var asyncTimer;

function asyncFlush(){
  // run promise callbacks
  for (var i = 0; i < asyncQueue.length; i++)
    asyncQueue[i][0](asyncQueue[i][1]);

  // reset async asyncQueue
  asyncQueue = [];
  asyncTimer = false;
}

function asyncCall(callback, arg){
  asyncQueue.push([callback, arg]);

  if (!asyncTimer)
  {
    asyncTimer = true;
    asyncSetTimer(asyncFlush, 0);
  }
}


function invokeResolver(resolver, promise) {
  function resolvePromise(value) {
    resolve(promise, value);
  }

  function rejectPromise(reason) {
    reject(promise, reason);
  }

  try {
    resolver(resolvePromise, rejectPromise);
  } catch(e) {
    rejectPromise(e);
  }
}

function invokeCallback(subscriber){
  var owner = subscriber.owner;
  var settled = owner.state_;
  var value = owner.data_;  
  var callback = subscriber[settled];
  var promise = subscriber.then;

  if (typeof callback === 'function')
  {
    settled = FULFILLED;
    try {
      value = callback(value);
    } catch(e) {
      reject(promise, e);
    }
  }

  if (!handleThenable(promise, value))
  {
    if (settled === FULFILLED)
      resolve(promise, value);

    if (settled === REJECTED)
      reject(promise, value);
  }
}

function handleThenable(promise, value) {
  var resolved;

  try {
    if (promise === value)
      throw new TypeError('A promises callback cannot return that same promise.');

    if (value && (typeof value === 'function' || typeof value === 'object'))
    {
      var then = value.then;  // then should be retrived only once

      if (typeof then === 'function')
      {
        then.call(value, function(val){
          if (!resolved)
          {
            resolved = true;

            if (value !== val)
              resolve(promise, val);
            else
              fulfill(promise, val);
          }
        }, function(reason){
          if (!resolved)
          {
            resolved = true;

            reject(promise, reason);
          }
        });

        return true;
      }
    }
  } catch (e) {
    if (!resolved)
      reject(promise, e);

    return true;
  }

  return false;
}

function resolve(promise, value){
  if (promise === value || !handleThenable(promise, value))
    fulfill(promise, value);
}

function fulfill(promise, value){
  if (promise.state_ === PENDING)
  {
    promise.state_ = SEALED;
    promise.data_ = value;

    asyncCall(publishFulfillment, promise);
  }
}

function reject(promise, reason){
  if (promise.state_ === PENDING)
  {
    promise.state_ = SEALED;
    promise.data_ = reason;

    asyncCall(publishRejection, promise);
  }
}

function publish(promise) {
  var callbacks = promise.then_;
  promise.then_ = undefined;

  for (var i = 0; i < callbacks.length; i++) {
    invokeCallback(callbacks[i]);
  }
}

function publishFulfillment(promise){
  promise.state_ = FULFILLED;
  publish(promise);
}

function publishRejection(promise){
  promise.state_ = REJECTED;
  publish(promise);
}

/**
* @class
*/
function Promise(resolver){
  if (typeof resolver !== 'function')
    throw new TypeError('Promise constructor takes a function argument');

  if (this instanceof Promise === false)
    throw new TypeError('Failed to construct \'Promise\': Please use the \'new\' operator, this object constructor cannot be called as a function.');

  this.then_ = [];

  invokeResolver(resolver, this);
}

Promise.prototype = {
  constructor: Promise,

  state_: PENDING,
  then_: null,
  data_: undefined,

  then: function(onFulfillment, onRejection){
    var subscriber = {
      owner: this,
      then: new this.constructor(NOOP),
      fulfilled: onFulfillment,
      rejected: onRejection
    };

    if (this.state_ === FULFILLED || this.state_ === REJECTED)
    {
      // already resolved, call callback async
      asyncCall(invokeCallback, subscriber);
    }
    else
    {
      // subscribe
      this.then_.push(subscriber);
    }

    return subscriber.then;
  },

  'catch': function(onRejection) {
    return this.then(null, onRejection);
  }
};

Promise.all = function(promises){
  var Class = this;

  if (!isArray(promises))
    throw new TypeError('You must pass an array to Promise.all().');

  return new Class(function(resolve, reject){
    var results = [];
    var remaining = 0;

    function resolver(index){
      remaining++;
      return function(value){
        results[index] = value;
        if (!--remaining)
          resolve(results);
      };
    }

    for (var i = 0, promise; i < promises.length; i++)
    {
      promise = promises[i];

      if (promise && typeof promise.then === 'function')
        promise.then(resolver(i), reject);
      else
        results[i] = promise;
    }

    if (!remaining)
      resolve(results);
  });
};

Promise.race = function(promises){
  var Class = this;

  if (!isArray(promises))
    throw new TypeError('You must pass an array to Promise.race().');

  return new Class(function(resolve, reject) {
    for (var i = 0, promise; i < promises.length; i++)
    {
      promise = promises[i];

      if (promise && typeof promise.then === 'function')
        promise.then(resolve, reject);
      else
        resolve(promise);
    }
  });
};

Promise.resolve = function(value){
  var Class = this;

  if (value && typeof value === 'object' && value.constructor === Class)
    return value;

  return new Class(function(resolve){
    resolve(value);
  });
};

Promise.reject = function(reason){
  var Class = this;

  return new Class(function(resolve, reject){
    reject(reason);
  });
};

})(typeof window != 'undefined' ? window : typeof global != 'undefined' ? global : typeof self != 'undefined' ? self : this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14), __webpack_require__(227).setImmediate))

/***/ }),

/***/ 20:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable__ = __webpack_require__(42);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ActionTypes; });
/* harmony export (immutable) */ __webpack_exports__["a"] = createStore;



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'
};

/**
 * Creates a Redux store that holds the state tree.
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} enhancer The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */
function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      listeners[i]();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/zenparsing/es-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["a" /* default */]] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["a" /* default */]] = observable, _ref2;
}

/***/ }),

/***/ 21:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),

/***/ 213:
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ 226:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14), __webpack_require__(213)))

/***/ }),

/***/ 227:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(226);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(14)))

/***/ }),

/***/ 228:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.configConst = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.setConfig = setConfig;

var _reactAddonsUpdate = __webpack_require__(27);

var _reactAddonsUpdate2 = _interopRequireDefault(_reactAddonsUpdate);

var _store = __webpack_require__(89);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Constants
 */
var configConst = exports.configConst = {
  STORE_PART: 'omfe-core-data:config',

  SET_CONFIG_ACTION: 'OMFE_CORE_DATA_UPDATE_CONFIG_ACTION'
};

/**
 * Store Part with Initial Config
 */
(0, _store.addStorePart)(configConst.STORE_PART, {});

/**
 * Reducers
 */
(0, _store.addReducer)(configConst.STORE_PART, configConst.SET_CONFIG_ACTION, function () {
  var prevState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  return (0, _reactAddonsUpdate2.default)(prevState, { $merge: action.config });
});

/**
 * setConfig - Update Config (action creator)
 * - updates application configuration
 * - performs shallow merge on store config sub-object
 *
 * @param  {obj}  config        new configuration
 * @return {obj}                action
 */
function setConfig() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return ((typeof config === 'undefined' ? 'undefined' : _typeof(config)) !== 'object' || config === null) && { type: 'NONE_' + Date.now() } || {
    type: configConst.SET_CONFIG_ACTION,
    config: config
  };
}

/**
 * Inherits Defaults From Global OMFECONFIG Variable
 */
/* global OMFECONFIG: true */
_store.store.dispatch(setConfig((typeof OMFECONFIG === 'undefined' ? 'undefined' : _typeof(OMFECONFIG)) === 'object' && OMFECONFIG !== null && OMFECONFIG || {}));

/***/ }),

/***/ 229:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.onRx = exports.onTx = exports.api = undefined;

var _txRx = __webpack_require__(328);

Object.defineProperty(exports, 'onTx', {
    enumerable: true,
    get: function get() {
        return _txRx.onTx;
    }
});
Object.defineProperty(exports, 'onRx', {
    enumerable: true,
    get: function get() {
        return _txRx.onRx;
    }
});

var _store = __webpack_require__(89);

var _configManager = __webpack_require__(228);

var _connection = __webpack_require__(71);

var _connection2 = __webpack_require__(327);

var _api = __webpack_require__(326);

var _api2 = _interopRequireDefault(_api);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Defaults
var connectionDefaults = {
    webapiEndpoint: 'wss://sports-banner.everymatrix.com/v2',
    webapiFallbackEndpoint: 'https://sports-banner.everymatrix.com/longpoll',
    webapiDomain: ''
};

// Set Default Connection Settings


/**
 * Connection
 */
(function () {
    var currentState = _store.store.getState()[_configManager.configConst.STORE_PART];

    var _Object$assign = Object.assign({}, connectionDefaults, currentState),
        webapiEndpoint = _Object$assign.webapiEndpoint,
        webapiFallbackEndpoint = _Object$assign.webapiFallbackEndpoint,
        webapiDomain = _Object$assign.webapiDomain;

    if (webapiEndpoint !== currentState.webapiEndpoint || webapiFallbackEndpoint !== currentState.webapiFallbackEndpoint || webapiDomain !== currentState.webapiDomain) {
        _store.store.dispatch((0, _configManager.setConfig)({ webapiEndpoint: webapiEndpoint, webapiFallbackEndpoint: webapiFallbackEndpoint, webapiDomain: webapiDomain }));
    }
    (0, _connection2.setDefaultConnectionSettings)(webapiEndpoint, webapiFallbackEndpoint, webapiDomain);
})();

// React To Configuration Changes
_store.store.subscribe(function () {
    var _store$getState$confi = _store.store.getState()[_configManager.configConst.STORE_PART],
        webapiEndpoint = _store$getState$confi.webapiEndpoint,
        webapiFallbackEndpoint = _store$getState$confi.webapiFallbackEndpoint,
        webapiDomain = _store$getState$confi.webapiDomain;

    (0, _connection2.updateConnectionSettings)(webapiEndpoint, webapiFallbackEndpoint, webapiDomain);
});

/**
 * Enhanced Web API
 */
exports.api = _api2.default;


/**
 * OperatorInfo
 */
var operatorInfoCallId = '';
function performOperatorInfoRequest() {
    operatorInfoCallId = _api2.default.createClientRequestId();
    _api2.default.requestOperatorInfo({
        clientRequestId: operatorInfoCallId,
        onSuccess: function onSuccess(operatorInfo) {
            return _store.store.dispatch((0, _configManager.setConfig)({ operatorInfo: operatorInfo }));
        }
    });
}

if ((0, _connection.isConnected)()) {
    performOperatorInfoRequest();
}

(0, _connection.onConnect)(performOperatorInfoRequest);
(0, _connection.onDisconnect)(function () {
    _api2.default.cancelOperatorInfoRequest(operatorInfoCallId);
    //clear OperatorInfo
    _store.store.dispatch((0, _configManager.setConfig)({ operatorInfo: undefined }));
});

/***/ }),

/***/ 27:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(87);

/***/ }),

/***/ 295:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _configManager = __webpack_require__(228);

Object.defineProperty(exports, 'configConst', {
  enumerable: true,
  get: function get() {
    return _configManager.configConst;
  }
});
Object.defineProperty(exports, 'setConfig', {
  enumerable: true,
  get: function get() {
    return _configManager.setConfig;
  }
});

var _store = __webpack_require__(89);

Object.defineProperty(exports, 'storeConst', {
  enumerable: true,
  get: function get() {
    return _store.storeConst;
  }
});
Object.defineProperty(exports, 'getReducersFor', {
  enumerable: true,
  get: function get() {
    return _store.getReducersFor;
  }
});
Object.defineProperty(exports, 'addReducer', {
  enumerable: true,
  get: function get() {
    return _store.addReducer;
  }
});
Object.defineProperty(exports, 'getMiddlewares', {
  enumerable: true,
  get: function get() {
    return _store.getMiddlewares;
  }
});
Object.defineProperty(exports, 'addMiddleware', {
  enumerable: true,
  get: function get() {
    return _store.addMiddleware;
  }
});
Object.defineProperty(exports, 'addStorePart', {
  enumerable: true,
  get: function get() {
    return _store.addStorePart;
  }
});
Object.defineProperty(exports, 'store', {
  enumerable: true,
  get: function get() {
    return _store.store;
  }
});

var _storage = __webpack_require__(330);

Object.defineProperty(exports, 'storageConst', {
  enumerable: true,
  get: function get() {
    return _storage.storageConst;
  }
});
Object.defineProperty(exports, 'saveLocalItem', {
  enumerable: true,
  get: function get() {
    return _storage.saveLocalItem;
  }
});
Object.defineProperty(exports, 'saveSessionItem', {
  enumerable: true,
  get: function get() {
    return _storage.saveSessionItem;
  }
});
Object.defineProperty(exports, 'removeItem', {
  enumerable: true,
  get: function get() {
    return _storage.removeItem;
  }
});

var _jsonp = __webpack_require__(329);

Object.defineProperty(exports, 'jsonpConst', {
  enumerable: true,
  get: function get() {
    return _jsonp.jsonpConst;
  }
});
Object.defineProperty(exports, 'jsonpCall', {
  enumerable: true,
  get: function get() {
    return _jsonp.jsonpCall;
  }
});
Object.defineProperty(exports, 'jsonpSubscribe', {
  enumerable: true,
  get: function get() {
    return _jsonp.jsonpSubscribe;
  }
});
Object.defineProperty(exports, 'jsonpUnsubscribe', {
  enumerable: true,
  get: function get() {
    return _jsonp.jsonpUnsubscribe;
  }
});

var _webapi = __webpack_require__(229);

Object.defineProperty(exports, 'api', {
  enumerable: true,
  get: function get() {
    return _webapi.api;
  }
});
Object.defineProperty(exports, 'onTx', {
  enumerable: true,
  get: function get() {
    return _webapi.onTx;
  }
});
Object.defineProperty(exports, 'onRx', {
  enumerable: true,
  get: function get() {
    return _webapi.onRx;
  }
});

var _vendors = __webpack_require__(331);

Object.defineProperty(exports, 'moment', {
  enumerable: true,
  get: function get() {
    return _vendors.moment;
  }
});
Object.defineProperty(exports, 'userTimezone', {
  enumerable: true,
  get: function get() {
    return _vendors.userTimezone;
  }
});

var _dataManager = __webpack_require__(309);

Object.defineProperty(exports, 'DataManager', {
  enumerable: true,
  get: function get() {
    return _dataManager.DataManager;
  }
});
Object.defineProperty(exports, 'dataConst', {
  enumerable: true,
  get: function get() {
    return _dataManager.dataConst;
  }
});

/***/ }),

/***/ 309:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.DataManager = exports.dataConst = undefined;

var _class, _temp; // @FIXME: this needs to blend with the API in a better way, for example this.dm.subscribeToMatch


var _reactAddonsUpdate = __webpack_require__(27);

var _reactAddonsUpdate2 = _interopRequireDefault(_reactAddonsUpdate);

var _store = __webpack_require__(89);

var _webapi = __webpack_require__(229);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Constants
 */
var dataConst = exports.dataConst = {
    STORE_PART: 'omfe-core-data:data',

    CREATE_DATA_MANAGER_COMPONENT: 'OMFE_DATA_MANAGER-CREATE_DATA_MANAGER_COMPONENT-ACTION',
    DESTROY_DATA_MANAGER_COMPONENT: 'OMFE_DATA_MANAGER-DESTROY_DATA_MANAGER_COMPONENT-ACTION',

    SUBSCRIPTION_UPDATE: 'OMFE_DATA_MANAGER-SUBSCRIPTION-UPDATE-ACTION',
    SUBSCRIPTION_DELETE: 'OMFE_DATA_MANAGER-SUBSCRIPTION-DELETE-ACTION'
};

/**
 * Store part
 */
(0, _store.addStorePart)(dataConst.STORE_PART, {});

/**
 * Reducers
 */

// Creating a new Component
(0, _store.addReducer)(dataConst.STORE_PART, dataConst.CREATE_DATA_MANAGER_COMPONENT, function (state, action) {
    if (!action.uuid) {
        return state;
    }
    var newState = Object.assign({}, state);
    newState[action.uuid] = {};
    return newState;
});

// Destroying an existing component
(0, _store.addReducer)(dataConst.STORE_PART, dataConst.DESTROY_DATA_MANAGER_COMPONENT, function (state, action) {
    if (!action.uuid) {
        return state;
    }
    var newState = Object.assign({}, state);
    delete newState[action.uuid];
    return newState;
});

// Data Updates
(0, _store.addReducer)(dataConst.STORE_PART, dataConst.SUBSCRIPTION_UPDATE, function (state, action) {
    var uuid = action.uuid,
        storeSubPart = action.storeSubPart,
        isLoaded = action.isLoaded,
        data = action.data;

    if (!uuid || !storeSubPart || !state[uuid]) {
        return state;
    }

    //let newState = Object.assign({}, state); //na
    var newState = Object.assign({}, state); // sm
    newState[uuid] = Object.assign({}, newState[uuid] || {}); //sm

    // loading state updates
    newState[uuid].isLoaded = Object.assign({}, newState[uuid].isLoaded || {}); //sv
    if (typeof isLoaded !== 'undefined') {
        newState[uuid].isLoaded[storeSubPart] = isLoaded;
    }

    // data updates
    newState[uuid][storeSubPart] = newState[uuid][storeSubPart] || {};
    if (typeof data !== 'undefined') {
        // newState[uuid][storeSubPart] = data && data.version && data.records && Object.assign({}, data.records) || Object.assign({}, data);//sv
        var records = data && data.records || [];
        // newState[uuid][storeSubPart] = {
        //     version: data.version,
        //     records : [...records]
        // };
        newState[uuid][storeSubPart] = records && [].concat(records) || data || {};
        // newState = update(newState, {
        //     [uuid]: {
        //         [storeSubPart]: {
        //             $merge: data && data.version && data.records || data || {},
        //         }
        //     },
        // });
    }

    // @TODO: errors management - when do we delete errors automatically, and based on what

    // done
    return newState;
});

// Data clearing
(0, _store.addReducer)(dataConst.STORE_PART, dataConst.SUBSCRIPTION_DELETE, function (state, action) {
    var uuid = action.uuid,
        storeSubPart = action.storeSubPart;

    if (!uuid || !storeSubPart || !state[uuid] || !state[uuid][storeSubPart]) {
        return state;
    }
    var newState = Object.assign({}, state);
    newState[uuid] = Object.assign({}, newState[uuid] || {}); //sm

    delete newState[uuid][storeSubPart];
    delete newState[uuid].isLoaded[storeSubPart];

    return newState;
});

/**
 * Middlewares-free Data Management Class Around OMFE WebAPI
 * - tracks uuids as individual store parts for components
 * - tracks subscriptions
 * - moves data and errors in the store part for components
 * - keeps loading states in sync with calls/subscriptions
 */
var DataManager = exports.DataManager = (_temp = _class = function () {

    // Create a new component
    function DataManager(uuid) {
        _classCallCheck(this, DataManager);

        this.uuid = uuid;
        this.subscriptions = {};

        _store.store.dispatch({ type: dataConst.CREATE_DATA_MANAGER_COMPONENT, uuid: uuid });
    }

    // Performing subscriptions


    DataManager.prototype.sub = function sub() {
        var storeSubPart = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

        var _this = this;

        var subMethodName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

        // Reserved store part name
        if (!storeSubPart || DataManager.reservedStoreSubPartNames[storeSubPart]) {
            throw new Error('Invalid storeSubPart supplied, \'' + storeSubPart + '\' is reserved');
        }

        // Store part name already in use
        if (this.subscriptions[storeSubPart]) {
            throw new Error('Invalid storeSubPart supplied, \'' + storeSubPart + '\' already exists');
        }

        // Invalid API method name
        if (!subMethodName || !_webapi.api[subMethodName]) {
            throw new Error('Invalid subscription method name, no such method \'' + subMethodName + '\'');
        }

        // save 'subscribed' state
        this.subscriptions[storeSubPart] = true;

        // perform subscription
        _webapi.api[subMethodName]({
            clientRequestId: this.uuid + '-' + storeSubPart,
            params: params,
            onPending: function onPending() {
                return _store.store.dispatch({
                    type: dataConst.SUBSCRIPTION_UPDATE,
                    uuid: _this.uuid,
                    storeSubPart: storeSubPart,
                    isLoaded: false,
                    data: {}
                });
            },
            onCompletion: function onCompletion() {
                return _store.store.dispatch({
                    type: dataConst.SUBSCRIPTION_UPDATE,
                    uuid: _this.uuid,
                    storeSubPart: storeSubPart,
                    isLoaded: true
                });
            },
            onUpdate: function onUpdate(data) {
                return _store.store.dispatch({
                    type: dataConst.SUBSCRIPTION_UPDATE,
                    uuid: _this.uuid,
                    storeSubPart: storeSubPart,
                    data: data
                });
            },
            onError: function onError(errors) {
                return _store.store.dispatch({
                    type: dataConst.SUBSCRIPTION_UPDATE,
                    uuid: _this.uuid,
                    storeSubPart: storeSubPart,
                    errors: errors
                });
            }
        });
    };

    DataManager.prototype.unsub = function unsub() {
        var storeSubPart = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        var unsubMethodName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

        // Store part name not already in use
        if (!this.subscriptions[storeSubPart]) {
            return false;
        }

        // Invalid API method name
        if (!unsubMethodName || !_webapi.api[unsubMethodName]) {
            throw new Error('Invalid subscription method name, no such method \'' + unsubMethodName + '\'');
        }

        // delete 'subscribed' state
        delete this.subscriptions[storeSubPart];

        // perform unsubscribe
        _webapi.api[unsubMethodName](this.uuid + '-' + storeSubPart);

        // dispatch deletion action
        return _store.store.dispatch({ type: dataConst.SUBSCRIPTION_DELETE, uuid: this.uuid, storeSubPart: storeSubPart });
    };

    // Destroying


    DataManager.prototype.done = function done() {
        _store.store.dispatch({ type: dataConst.DESTROY_DATA_MANAGER_COMPONENT, uuid: this.uuid });
    };

    return DataManager;
}(), _class.reservedStoreSubPartNames = {
    isLoaded: true,
    errors: true }, _temp);

/***/ }),

/***/ 31:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(35);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = baseGetTag;


/***/ }),

/***/ 310:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _connection = __webpack_require__(71);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Main Subscribers - Turns subscribers into actual subscriptions
 */
var SubscriberProcessor = function () {
    /**
     * Ctor
     */
    function SubscriberProcessor() {
        var _this = this;

        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _classCallCheck(this, SubscriberProcessor);

        // Save passed options
        this.options = options;

        // Subscribers List
        this.subscribersByTopic = {};

        // Subscriptions List
        this.activeSubscriptions = {};

        // Process on Connect / Disconnect
        (0, _connection.onConnect)(function () {
            return _this.processSubscribers();
        });
        (0, _connection.onDisconnect)(function () {
            return _this.processSubscribers();
        });

        // Next Retry
        this.retryAfterInterval = setInterval(function () {
            return _this.processSubscribers();
        }, options.retryAfter);

        // Function to Call Each Time Subscriptions List Updates
        this.onSubscriptionsUpdate = function (activeSubscriptions) {
            return activeSubscriptions;
        };

        // Subscribers processing thread
        this.subscriptionsHaveChanged = false;
        setInterval(function () {
            if (_this.subscriptionsHaveChanged) {
                _this.processSubscriptionData();
                _this.processSubscribers();
                _this.onSubscriptionsUpdate(_this.activeSubscriptions);
                _this.subscriptionsHaveChanged = false;
            }
        }, options.subscribersProcessingFrequency);
    }

    /**
     * updateSubscribers - update the internal subscribers list, based on which actual subscriptions are updated
     */


    SubscriberProcessor.prototype.updateSubscribers = function updateSubscribers(subscribersByTopic) {
        this.subscribersByTopic = subscribersByTopic;
        this.subscriptionsHaveChanged = true;
    };

    /**
     * processSubscribers
     * - turn subscribers into subscriptions, unsub subscriptions that are no longer in use
     * - only updates activeSubscriptions, reacts to subscribersByTopic
     */


    SubscriberProcessor.prototype.processSubscribers = function processSubscribers() {
        var _this2 = this;

        // Relevant Props
        var options = this.options,
            subscribersByTopic = this.subscribersByTopic,
            activeSubscriptions = this.activeSubscriptions;

        // No processing if disconnected, void activeSubscriptions

        var session = (0, _connection.getSession)();
        if (!session) {
            this.activeSubscriptions = {};
            this.subscriptionsHaveChanged = true;
            return;
        }

        // Relevant Opts
        var validateInitialDump = options.validateInitialDump,
            isErrorInitialDump = options.isErrorInitialDump,
            parseInitialDump = options.parseInitialDump,
            validateUpdate = options.validateUpdate,
            isErrorUpdate = options.isErrorUpdate,
            parseUpdate = options.parseUpdate,
            isSubscriptionError = options.isSubscriptionError,
            mergeUpdates = options.mergeUpdates,
            uniqueKey = options.uniqueKey,
            initialDumpEndpoint = options.initialDumpEndpoint,
            unregisterEndpoint = options.unregisterEndpoint,
            retryAfter = options.retryAfter;


        var now = Date.now();

        // Register Topics for Subscribers Without a Topic

        var _loop = function _loop() {
            if (_isArray) {
                if (_i >= _iterator.length) return 'break';
                _ref = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) return 'break';
                _ref = _i.value;
            }

            var topic = _ref;

            if (!activeSubscriptions[topic] || activeSubscriptions[topic] && activeSubscriptions[topic].nextRetry !== false && activeSubscriptions[topic].nextRetry < now && !activeSubscriptions[topic].isBusy) {
                // overwrite existing subscription
                activeSubscriptions[topic] = {
                    registration: null,
                    topic: topic,

                    currentState: null,
                    pendingUpdates: [],
                    pendingErrors: [],

                    acceptsUpdates: false, // means we can't push updates to pendingUpdates
                    suppliesData: false, // whether this subscription is an active data supplier; will otherwise not be processed
                    isBusy: true, // means register/unregister operations are locked

                    nextRetry: false
                };

                _this2.subscriptionsHaveChanged = true;

                // we can now perform the registration
                session.register(topic, function (args, kwargs, details) {
                    var response = { args: args, kwargs: kwargs, details: details };
                    // Updates Handler
                    if (activeSubscriptions[topic] && activeSubscriptions[topic].acceptsUpdates) {
                        if (!validateUpdate(response, uniqueKey)) {
                            if (isErrorUpdate(response, uniqueKey)) {
                                activeSubscriptions[topic].pendingErrors.push(response);
                                _this2.subscriptionsHaveChanged = true;
                            } else {
                                throw new Error('Subscription update validation failed for ' + topic + '.\n                                    This is very likely to be the result of a breaking change in the API');
                            }
                        } else {
                            if (!activeSubscriptions[topic].suppliesData) {
                                activeSubscriptions[topic].pendingUpdates.push(parseUpdate(response, uniqueKey));
                            } else {
                                activeSubscriptions[topic].currentState = mergeUpdates(activeSubscriptions[topic].currentState, [parseUpdate(response, uniqueKey)], uniqueKey);
                            }
                            _this2.subscriptionsHaveChanged = true;
                        }
                    }
                    return new Promise(function (resolve) {
                        return resolve('');
                    });
                }, {}).then(function (registration) {
                    // Registration Successful - save it; we now accept updates - but activeSubscription is still busy
                    activeSubscriptions[topic].registration = registration;
                    activeSubscriptions[topic].acceptsUpdates = true;
                    _this2.subscriptionsHaveChanged = true;

                    // Registration Ditching Mechanism
                    var ditchRegistration = function ditchRegistration() {
                        var retry = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

                        activeSubscriptions[topic].acceptsUpdates = false;
                        activeSubscriptions[topic].suppliesData = false;
                        activeSubscriptions[topic].pendingUpdates = [];
                        activeSubscriptions[topic].currentState = null;
                        _this2.subscriptionsHaveChanged = true;

                        // session.call(unregisterEndpoint, [], { registrationId: registration.id }, {}).then(response => {
                        //     if (!response || !response.kwargs || !response.kwargs.registrationId) {
                        //         return disconnect();
                        //     }

                        return session.unregister(registration).then(function () {
                            activeSubscriptions[topic].nextRetry = retry && Date.now() + retryAfter || false;
                            activeSubscriptions[topic].isBusy = false;
                            activeSubscriptions[topic].registration = null;
                            _this2.subscriptionsHaveChanged = true;
                        }, function () {
                            // Ditch entire connetion on error
                            (0, _connection.disconnect)();
                        });
                        // }, () => disconnect());
                    };

                    // Call initialDump Endpoint
                    session.call(initialDumpEndpoint, [], { topic: topic }, {}).then(function (response) {
                        if (!validateInitialDump(response, uniqueKey)) {
                            ditchRegistration(false);
                            if (isErrorInitialDump(response, uniqueKey)) {
                                activeSubscriptions[topic].pendingErrors.push(response);
                                _this2.subscriptionsHaveChanged = true;
                            } else {
                                throw new Error('Initial Dump validation failed for ' + topic + '.\n                                    This is very likely to be the result of a breaking change in the API');
                            }
                        } else {
                            activeSubscriptions[topic].currentState = mergeUpdates(parseInitialDump(response, uniqueKey), activeSubscriptions[topic].pendingUpdates, uniqueKey);
                            activeSubscriptions[topic].pendingUpdates = [];
                            activeSubscriptions[topic].isBusy = false;
                            activeSubscriptions[topic].suppliesData = true;
                            _this2.subscriptionsHaveChanged = true;
                        }
                    }, function (response) {
                        var errorCode = response && response.error || false;
                        switch (errorCode) {
                            // Actual Error From The WAMP Router
                            case 'wamp.error.no_business_server':
                            case 'wamp.no.backend':
                                ditchRegistration();
                                break;
                            case 'wamp.error.no_such_procedure':
                            case 'om.rpc.exception':
                            default:
                                ditchRegistration(false);
                                throw new Error('Initial dump endpoint ' + initialDumpEndpoint + ' failed or was not found on the server.\n                                    This is very likely to be the result of a breaking change in the API');
                        }
                    });
                }, function (response) {
                    if (isSubscriptionError(response)) {
                        activeSubscriptions[topic].isBusy = false;
                        activeSubscriptions[topic].registration = null;
                        activeSubscriptions[topic].pendingErrors.push(response);
                        _this2.subscriptionsHaveChanged = true;
                    } else {
                        var errorCode = response && response.error || false;
                        switch (errorCode) {
                            // Actual Error From The WAMP Router
                            case 'wamp.error.no_such_procedure':
                            case 'om.rpc.exception':
                                throw new Error('Initial dump endpoint ' + initialDumpEndpoint + ' was not found on the server.\n                                    This is very likely to be the result of a breaking change in the API');
                            // Retry registration later
                            case 'wamp.error.no_business_server':
                            case 'wamp.no.backend':
                            default:
                                activeSubscriptions[topic].nextRetry = Date.now() + retryAfter;
                                activeSubscriptions[topic].isBusy = false;
                                _this2.subscriptionsHaveChanged = true;
                                break;
                        }
                    }
                });
            }
        };

        for (var _iterator = Object.keys(subscribersByTopic), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
            var _ref;

            var _ret = _loop();

            if (_ret === 'break') break;
        }

        // Unregister Topics Without Subscribers

        var _loop2 = function _loop2() {
            if (_isArray2) {
                if (_i2 >= _iterator2.length) return 'break';
                _ref2 = _iterator2[_i2++];
            } else {
                _i2 = _iterator2.next();
                if (_i2.done) return 'break';
                _ref2 = _i2.value;
            }

            var topic = _ref2;

            if (!subscribersByTopic[topic] && !activeSubscriptions[topic].isBusy && activeSubscriptions[topic].nextRetry === false) {
                if (!activeSubscriptions[topic].registration) {
                    delete activeSubscriptions[topic];
                    _this2.subscriptionsHaveChanged = true;
                } else {
                    activeSubscriptions[topic].isBusy = true;
                    activeSubscriptions[topic].acceptsUpdates = false;
                    activeSubscriptions[topic].suppliesData = false;
                    activeSubscriptions[topic].currentState = null;
                    _this2.subscriptionsHaveChanged = true;

                    // session.call(unregisterEndpoint, [], { registrationId: activeSubscriptions[topic].registration.id }, {}).then(response => {
                    //     if (!response || !response.kwargs || !response.kwargs.registrationId) {
                    //         return disconnect();
                    //     }

                    return {
                        v: session.unregister(activeSubscriptions[topic].registration).then(function () {
                            delete activeSubscriptions[topic];
                            _this2.subscriptionsHaveChanged = true;
                        }, function () {
                            (0, _connection.disconnect)();
                        })
                    };
                    // }, () => disconnect());
                }
            }
        };

        _loop3: for (var _iterator2 = Object.keys(activeSubscriptions), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
            var _ref2;

            var _ret2 = _loop2();

            switch (_ret2) {
                case 'break':
                    break _loop3;

                default:
                    if ((typeof _ret2 === 'undefined' ? 'undefined' : _typeof(_ret2)) === "object") return _ret2.v;
            }
        }

        this.subscriptionsHaveChanged = true;
    };

    /**
     * Send Updates To Subscribers
     * - only updates subscribersByTopic, calls handlers on subscribers, reacts to activeSubscriptions
     * - gets called every time activeSubscriptions changes
     * - merges updates
     * - indexes data
     */


    SubscriberProcessor.prototype.processSubscriptionData = function processSubscriptionData() {
        // Relevant Options
        var subscribersByTopic = this.subscribersByTopic,
            activeSubscriptions = this.activeSubscriptions;

        // Iterate Subscribers by Topic

        for (var _iterator3 = Object.keys(subscribersByTopic), _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
            var _ref3;

            if (_isArray3) {
                if (_i3 >= _iterator3.length) break;
                _ref3 = _iterator3[_i3++];
            } else {
                _i3 = _iterator3.next();
                if (_i3.done) break;
                _ref3 = _i3.value;
            }

            var _topic = _ref3;

            for (var _iterator4 = subscribersByTopic[_topic], _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator]();;) {
                var _ref4;

                if (_isArray4) {
                    if (_i4 >= _iterator4.length) break;
                    _ref4 = _iterator4[_i4++];
                } else {
                    _i4 = _iterator4.next();
                    if (_i4.done) break;
                    _ref4 = _i4.value;
                }

                var subscriber = _ref4;

                // call onPending
                if (typeof subscriber.isPending === 'undefined' || // subscriber has no isPending field set
                !subscriber.isPending && (!activeSubscriptions[_topic] || activeSubscriptions[_topic] && !activeSubscriptions[_topic].suppliesData)) {
                    subscriber.isPending = true;
                    subscriber.onPending();
                }

                // Call onError if there were errors
                if (activeSubscriptions[_topic] && activeSubscriptions[_topic].pendingErrors && activeSubscriptions[_topic].pendingErrors.length) {
                    subscriber.onError(activeSubscriptions[_topic].pendingErrors);
                }

                // Call onUpdate if we have data
                if (activeSubscriptions[_topic]) {
                    if (activeSubscriptions[_topic].currentState !== subscriber.lastUpdate) {
                        subscriber.lastUpdate = activeSubscriptions[_topic].currentState;
                        subscriber.onUpdate(activeSubscriptions[_topic].currentState);
                    }
                } else if (subscriber.lastUpdate !== null) {
                    subscriber.lastUpdate = null;
                    subscriber.onUpdate(null);
                }

                // Call onComplete if ready
                if (activeSubscriptions[_topic] && activeSubscriptions[_topic].suppliesData && subscriber.isPending) {
                    subscriber.isPending = false;
                    subscriber.onCompletion();
                }
            }

            // We're done with errors, clear the errors queue
            if (activeSubscriptions[_topic] && activeSubscriptions[_topic].pendingErrors && activeSubscriptions[_topic].pendingErrors.length) {
                activeSubscriptions[_topic].pendingErrors = [];
            }
        }
    };

    return SubscriberProcessor;
}();

exports.default = SubscriberProcessor;

/***/ }),

/***/ 311:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.onPendingCallsUpdate = onPendingCallsUpdate;
exports.default = provideCall;

var _connection = __webpack_require__(71);

/**
 * Defaults to base call provision on
 */
var defaultOptions = {
    // RPC to call
    rpcName: '',

    // parameters parsing and defaults go here, should not throw errors
    parseParams: function parseParams() {},

    // response validator - should return true or false, when response is invalid
    validateResponse: function validateResponse(data) {
        return !!data && typeof data.kwargs !== 'undefined';
    },

    // check whether a response qualifies as a request error (invalid parameters, etc.)
    // occurrs after validation failure - if it returns false, then the API is broken and an error is thrown
    isErrorResponse: function isErrorResponse(data) {
        return data && data.kwargs && data.kwargs.error;
    },

    // response parser - this is to reformat the data (ex.: kwargs removal)
    parseResponse: function parseResponse(data) {
        return data.kwargs;
    },

    // when calls fail recoverably, retry after this amount of time (minimum)
    // @TODO: retry_delay_growth and retry_delay_jitter from autobahn reconnect logic
    retryAfter: 3000
};

/**
 * List Updates Handlers
 */
var handlersIndex = 0;

var onPendingCallsUpdateHandlers = {};
var pendingCallsList = {};

// Logic to attach a handler
function addHandler() {
    var handlers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var fn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

    var handlerIndex = ++handlersIndex;
    var targetHandlers = handlers;
    targetHandlers[handlerIndex] = fn;
    return function () {
        delete targetHandlers[handlerIndex];
    };
}

// Logic to call all attached handlers
function callHandlers() {
    var handlers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    for (var _iterator = Object.keys(handlers), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref;

        if (_isArray) {
            if (_i >= _iterator.length) break;
            _ref = _iterator[_i++];
        } else {
            _i = _iterator.next();
            if (_i.done) break;
            _ref = _i.value;
        }

        var handlerIndex = _ref;

        if (typeof handlers[handlerIndex] === 'function') {
            handlers[handlerIndex].apply(handlers, params);
        }
    }
}

// Retrieve coalesced pendingCalls list
function getPendingCallsList() {
    var r = [];
    for (var _iterator2 = Object.keys(pendingCallsList), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
        var _ref2;

        if (_isArray2) {
            if (_i2 >= _iterator2.length) break;
            _ref2 = _iterator2[_i2++];
        } else {
            _i2 = _iterator2.next();
            if (_i2.done) break;
            _ref2 = _i2.value;
        }

        var methodName = _ref2;

        for (var _iterator3 = Object.keys(pendingCallsList[methodName]), _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
            var _ref3;

            if (_isArray3) {
                if (_i3 >= _iterator3.length) break;
                _ref3 = _iterator3[_i3++];
            } else {
                _i3 = _iterator3.next();
                if (_i3.done) break;
                _ref3 = _i3.value;
            }

            var callId = _ref3;

            r.push(pendingCallsList[methodName][callId]);
        }
    }
    return r;
}

/**
 * onPendingCallsUpdate - attaches handlers - bound to api.onPendingCallsUpdate
 */
function onPendingCallsUpdate() {
    var fn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};

    return addHandler(onPendingCallsUpdateHandlers, fn);
}

/**
 * provideCall - exported to API core
 */
var automaticClientRequestId = 0;
function provideCall() {
    var callMethodName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var cancelCallMethodName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var preferredOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    // Apply defaults, validate options
    var options = Object.assign({}, defaultOptions, preferredOptions);
    if (!options.rpcName || typeof options.rpcName !== 'string' || !options.rpcName.length) {
        throw new Error('Invalid RPC name supplied to provideCall ' + options.rpcName);
    }

    var rpcName = options.rpcName,
        parseParams = options.parseParams,
        isErrorResponse = options.isErrorResponse,
        validateResponse = options.validateResponse,
        parseResponse = options.parseResponse,
        retryAfter = options.retryAfter;

    /**
     * Process all pending calls
     */

    var pendingCalls = {};
    function processPendingCalls() {
        var session = (0, _connection.getSession)();
        if (!session) {
            return false;
        }

        var now = Date.now();

        var _loop = function _loop() {
            if (_isArray4) {
                if (_i4 >= _iterator4.length) return 'break';
                _ref4 = _iterator4[_i4++];
            } else {
                _i4 = _iterator4.next();
                if (_i4.done) return 'break';
                _ref4 = _i4.value;
            }

            var callId = _ref4;

            var pendingCall = pendingCalls[callId];
            var params = pendingCall.params,
                onCompletion = pendingCall.onCompletion,
                onSuccess = pendingCall.onSuccess,
                onError = pendingCall.onError,
                isRequested = pendingCall.isRequested,
                sessionId = pendingCall.sessionId,
                nextRetry = pendingCall.nextRetry;


            if ((!isRequested || sessionId !== session.id) && (!nextRetry || nextRetry <= now)) {
                var callSessionId = session.id;

                /**
                 * Executing the actual call, and it will only resolve/reject if:
                 * - call was not canceled
                 * - call is not being resolved while session has been invalidated
                 * - session id recorded when call was performed matches currently live session id
                 * - another call has not been attempted
                 * - the current call is the same as the one in the pending calls list
                 *
                 * According to tests, this is well within bounds:
                 * http://stackoverflow.com/questions/20068467/do-never-resolved-promises-cause-memory-leak
                 */
                session.call(rpcName, [], params || {}, {}).then(function (response) {
                    // resolving the call
                    var localSession = (0, _connection.getSession)();
                    if (pendingCalls[callId] && localSession && callSessionId === pendingCalls[callId].sessionId && callSessionId === localSession.id && pendingCall === pendingCalls[callId]) {
                        delete pendingCalls[callId];

                        pendingCallsList[callMethodName] = Object.assign({}, pendingCalls);
                        callHandlers(onPendingCallsUpdateHandlers, [getPendingCallsList()]);
                        // Validation succeeds - call is successful, response is good
                        if (validateResponse(response)) {
                            onSuccess(parseResponse(response));
                            onCompletion();
                            // Validation fails, but it is an error, call the error handler
                            // @TODO: APIFIX: {"error": 'INVALID_WHATEVER', "message": "Invalid Whatever"}
                        } else if (isErrorResponse(response)) {
                            onError(response);
                            onCompletion();
                            // In case it doesn't seem to be an error either
                        } else {
                            throw new Error('Response validation failed for ' + rpcName + ' called with params ' + JSON.stringify(params) + '.\n                                This is very likely to be the result of a breaking change in the API');
                        }
                    }
                }, function (response) {
                    // rejecting the call
                    var localSession = (0, _connection.getSession)();
                    if (pendingCalls[callId] && localSession && callSessionId === pendingCalls[callId].sessionId && callSessionId === localSession.id && pendingCall === pendingCalls[callId]) {
                        var errorCode = response && response.error || false;
                        switch (errorCode) {
                            // Actual Error From The WAMP Router
                            case 'wamp.error.no_such_procedure':
                            case 'om.rpc.exception':
                                delete pendingCalls[callId];
                                if (rpcName.indexOf('infoTypeUsage') > -1) {
                                    break;
                                }
                                pendingCallsList[callMethodName] = Object.assign({}, pendingCalls);
                                callHandlers(onPendingCallsUpdateHandlers, [getPendingCallsList()]);
                                throw new Error('Procedure ' + rpcName + ' was not found on the server.\n                                    This is very likely to be the result of a breaking change in the API');
                            // Retry the call later
                            case 'wamp.error.no_business_server':
                            case 'wamp.no.backend':
                            default:
                                pendingCalls[callId].nextRetry = Date.now() + retryAfter;
                                pendingCalls[callId].isRequested = false;
                                pendingCalls[callId].sessionId = false;

                                pendingCallsList[callMethodName] = Object.assign({}, pendingCalls);
                                callHandlers(onPendingCallsUpdateHandlers, [getPendingCallsList()]);
                                break;
                        }
                    }
                });

                // mark call as processed under current session
                pendingCall.sessionId = session.id;
                pendingCall.isRequested = true;
                pendingCall.nextRetry = false;

                pendingCallsList[callMethodName] = Object.assign({}, pendingCalls);
                callHandlers(onPendingCallsUpdateHandlers, [getPendingCallsList()]);
            }
        };

        for (var _iterator4 = Object.keys(pendingCalls), _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator]();;) {
            var _ref4;

            var _ret = _loop();

            if (_ret === 'break') break;
        }

        return true;
    }

    // Called to cancel the RPC
    function _cancelCall(cancelClientrequestId) {
        if (cancelClientrequestId && pendingCalls[cancelClientrequestId] && {}.hasOwnProperty.call(pendingCalls, cancelClientrequestId)) {
            delete pendingCalls[cancelClientrequestId];

            pendingCallsList[callMethodName] = Object.assign({}, pendingCalls);
            callHandlers(onPendingCallsUpdateHandlers, [getPendingCallsList()]);
        }
    }

    // Called to execute the RPC
    function call(_ref5) {
        var clientRequestId = _ref5.clientRequestId,
            _ref5$params = _ref5.params,
            params = _ref5$params === undefined ? {} : _ref5$params,
            _ref5$onPending = _ref5.onPending,
            onPending = _ref5$onPending === undefined ? function () {} : _ref5$onPending,
            _ref5$onCompletion = _ref5.onCompletion,
            onCompletion = _ref5$onCompletion === undefined ? function () {} : _ref5$onCompletion,
            _ref5$onSuccess = _ref5.onSuccess,
            onSuccess = _ref5$onSuccess === undefined ? function () {} : _ref5$onSuccess,
            _ref5$onError = _ref5.onError,
            onError = _ref5$onError === undefined ? function () {} : _ref5$onError;

        // Call identifier
        var callId = clientRequestId || ++automaticClientRequestId;

        // Existing call with same clientRequestId
        if (clientRequestId && pendingCalls[clientRequestId]) {
            throw new Error('Existing call found to ' + rpcName + ' using ' + clientRequestId + ';\neither serialize calls, cancel the existing call, execute the call under a different clientRequestId, or do not specify a clientRequestId at all');
        }

        pendingCalls[callId] = {
            rpcName: rpcName,
            params: parseParams(params),
            isRequested: false,
            sessionId: false,
            nextRetry: false,
            onPending: onPending,
            onCompletion: onCompletion,
            onSuccess: onSuccess,
            onError: onError,
            cancelCall: function cancelCall() {
                return _cancelCall(callId);
            }
        };

        pendingCallsList[callMethodName] = Object.assign({}, pendingCalls);
        callHandlers(onPendingCallsUpdateHandlers, [getPendingCallsList()]);

        // call onPending()
        onPending();

        // Process if connected
        if ((0, _connection.isConnected)()) {
            processPendingCalls();
        }
    }

    // Process all pending calls on connect
    (0, _connection.onConnect)(function () {
        return processPendingCalls();
    });
    setInterval(function () {
        return processPendingCalls();
    }, defaultOptions.retryAfter);

    // Done
    return { callMethodName: callMethodName, call: call, cancelCallMethodName: cancelCallMethodName, cancelCall: _cancelCall };
}

/***/ }),

/***/ 312:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.onSubscriptionsUpdate = onSubscriptionsUpdate;
exports.onSubscribersUpdate = onSubscribersUpdate;
exports.default = provideOMFETopic;

var _SubscribersProcessor = __webpack_require__(310);

var _SubscribersProcessor2 = _interopRequireDefault(_SubscribersProcessor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// @FIXME: APIFIX: Investigate all errors types again

/**
 * Defaults to base OMFETopic provision on
 */
var defaultOptions = {
    // topic name construction - parameters parsing and defaults go here, should return a string
    topicName: function topicName(params) {
        return JSON.stringify(params);
    },

    // response validator - should return true or false, when initial dump is invalid
    validateInitialDump: function validateInitialDump(data) {
        return data && data.kwargs && data.kwargs.records && data.kwargs.version;
    },

    // check whether a response qualifies as an error (ex.: error key presence etc.)
    isErrorInitialDump: function isErrorInitialDump(data) {
        return data && data.kwargs && data.kwargs.error;
    },

    // response parser - this is to reformat the data pulled from initial dump (ex.: kwargs removal)
    parseInitialDump: function parseInitialDump(data, uniqueKey) {
        var _ref = data && data.kwargs || {},
            version = _ref.version,
            records = _ref.records;

        var newState = { version: version, records: records };
        // for (const record of records){
        //     newState.records[record[uniqueKey]] = record;
        // }
        return newState;
    },

    // updates validator - if an update is understood by the client an can be merged
    validateUpdate: function validateUpdate(data) {
        return data && data.kwargs && data.kwargs.records && data.kwargs.version && (data.kwargs.type && (data.kwargs.type === 'CREATE' || data.kwargs.type === 'UPDATE' || data.kwargs.type === 'DELETE') || data.kwargs.messageType && data.kwargs.messageType === 'UPDATE');
    },

    // validate an error update type
    isErrorUpdate: function isErrorUpdate(data) {
        return data && data.kwargs && data.kwargs.error;
    },

    // updates parser - reformat data pushed
    parseUpdate: function parseUpdate(data, uniqueKey) {
        var _ref2 = data && data.kwargs,
            messageType = _ref2.messageType,
            type = _ref2.type,
            version = _ref2.version,
            records = _ref2.records;

        var newUpdate = { version: version, type: type, messageType: messageType, records: records };
        //
        // if (messageType === 'UPDATE' || messageType === 'INITIAL_DUMP'){
        //     return newUpdate;
        // } else {
        //     if (type === 'CREATE'){
        //         for (const record of records){
        //             // newUpdate.records[record[uniqueKey]] = record;
        //             newUpdate.records
        //         }
        //     } else {
        //         newUpdate.records = records;
        //     }
        // }
        return newUpdate;
    },

    // subscription error - ex.: invalid match id
    isSubscriptionError: function isSubscriptionError(data) {
        return data && data.kwargs && data.kwargs.error;
    },

    // merging strategy, this will be applied on non-indexed data
    // all the parsing above should already be applied, be wary of data format inconsistencies
    // because this is the function that merges updates into current state, pre-index
    // - brings the data to an initialDump format, you can index records by uniquekey
    mergeUpdates: function mergeUpdates(currentState, updates) {
        var newState = Object.assign({}, currentState);
        newState.records = [].concat(currentState.records);
        for (var _iterator = updates, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
            var _ref3;

            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref3 = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref3 = _i.value;
            }

            var update = _ref3;
            var messageType = update.messageType,
                type = update.type,
                records = update.records,
                version = update.version;

            if (Number(version) >= Number(newState.version)) {
                newState.version = version;

                if (messageType === 'UPDATE') {
                    var _loop = function _loop() {
                        if (_isArray2) {
                            if (_i2 >= _iterator2.length) return 'break';
                            _ref4 = _iterator2[_i2++];
                        } else {
                            _i2 = _iterator2.next();
                            if (_i2.done) return 'break';
                            _ref4 = _i2.value;
                        }

                        var record = _ref4;

                        switch (record.changeType) {
                            case 'CREATE':
                                newState.records = [].concat(newState.records.filter(function (fi) {
                                    return !(fi.id === record.id && fi._type === record.entityType);
                                }), [record.entity]);
                                break;
                            case 'UPDATE':
                                var found = newState.records.find(function (fi) {
                                    return fi.id === record.id && fi._type === record.entityType;
                                });
                                var newRecord = Object.assign({}, found);
                                if (found) {
                                    for (var _iterator3 = Object.keys(record.changedProperties), _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
                                        var _ref5;

                                        if (_isArray3) {
                                            if (_i3 >= _iterator3.length) break;
                                            _ref5 = _iterator3[_i3++];
                                        } else {
                                            _i3 = _iterator3.next();
                                            if (_i3.done) break;
                                            _ref5 = _i3.value;
                                        }

                                        var key = _ref5;

                                        newRecord[key] = record.changedProperties[key];
                                    }
                                    newState.records = [].concat(newState.records.filter(function (fi) {
                                        return !(fi.id === record.id && fi._type === record.entityType);
                                    }), [newRecord]);
                                }
                                break;
                            case 'DELETE':
                                newState.records = newState.records.filter(function (fi) {
                                    return !(fi.id === record.id && fi._type === record.entityType);
                                });
                                break;
                        }
                    };

                    // apiVersion4
                    for (var _iterator2 = records, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
                        var _ref4;

                        var _ret = _loop();

                        if (_ret === 'break') break;
                    }
                    return newState;
                } else if (typeof type !== 'undefined') {
                    switch (type) {
                        case 'CREATE':
                            var _loop2 = function _loop2() {
                                if (_isArray4) {
                                    if (_i4 >= _iterator4.length) return 'break';
                                    _ref6 = _iterator4[_i4++];
                                } else {
                                    _i4 = _iterator4.next();
                                    if (_i4.done) return 'break';
                                    _ref6 = _i4.value;
                                }

                                var record = _ref6;

                                newState.records = [].concat(newState.records.filter(function (fi) {
                                    return !(fi.id === record.id);
                                }), [record]);
                            };

                            for (var _iterator4 = records, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator]();;) {
                                var _ref6;

                                var _ret2 = _loop2();

                                if (_ret2 === 'break') break;
                            }
                            break;
                        case 'UPDATE':
                            var _loop3 = function _loop3() {
                                if (_isArray5) {
                                    if (_i5 >= _iterator5.length) return 'break';
                                    _ref7 = _iterator5[_i5++];
                                } else {
                                    _i5 = _iterator5.next();
                                    if (_i5.done) return 'break';
                                    _ref7 = _i5.value;
                                }

                                var record = _ref7;

                                var found = newState.records.find(function (fi) {
                                    return fi.id === record.id;
                                });
                                if (found) {
                                    var newRecord = Object.assign({}, found, record);
                                    newState.records = [].concat(newState.records.filter(function (fi) {
                                        return !(fi.id === newRecord.id && fi._type === newRecord._type);
                                    }), [newRecord]);
                                }
                            };

                            for (var _iterator5 = records, _isArray5 = Array.isArray(_iterator5), _i5 = 0, _iterator5 = _isArray5 ? _iterator5 : _iterator5[Symbol.iterator]();;) {
                                var _ref7;

                                var _ret3 = _loop3();

                                if (_ret3 === 'break') break;
                            }
                            break;
                        case 'DELETE':
                            var _loop4 = function _loop4() {
                                if (_isArray6) {
                                    if (_i6 >= _iterator6.length) return 'break';
                                    _ref8 = _iterator6[_i6++];
                                } else {
                                    _i6 = _iterator6.next();
                                    if (_i6.done) return 'break';
                                    _ref8 = _i6.value;
                                }

                                var id = _ref8;

                                newState.records = newState.records.filter(function (fi) {
                                    return !(fi.id === id);
                                });
                            };

                            for (var _iterator6 = records, _isArray6 = Array.isArray(_iterator6), _i6 = 0, _iterator6 = _isArray6 ? _iterator6 : _iterator6[Symbol.iterator]();;) {
                                var _ref8;

                                var _ret4 = _loop4();

                                if (_ret4 === 'break') break;
                            }
                            break;
                        default:
                            break;
                    }
                }
            }
        }
        return newState;
    },

    // unique key to process updates by
    uniqueKey: 'id',

    // initialDump endpoint to call
    initialDumpEndpoint: '/sports#initialDump',

    // another endpoint to call before unregistering - this is to ensure nodes actually unregister
    unregisterEndpoint: '/sports#doUnregister',

    // when calls fail recoverably, retry after this amount of time (minimum)
    // @TODO: retry_delay_growth and retry_delay_jitter from autobahn reconnect logic
    retryAfter: 3000,

    // subscribers processing frequency
    subscribersProcessingFrequency: 1000 / 60
};

/**
 * List Updates Handlers
 */
var handlersIndex = 0;

var onSubscriptionsUpdateHandlers = {};
var onSubscribersUpdateHandlers = {};
var subscriptionsList = {};
var subscribersList = {};

// Logic to attach a handler
function addHandler() {
    var handlers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var fn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

    var handlerIndex = ++handlersIndex;
    var targetHandlers = handlers;
    targetHandlers[handlerIndex] = fn;
    return function () {
        delete targetHandlers[handlerIndex];
    };
}

// Logic to call all attached handlers
function callHandlers() {
    var handlers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    for (var _iterator7 = Object.keys(handlers), _isArray7 = Array.isArray(_iterator7), _i7 = 0, _iterator7 = _isArray7 ? _iterator7 : _iterator7[Symbol.iterator]();;) {
        var _ref9;

        if (_isArray7) {
            if (_i7 >= _iterator7.length) break;
            _ref9 = _iterator7[_i7++];
        } else {
            _i7 = _iterator7.next();
            if (_i7.done) break;
            _ref9 = _i7.value;
        }

        var handlerIndex = _ref9;

        if (typeof handlers[handlerIndex] === 'function') {
            handlers[handlerIndex].apply(handlers, params);
        }
    }
}

// Retrieve coalesced subscribers list
function getSubscriptionsList() {
    var r = [];
    for (var _iterator8 = Object.keys(subscriptionsList), _isArray8 = Array.isArray(_iterator8), _i8 = 0, _iterator8 = _isArray8 ? _iterator8 : _iterator8[Symbol.iterator]();;) {
        var _ref10;

        if (_isArray8) {
            if (_i8 >= _iterator8.length) break;
            _ref10 = _iterator8[_i8++];
        } else {
            _i8 = _iterator8.next();
            if (_i8.done) break;
            _ref10 = _i8.value;
        }

        var methodName = _ref10;

        for (var _iterator9 = Object.keys(subscriptionsList[methodName]), _isArray9 = Array.isArray(_iterator9), _i9 = 0, _iterator9 = _isArray9 ? _iterator9 : _iterator9[Symbol.iterator]();;) {
            var _ref11;

            if (_isArray9) {
                if (_i9 >= _iterator9.length) break;
                _ref11 = _iterator9[_i9++];
            } else {
                _i9 = _iterator9.next();
                if (_i9.done) break;
                _ref11 = _i9.value;
            }

            var callId = _ref11;

            r.push(subscriptionsList[methodName][callId]);
        }
    }
    return r;
}

function getSubscribersList() {
    var r = [];
    for (var _iterator10 = Object.keys(subscribersList), _isArray10 = Array.isArray(_iterator10), _i10 = 0, _iterator10 = _isArray10 ? _iterator10 : _iterator10[Symbol.iterator]();;) {
        var _ref12;

        if (_isArray10) {
            if (_i10 >= _iterator10.length) break;
            _ref12 = _iterator10[_i10++];
        } else {
            _i10 = _iterator10.next();
            if (_i10.done) break;
            _ref12 = _i10.value;
        }

        var methodName = _ref12;

        for (var _iterator11 = Object.keys(subscribersList[methodName]), _isArray11 = Array.isArray(_iterator11), _i11 = 0, _iterator11 = _isArray11 ? _iterator11 : _iterator11[Symbol.iterator]();;) {
            var _ref13;

            if (_isArray11) {
                if (_i11 >= _iterator11.length) break;
                _ref13 = _iterator11[_i11++];
            } else {
                _i11 = _iterator11.next();
                if (_i11.done) break;
                _ref13 = _i11.value;
            }

            var callId = _ref13;

            r.push(subscribersList[methodName][callId]);
        }
    }
    return r;
}

/**
 * onSubscriptionsUpdate - attaches handlers - bound to api.onSubscriptionsUpdate
 */
function onSubscriptionsUpdate() {
    var fn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};

    return addHandler(onSubscriptionsUpdateHandlers, fn);
}

/**
 * onSubscribersUpdate - attaches handlers - bound to api.onSubscribersUpdate
 */
function onSubscribersUpdate() {
    var fn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};

    return addHandler(onSubscribersUpdateHandlers, fn);
}

/**
 * provideOMFETopic
 */
function provideOMFETopic() {
    var subscribeMethodName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var unsubscribeMethodName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var preferredOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    /**
     * Options
     */
    var options = Object.assign({}, defaultOptions, preferredOptions);
    if (!options.topicName || typeof options.topicName !== 'function' || typeof options.topicName({}) !== 'string' || !options.topicName({}).length) {
        throw new Error('Invalid topic name supplied to provideCall; must be a function that returns a string');
    }

    var topicName = options.topicName;

    /**
     * Subscribers Lists
     * - only subscribe/unsubscribe operates on these lists
     * - processor reacts to changes to these lists
     */

    var subscribers = {};
    var subscribersByTopic = {};
    var subscribersHaveChanged = false;
    var processor = new _SubscribersProcessor2.default(options);

    // subscribers processing task
    setInterval(function () {
        if (subscribersHaveChanged) {
            processor.updateSubscribers(subscribersByTopic);

            // Call Handlers
            subscribersList[subscribeMethodName] = Object.assign({}, subscribers);
            callHandlers(onSubscribersUpdateHandlers, [getSubscribersList()]);

            // Reset Subscribers Status
            subscribersHaveChanged = false;
        }
    }, options.subscribersProcessingFrequency);

    /**
     * Attach handler updates
     */
    processor.onSubscriptionsUpdate = function (activeSubscriptions) {
        subscriptionsList[subscribeMethodName] = Object.assign({}, activeSubscriptions);
        callHandlers(onSubscriptionsUpdateHandlers, [getSubscriptionsList()]);
    };

    /**
     * unsubscribe - the opposite of subscribe
     */
    function unsubscribe(unsubscribeClientRequestId) {
        if (!subscribers[unsubscribeClientRequestId]) {
            return;
        }
        var topic = subscribers[unsubscribeClientRequestId].topic;

        delete subscribers[unsubscribeClientRequestId];
        var i = -1;
        for (var _iterator12 = subscribersByTopic[topic], _isArray12 = Array.isArray(_iterator12), _i12 = 0, _iterator12 = _isArray12 ? _iterator12 : _iterator12[Symbol.iterator]();;) {
            var _ref14;

            if (_isArray12) {
                if (_i12 >= _iterator12.length) break;
                _ref14 = _iterator12[_i12++];
            } else {
                _i12 = _iterator12.next();
                if (_i12.done) break;
                _ref14 = _i12.value;
            }

            var subscriber = _ref14;

            i++;
            if (subscriber.clientRequestId === unsubscribeClientRequestId) {
                subscribersByTopic[topic].splice(i, 1);
                break;
            }
        }

        // delete empty index
        if (!subscribersByTopic[topic].length) {
            delete subscribersByTopic[topic];
        }

        subscribersHaveChanged = true;
    }

    /**
     * subscribe - called by clients - updates internal subscribers lists,
     */
    function subscribe(_ref15) {
        var _ref15$clientRequestI = _ref15.clientRequestId,
            clientRequestId = _ref15$clientRequestI === undefined ? false : _ref15$clientRequestI,
            _ref15$params = _ref15.params,
            params = _ref15$params === undefined ? {} : _ref15$params,
            _ref15$groupBy = _ref15.groupBy,
            groupBy = _ref15$groupBy === undefined ? false : _ref15$groupBy,
            _ref15$onPending = _ref15.onPending,
            onPending = _ref15$onPending === undefined ? function () {} : _ref15$onPending,
            _ref15$onCompletion = _ref15.onCompletion,
            onCompletion = _ref15$onCompletion === undefined ? function () {} : _ref15$onCompletion,
            _ref15$onUpdate = _ref15.onUpdate,
            onUpdate = _ref15$onUpdate === undefined ? function () {} : _ref15$onUpdate,
            _ref15$onError = _ref15.onError,
            onError = _ref15$onError === undefined ? function () {} : _ref15$onError;

        if (!clientRequestId) {
            throw new Error('The `clientRequestId` parameter is mandatory for OMFE subscriptions');
        }

        if (subscribers[clientRequestId]) {
            throw new Error('Already using ' + clientRequestId + ' against ' + subscribeMethodName);
        }

        // save the subscription
        var topic = topicName(params);
        subscribers[clientRequestId] = {
            clientRequestId: clientRequestId,
            params: params,
            topic: topic,
            groupBy: groupBy,

            onPending: onPending,
            onCompletion: onCompletion,
            onUpdate: onUpdate,
            onError: onError,

            removeSubscriber: function removeSubscriber() {
                return unsubscribe(clientRequestId);
            }
        };

        // create the index if not exists
        if (!subscribersByTopic[topic]) {
            subscribersByTopic[topic] = [];
        }

        // add to index
        subscribersByTopic[topic].push(subscribers[clientRequestId]);

        // update status
        subscribersHaveChanged = true;
    }

    /**
     * Functions Go Back Into API Singleton
     */
    return { subscribeMethodName: subscribeMethodName, subscribe: subscribe, unsubscribeMethodName: unsubscribeMethodName, unsubscribe: unsubscribe };
}

/***/ }),

/***/ 313:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = disciplines;
function disciplines(api) {
    return api && api.provideCall && api.provideCall('requestDisciplines', 'cancelDisciplinesRequest', {
        // topic to request
        rpcName: '/sports#disciplines',

        parseParams: function parseParams(_ref) {
            var _ref$lang = _ref.lang,
                lang = _ref$lang === undefined ? 'en' : _ref$lang,
                _ref$virtualStatus = _ref.virtualStatus,
                virtualStatus = _ref$virtualStatus === undefined ? 'BOTH' : _ref$virtualStatus,
                _ref$liveStatus = _ref.liveStatus,
                liveStatus = _ref$liveStatus === undefined ? 'BOTH' : _ref$liveStatus;
            return { lang: lang, virtualStatus: virtualStatus, liveStatus: liveStatus };
        },

        // validation occurs before parsing
        validateResponse: function validateResponse(data) {
            return data && data.kwargs;
        },
        parseResponse: function parseResponse(data) {
            return !data && [] || data.kwargs && data.kwargs.records || data && data.kwargs;
        }
    });
}

/***/ }),

/***/ 314:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = eventInfoTypeUsage;
function eventInfoTypeUsage(api) {
        return api && api.provideCall && api.provideCall('requestEventInfoTypeUsage', 'cancelEventInfoTypeUsageRequest', {
                // topic to request
                rpcName: '/sports#infoTypeUsages',

                parseParams: function parseParams(_ref) {
                        var _ref$lang = _ref.lang,
                            lang = _ref$lang === undefined ? 'en' : _ref$lang;
                        return { lang: lang };
                },

                // validation occurs before parsing
                // validateResponse: (data) => data && data.kwargs,
                parseResponse: function parseResponse(data) {
                        return !data && [] || data.kwargs && data.kwargs.records || data && data.kwargs;
                }
        });
}

/***/ }),

/***/ 315:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = eventPartDefaultUsage;
function eventPartDefaultUsage(api) {
        return api && api.provideCall && api.provideCall('requestEventPartDefaultUsage', 'cancelEventPartDefaultUsageRequest', {
                // topic to request
                rpcName: '/sports#eventPartDefaultUsage',

                parseParams: function parseParams(_ref) {
                        var _ref$lang = _ref.lang,
                            lang = _ref$lang === undefined ? 'en' : _ref$lang;
                        return { lang: lang };
                },

                // validation occurs before parsing
                validateResponse: function validateResponse(data) {
                        return data && data.kwargs;
                },
                parseResponse: function parseResponse(data) {
                        return !data && [] || data.kwargs && data.kwargs.records || data && data.kwargs;
                }
        });
}

/***/ }),

/***/ 316:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = eventParts;
function eventParts(api) {
        return api && api.provideCall && api.provideCall('requestEventParts', 'cancelEventPartsRequest', {
                // topic to request
                rpcName: '/sports#eventParts',

                parseParams: function parseParams(_ref) {
                        var _ref$lang = _ref.lang,
                            lang = _ref$lang === undefined ? 'en' : _ref$lang;
                        return { lang: lang };
                },

                // validation occurs before parsing
                validateResponse: function validateResponse(data) {
                        return data && data.kwargs;
                },
                parseResponse: function parseResponse(data) {
                        return !data && [] || data.kwargs && data.kwargs.records || data && data.kwargs;
                }
        });
}

/***/ }),

/***/ 317:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = initialDump;
function initialDump(api) {
    return api && api.provideCall && api.provideCall('requestInitialDump', 'cancelInitialDumpRequest', {
        // topic to request
        rpcName: '/sports#initialDump',

        parseParams: function parseParams(_ref) {
            var _ref$topic = _ref.topic,
                topic = _ref$topic === undefined ? '' : _ref$topic;
            return { topic: topic };
        },

        // validation occurs before parsing
        validateResponse: function validateResponse(data) {
            return data && data.kwargs && data.kwargs.version && data.kwargs.records;
        }
    });
}

/***/ }),

/***/ 318:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = matches;
function matches(api) {
    return api && api.provideCall && api.provideCall('requestMatches', 'cancelMatchesRequest', {
        // topic to request
        rpcName: '/sports#matches',

        parseParams: function parseParams(_ref) {
            var _ref$lang = _ref.lang,
                lang = _ref$lang === undefined ? 'en' : _ref$lang,
                _ref$disciplineId = _ref.disciplineId,
                disciplineId = _ref$disciplineId === undefined ? '1' : _ref$disciplineId,
                _ref$liveStatus = _ref.liveStatus,
                liveStatus = _ref$liveStatus === undefined ? 'BOTH' : _ref$liveStatus;
            return { lang: lang, disciplineId: disciplineId, liveStatus: liveStatus };
        },

        // validation occurs before parsing
        validateResponse: function validateResponse(data) {
            return data && data.kwargs;
        },
        parseResponse: function parseResponse(data) {
            return !data && [] || data.kwargs && data.kwargs.records || data && data.kwargs;
        }
    });
}

/***/ }),

/***/ 319:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = nextMatches;
function nextMatches(api) {
    return api && api.provideCall && api.provideCall('requestNextMatches', 'cancelNextMatchesRequest', {
        // topic to request
        rpcName: '/sports#nextMatches',

        parseParams: function parseParams(_ref) {
            var _ref$lang = _ref.lang,
                lang = _ref$lang === undefined ? 'en' : _ref$lang,
                _ref$disciplineId = _ref.disciplineId,
                disciplineId = _ref$disciplineId === undefined ? '1' : _ref$disciplineId,
                _ref$hoursTillLive = _ref.hoursTillLive,
                hoursTillLive = _ref$hoursTillLive === undefined ? 24 : _ref$hoursTillLive;
            return { lang: lang, disciplineId: disciplineId, hoursTillLive: hoursTillLive };
        },

        // validation occurs before parsing
        validateResponse: function validateResponse(data) {
            return !data || data && data.kwargs;
        },
        parseResponse: function parseResponse(data) {
            return !data && [] || data.kwargs && data.kwargs.records || data && data.kwargs;
        }
    });
}

/***/ }),

/***/ 32:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(14)))

/***/ }),

/***/ 320:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = operatorInfo;
function operatorInfo(api) {
    return api && api.provideCall && api.provideCall('requestOperatorInfo', 'cancelOperatorInfoRequest', {
        // topic to request
        rpcName: '/sports#operatorInfo',

        // validation occurs before parsing
        validateResponse: function validateResponse(data) {
            var _ref = data || {},
                kwargs = _ref.kwargs;

            var _ref2 = kwargs || {},
                providerId = _ref2.providerId,
                apiVersion = _ref2.apiVersion,
                ucsOperatorId = _ref2.ucsOperatorId;

            var _arr = [providerId, apiVersion, ucsOperatorId];

            for (var _i = 0; _i < _arr.length; _i++) {
                var param = _arr[_i];
                if (typeof param === 'undefined') {
                    return false;
                }
            }
            return true;
        }
    });
}

/***/ }),

/***/ 321:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = eventInfo;
function eventInfo(api) {
    api.provideOMFETopic('subscribeToEventInfo', 'unsubscribeFromEventInfo', {
        topicName: function topicName(_ref) {
            var ucsOperatorId = _ref.ucsOperatorId,
                apiVersion = _ref.apiVersion,
                lang = _ref.lang,
                matchId = _ref.matchId,
                eventInfoType = _ref.eventInfoType,
                eventPartId = _ref.eventPartId;
            return '/sports/' + (apiVersion && ucsOperatorId && apiVersion >= 1 && ucsOperatorId + '/' || '') + (lang || 'en') + '/' + (matchId || 0) + '/eventInfo' + (eventInfoType && '/' + eventInfoType || '') + (eventPartId && '/' + eventPartId || '');
        }
    });
}

/***/ }),

/***/ 322:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = matchOdds;
function matchOdds(api) {
    api.provideOMFETopic('subscribeToMatchOdds', 'unsubscribeFromMatchOdds', {
        topicName: function topicName(_ref) {
            var ucsOperatorId = _ref.ucsOperatorId,
                apiVersion = _ref.apiVersion,
                lang = _ref.lang,
                matchId = _ref.matchId,
                providerId = _ref.providerId,
                bettingTypeId = _ref.bettingTypeId,
                eventPartId = _ref.eventPartId;
            return '/sports/' + (apiVersion && ucsOperatorId && apiVersion >= 1 && ucsOperatorId + '/' || '') + (lang || 'en') + '/' + (matchId || 0) + '/match-odds' + ((!apiVersion || !ucsOperatorId || apiVersion < 1) && '/' + providerId || '') + (bettingTypeId && '/' + bettingTypeId || '') + (eventPartId && '/' + eventPartId || '');
        }

    });
}

/***/ }),

/***/ 323:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = match;
function match(api) {
    api.provideOMFETopic('subscribeToMatch', 'unsubscribeFromMatch', {
        topicName: function topicName(_ref) {
            var ucsOperatorId = _ref.ucsOperatorId,
                apiVersion = _ref.apiVersion,
                lang = _ref.lang,
                matchId = _ref.matchId;
            return '/sports/' + (apiVersion && ucsOperatorId && apiVersion >= 1 && ucsOperatorId + '/' || '') + (lang || 'en') + '/match/' + (matchId || 0);
        }
    });
}

/***/ }),

/***/ 324:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = matchOdds;
function matchOdds(api) {
    api.provideOMFETopic('subscribeToSingleOdds', 'unsubscribeFromSingleOdds', {
        topicName: function topicName(_ref) {
            var ucsOperatorId = _ref.ucsOperatorId,
                apiVersion = _ref.apiVersion,
                lang = _ref.lang,
                oddsId = _ref.oddsId;
            return '/sports/' + (apiVersion && ucsOperatorId && apiVersion >= 1 && ucsOperatorId + '/' || '') + (lang || 'en') + '/odd/' + (oddsId || 0);
        }
    });
}

/***/ }),

/***/ 325:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = sportsBannerData;
function sportsBannerData(api) {
    api.provideOMFETopic('subscribeToOddsBannerData', 'unsubscribeFromOddsBannerData', {
        topicName: function topicName(_ref) {
            var ucsOperatorId = _ref.ucsOperatorId,
                apiVersion = _ref.apiVersion,
                lang = _ref.lang,
                operatorId = _ref.operatorId;
            return '/sports/' + (apiVersion && ucsOperatorId && apiVersion >= 1 && ucsOperatorId + '/' || '') + (lang || 'en') + '/sportsBannerData' + ((!apiVersion || !ucsOperatorId || apiVersion < 1) && '/' + operatorId || '');
        }
    });
}

/***/ }),

/***/ 326:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _provideCall3 = __webpack_require__(311);

var _provideCall4 = _interopRequireDefault(_provideCall3);

var _provideOMFETopic3 = __webpack_require__(312);

var _provideOMFETopic4 = _interopRequireDefault(_provideOMFETopic3);

var _rpcOperatorInfo = __webpack_require__(320);

var _rpcOperatorInfo2 = _interopRequireDefault(_rpcOperatorInfo);

var _rpcDisciplines = __webpack_require__(313);

var _rpcDisciplines2 = _interopRequireDefault(_rpcDisciplines);

var _rpcEventParts = __webpack_require__(316);

var _rpcEventParts2 = _interopRequireDefault(_rpcEventParts);

var _rpcEventInfoTypeUsage = __webpack_require__(314);

var _rpcEventInfoTypeUsage2 = _interopRequireDefault(_rpcEventInfoTypeUsage);

var _rpcEventPartDefaultUsage = __webpack_require__(315);

var _rpcEventPartDefaultUsage2 = _interopRequireDefault(_rpcEventPartDefaultUsage);

var _rpcNextMatches = __webpack_require__(319);

var _rpcNextMatches2 = _interopRequireDefault(_rpcNextMatches);

var _rpcMatches = __webpack_require__(318);

var _rpcMatches2 = _interopRequireDefault(_rpcMatches);

var _subSportsBannerData = __webpack_require__(325);

var _subSportsBannerData2 = _interopRequireDefault(_subSportsBannerData);

var _subMatch = __webpack_require__(323);

var _subMatch2 = _interopRequireDefault(_subMatch);

var _subEventInfo = __webpack_require__(321);

var _subEventInfo2 = _interopRequireDefault(_subEventInfo);

var _subMatchOdds = __webpack_require__(322);

var _subMatchOdds2 = _interopRequireDefault(_subMatchOdds);

var _rpcInitialDump = __webpack_require__(317);

var _rpcInitialDump2 = _interopRequireDefault(_rpcInitialDump);

var _subSingleOdds = __webpack_require__(324);

var _subSingleOdds2 = _interopRequireDefault(_subSingleOdds);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /**
                                                                                                                                                           * Exposed API through OMFECore.api.doSomething()
                                                                                                                                                           */


var currentUUID = Date.now();

var api = function () {
    function api() {
        _classCallCheck(this, api);
    }

    /**
     * Creates UUIDs for Requests
     */
    api.createClientRequestId = function createClientRequestId() {
        return (++currentUUID).toString(16);
    };

    /**
     * Installs a callable on the API Object
     */


    api.addMethod = function addMethod() {
        var methodName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        var actualMethod = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

        if (!methodName || typeof methodName !== 'string' || !methodName.length) {
            throw new Error('Invalid method name supplied: ' + methodName);
        }

        if (typeof actualMethod !== 'function') {
            throw new Error('Invalid parameter supplied to `addMethod` - must be callable');
        }

        if (this[methodName]) {
            throw new Error('Method ' + methodName + ' already installed on API');
        }

        Object.defineProperty(this, methodName, {
            enumerable: true,
            configurable: false,
            get: function get() {
                return actualMethod;
            },
            set: function set() {}
        });
    };

    /**
     * Creates a new method in the API that executes a specific RPC on the server
     */


    api.provideCall = function provideCall() {
        var _provideCall2 = _provideCall4.default.apply(undefined, arguments),
            callMethodName = _provideCall2.callMethodName,
            call = _provideCall2.call,
            cancelCallMethodName = _provideCall2.cancelCallMethodName,
            cancelCall = _provideCall2.cancelCall;

        this.addMethod(callMethodName, call);
        this.addMethod(cancelCallMethodName, cancelCall);
    };

    // Handlers - call a function every time calls list is updated


    api.onPendingCallsUpdate = function onPendingCallsUpdate() {
        return _provideCall3.onPendingCallsUpdate.apply(undefined, arguments);
    };

    /**
     * Creates a new method in the API that performs an OMFE registration & initial dump
     */


    api.provideOMFETopic = function provideOMFETopic() {
        var _provideOMFETopic2 = _provideOMFETopic4.default.apply(undefined, arguments),
            subscribeMethodName = _provideOMFETopic2.subscribeMethodName,
            subscribe = _provideOMFETopic2.subscribe,
            unsubscribeMethodName = _provideOMFETopic2.unsubscribeMethodName,
            unsubscribe = _provideOMFETopic2.unsubscribe;

        this.addMethod(subscribeMethodName, subscribe);
        this.addMethod(unsubscribeMethodName, unsubscribe);
    };

    // Handlers 1 - call a function every time subscribers list is updated


    api.onSubscribersUpdate = function onSubscribersUpdate() {
        return _provideOMFETopic3.onSubscribersUpdate.apply(undefined, arguments);
    };

    // Handlers 2 - call a function every time subscriptions list is updated; subscriptions list is basically subscribers merged


    api.onSubscriptionsUpdate = function onSubscriptionsUpdate() {
        return _provideOMFETopic3.onSubscriptionsUpdate.apply(undefined, arguments);
    };

    return api;
}();

/**
 * Install All the Methods on the Singleton
 *
 */
/* eslint import/newline-after-import: 0 */


exports.default = api;

(0, _rpcOperatorInfo2.default)(api);

(0, _rpcDisciplines2.default)(api);

(0, _rpcEventParts2.default)(api);

(0, _rpcEventInfoTypeUsage2.default)(api);

(0, _rpcEventPartDefaultUsage2.default)(api);

(0, _rpcNextMatches2.default)(api);

(0, _rpcMatches2.default)(api);

(0, _subSportsBannerData2.default)(api);

(0, _subMatch2.default)(api);

(0, _subEventInfo2.default)(api);

(0, _subMatchOdds2.default)(api);

(0, _rpcInitialDump2.default)(api);

(0, _subSingleOdds2.default)(api);

/***/ }),

/***/ 327:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.setDefaultConnectionSettings = setDefaultConnectionSettings;
exports.updateConnectionSettings = updateConnectionSettings;

var _connection = __webpack_require__(71);

/**
 * Set Default Connection Settings
 */
var currentConfig = {};
var hasDefaults = false;
function setDefaultConnectionSettings(webapiEndpoint, webapiFallbackEndpoint, webapiDomain) {
    if (hasDefaults) {
        return false;
    }

    if (!webapiEndpoint && !webapiFallbackEndpoint && webapiDomain) {
        return false;
    }

    // save defaults
    currentConfig.webapiEndpoint = webapiEndpoint;
    currentConfig.webapiFallbackEndpoint = webapiFallbackEndpoint;
    currentConfig.webapiDomain = webapiDomain;
    hasDefaults = true;

    // with enough settings, we can now connect
    if ((0, _connection.isConnected)() || (0, _connection.isConnecting)()) {
        return true;
    }

    // let's do that
    var transports = [];
    if (webapiEndpoint) {
        transports.push({ type: 'websocket', url: webapiEndpoint });
    }
    if (webapiFallbackEndpoint) {
        transports.push({ type: 'longpoll', url: webapiFallbackEndpoint });
    }
    if (webapiDomain && transports.length) {
        (0, _connection.connect)({
            realm: webapiDomain,
            transports: transports
        });
    }

    return true;
}

function updateConnectionSettings(webapiEndpoint, webapiFallbackEndpoint, webapiDomain) {
    // do we have at least one relevant setting?
    if (!webapiEndpoint && !webapiFallbackEndpoint && !webapiDomain) {
        return;
    }

    // did at least one of those settings change?
    if (webapiEndpoint === currentConfig.webapiEndpoint && webapiFallbackEndpoint === currentConfig.webapiFallbackEndpoint && webapiDomain === currentConfig.webapiDomain) {
        return;
    }

    // save new settings
    currentConfig.webapiEndpoint = webapiEndpoint;
    currentConfig.webapiFallbackEndpoint = webapiFallbackEndpoint;
    currentConfig.webapiDomain = webapiDomain;

    // attempt a new connection
    var transports = [];

    if (webapiEndpoint) {
        transports.push({ type: 'websocket', url: webapiEndpoint });
    }

    if (webapiFallbackEndpoint) {
        transports.push({ type: 'longpoll', url: webapiFallbackEndpoint });
    }

    // abide by shared-session connect/disconnect pattern - connect call updates connection settings internally
    if (webapiDomain && transports.length) {
        var shouldDisconnect = (0, _connection.isConnected)() || (0, _connection.isConnecting)();
        (0, _connection.connect)({ transports: transports, realm: webapiDomain });
        if (shouldDisconnect) {
            (0, _connection.disconnect)();
        }
    }
}

/***/ }),

/***/ 328:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.onTx = onTx;
exports.onRx = onRx;

var _connection = __webpack_require__(71);

/**
 * Additional Handlers
 */
var handlersIndex = 0;
var onTxHandlers = {};
var onRxHandlers = {};

// Logic to attach a handler
function addHandler() {
    var handlers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var fn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

    var handlerIndex = ++handlersIndex;
    var targetHandlers = handlers;
    targetHandlers[handlerIndex] = fn;
    return function () {
        delete targetHandlers[handlerIndex];
    };
}

// Logic to call all attached handlers
function callHandlers() {
    var handlers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    for (var _iterator = Object.keys(handlers), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref;

        if (_isArray) {
            if (_i >= _iterator.length) break;
            _ref = _iterator[_i++];
        } else {
            _i = _iterator.next();
            if (_i.done) break;
            _ref = _i.value;
        }

        var handlerIndex = _ref;

        if (typeof handlers[handlerIndex] === 'function') {
            handlers[handlerIndex].apply(handlers, params);
        }
    }
}

/**
 * Attach callHandlers to session
 */
function attachHandlers() {
    var session = (0, _connection.getSession)();
    if (!session) {
        return false;
    }

    var socket = '_socket';
    if (session && session[socket]) {
        if (typeof session[socket].onmessage === 'function') {
            var onmessage = session[socket].onmessage;
            session[socket].onmessage = function () {
                for (var _len = arguments.length, params = Array(_len), _key = 0; _key < _len; _key++) {
                    params[_key] = arguments[_key];
                }

                onmessage.apply(undefined, params);
                callHandlers(onRxHandlers, params);
            };
        }

        if (typeof session[socket].send === 'function') {
            var send = session[socket].send;
            session[socket].send = function () {
                for (var _len2 = arguments.length, params = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                    params[_key2] = arguments[_key2];
                }

                send.apply(undefined, params);
                callHandlers(onTxHandlers, params);
            };
        }
    }

    return true;
}
(0, _connection.onConnect)(function () {
    return attachHandlers();
});
if ((0, _connection.isConnected)()) {
    attachHandlers();
}

/**
 * onTx - On data transmitted
 */
function onTx(fn) {
    return addHandler(onTxHandlers, fn);
}

/**
 * onRx = On data received
 */
function onRx(fn) {
    return addHandler(onRxHandlers, fn);
}

/***/ }),

/***/ 329:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.jsonpConst = undefined;
exports.jsonpCall = jsonpCall;
exports.jsonpSubscribe = jsonpSubscribe;
exports.jsonpUnsubscribe = jsonpUnsubscribe;

var _store = __webpack_require__(89);

// @TODO: jquery-style data/params

/**
 * Constants
 */
var jsonpConst = exports.jsonpConst = {
    DEFAULT_TIMEOUT: 30 * 1000, // default timeout in seconds
    MIN_POLLING_INTERVAL: 0.5 * 1000 // default jsonp subscription interval
};

/**
 * Where to attach script tags
 */
/* eslint no-param-reassign:0,no-use-before-define:0 */
var scriptTarget = null;

/**
 * pollSubsriptions - goes through all subscriptions
 */
// subscribe/unsubscribe jsonp (traditional HTTP polling)
var subscriptions = new Map();
var subscriptionInterval = false;
function pollSubsriptions() {
    // stop interval if there are no more subscriptions
    if (!subscriptions.size) {
        clearInterval(subscriptionInterval);
        subscriptionInterval = false;
    }

    var timestamp = Date.now && Date.now() || new Date().getTime();
    subscriptions.forEach(function (subscription) {
        var url = subscription.url,
            funcParam = subscription.funcParam,
            timeout = subscription.timeout,
            handler = subscription.handler,
            errorHandler = subscription.errorHandler,
            interval = subscription.interval,
            lastCall = subscription.lastCall,
            pending = subscription.pending;


        if (pending || lastCall + interval > timestamp) {
            return;
        }

        subscription.pending = true;
        subscription.lastCall = timestamp;
        jsonpCall(url, funcParam, timeout).then(function (result) {
            subscription.pending = false;
            handler(result);
        }, function (error) {
            subscription.pending = false;
            // jsonpUnsubscribe(subscription.id); // @TODO: support failOnError?
            errorHandler(error);
        });
    });
}

/**
 * Store middlewares
 */

// jsonpCall
(0, _store.addMiddleware)(function (passedStore) {
    return function (next) {
        return function (action) {
            if (!action.types || !action.jsonpCall) {
                return next(action);
            }

            // types.request is called immediately
            if (action.types.request) {
                passedStore.dispatch({
                    type: action.types.request,
                    jsonpCall: action.jsonpCall
                });
            }

            // success and error are called as they come
            action.jsonpCall.then(function (result) {
                return action.types.success && _store.store.dispatch({ type: action.types.success, result: result });
            }, function (error) {
                return action.types.error && _store.store.dispatch({ type: action.types.error, error: error });
            });

            return next(action);
        };
    };
});

// jsonSubscribe
(0, _store.addMiddleware)(function (passedStore) {
    return function (next) {
        return function (action) {
            if (!action.types || !action.jsonpSubscribe) {
                return next(action);
            }

            // types.request is called immediately
            if (action.types.request) {
                passedStore.dispatch({
                    type: action.types.request,
                    jsonpSubscribe: action.jsonpSubscribe
                });
            }

            // dispatch update and call handler with result
            if (action.types.update) {
                var _oldHandler = action.jsonpSubscribe.handler;
                action.jsonpSubscribe.handler = function (result) {
                    _store.store.dispatch({ type: action.types.update, result: result, jsonpSubscribe: action.jsonpSubscribe });
                    return typeof _oldHandler === 'function' && _oldHandler(result);
                };
            }

            // dispatch error and call errorHandler with error
            if (action.types.error) {
                var oldErrorHandler = action.jsonpSubscribe.errorHandler;
                action.jsonpSubscribe.errorHandler = function (error) {
                    _store.store.dispatch({ type: action.types.error, error: error, jsonpSubscribe: action.jsonpSubscribe });
                    return typeof oldHandler === 'function' && oldErrorHandler(error);
                };
            }

            // all good, run the subscription
            action.jsonpSubscribe.pending = false;

            // call once anyway to have subscription values pre-populated
            pollSubsriptions();

            return next(action);
        };
    };
});

/**
 * jsonp - retrieves jsonp data
 *
 * @param  {string}             url = ''                        url of method to call
 * @param  {string}             funcParam = '%s'                substring URL callback function name
 * @param  {int}                [timeout = DEFAULT_TIMEOUT]     s/e, in seconds
 * @return {object}             Promise
 */
function jsonpCall() {
    var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var funcParam = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '%s';
    var timeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : jsonpConst.DEFAULT_TIMEOUT;

    return new Promise(function (resolve, reject) {
        // Timestamp & random factor
        var timestamp = Date.now && Date.now() || new Date().getTime();
        var generatedFunction = 'jsonp' + Math.round(timestamp + Math.random() * 1000001);

        // script tag
        var jsonpScript = null;

        // Delete window callback
        var cleanup = function cleanup() {
            scriptTarget.removeChild(jsonpScript);
            try {
                delete window[generatedFunction];
            } catch (e) {
                window[generatedFunction] = undefined; // IE8
            }
        };

        // Wait a while, then reject the promise
        var timeoutRejection = setTimeout(function () {
            cleanup();
            reject();
        }, timeout);

        // Attach generated function
        window[generatedFunction] = function (result) {
            cleanup();
            clearTimeout(timeoutRejection);
            resolve(result);
        };

        // Create <script> tag
        jsonpScript = document.createElement('script');
        jsonpScript.setAttribute('src', '' + url.replace(funcParam, generatedFunction) + (url.indexOf('?') !== -1 ? '&' : '?') + 't' + timestamp + '=' + timestamp);

        // Locate a script target
        if (scriptTarget === null) {
            scriptTarget = document.getElementsByTagName('head');
            if (!scriptTarget.length) {
                scriptTarget = document.getElementsByTagName('body');
            }

            if (!scriptTarget.length) {
                throw new Error('Could not find `head` or `body` to append JSONP script tags. ');
            }

            scriptTarget = scriptTarget[0];
        }

        // Append
        scriptTarget.appendChild(jsonpScript);
    });
}

/**
 * jsonpSubscribe - subscribe via jsonP polling
 *
 * @param  {string}     url = ''                url of method to call
 * @param  {string}     [funcParam = '%s']      url substring to replace with function called by remote script
 * @param  {function}   [handler]               function to call on success
 * @param  {function}   [errorHandler]          function to call on error (mostly timeout)
 * @param  {int}        [timeout]               timeout in seconds
 * @param  {int}        [interval]              interval in seconds at which to poll
 * @return {object}                             subscription object - use subscription.id to unsubscribe
 */
function jsonpSubscribe() {
    var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var funcParam = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '%s';
    var handler = arguments[2];
    var errorHandler = arguments[3];
    var timeout = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : jsonpConst.DEFAULT_TIMEOUT;
    var interval = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : jsonpConst.MIN_POLLING_INTERVAL;

    if (interval && interval < jsonpConst.MIN_POLLING_INTERVAL) {
        throw new Error('Minimum interval for jsonp subscriptions is ' + jsonpConst.MIN_POLLING_INTERVAL + 's');
    }

    var timestamp = Date.now && Date.now() || new Date().getTime();
    var id = 'jsonpSubscription' + Math.round(timestamp + Math.random() * 1000001);
    var subscription = {
        id: id,
        url: url,
        funcParam: funcParam,
        timeout: timeout,
        handler: handler,
        errorHandler: errorHandler,
        interval: interval,
        lastCall: 0,
        pending: true
    };

    subscriptions.set(id, subscription);

    // do we have poller up?
    if (!subscriptionInterval) {
        subscriptionInterval = setInterval(function () {
            return pollSubsriptions();
        }, jsonpConst.MIN_POLLING_INTERVAL);
    }

    //
    return subscription;
}

/**
 * jsonpUnsubscribe - unsubscribe a previous jsonp subscription
 *
 * @param  {string} id = '' subscription id to unsubscribe
 * @return {null}           nothing is returned
 */
function jsonpUnsubscribe() {
    var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    // remove subscription
    subscriptions.delete(id);
}

/***/ }),

/***/ 33:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(36);


/** Built-in value references. */
var getPrototype = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = getPrototype;


/***/ }),

/***/ 330:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.storageConst = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /**
                                                                                                                                                                                                                                                                               * Support for localStorage and sessionStorage under DAL
                                                                                                                                                                                                                                                                               */


exports.saveLocalItem = saveLocalItem;
exports.saveSessionItem = saveSessionItem;
exports.removeItem = removeItem;

var _reactAddonsUpdate = __webpack_require__(27);

var _reactAddonsUpdate2 = _interopRequireDefault(_reactAddonsUpdate);

var _store = __webpack_require__(89);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Constants
 */
var storageConst = exports.storageConst = {
    STORE_PART: 'omfe-core-data:storage',

    SAVE_LOCAL_ITEM: 'OMFE_CORE_DATA_WEBSTORAGE_SAVE_LOCAL_ITEM',
    SAVE_SESSION_ITEM: 'OMFE_CORE_DATA_WEBSTORAGE_SAVE_SESSION_ITEM',
    DELETE_ITEM: 'OMFE_CORE_DATA_WEBSTORAGE_DELETE_ITEM',

    INIT: 'OFME_CORE_DATA_WEBSTORAGE_INIT',

    INVALID_KEY_TYPE: 'Invalid key type. For performance reasons stored item keys may only be strings.',
    INVALID_VALUE_TYPE: 'Invalid value type. For performance reasons stored items may only be strings. '
};

/**
 * Default State
 * - retrieves existing objects automatically
 * - puts them in STORE_PART
 * - localStorage will overwrite sessionStorage
 */
function getItems(storage) {
    if ((typeof window === 'undefined' ? 'undefined' : _typeof(window)) !== 'object' || window === null || !window[storage] || !window[storage].getItem) {
        return {};
    }
    var engine = window[storage];
    var data = {};
    Object.keys(engine).forEach(function (key) {
        data[key] = engine.getItem(key);
    });
    return data;
}

(0, _store.addStorePart)(storageConst.STORE_PART, Object.assign({}, getItems('sessionStorage'), getItems('localStorage')));

/**
 * Reducers
 */
// save localStorage and sessionStorage items
(0, _store.addReducer)(storageConst.STORE_PART, storageConst.SAVE_LOCAL_ITEM, function () {
    var _$merge;

    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];
    return (0, _reactAddonsUpdate2.default)(state, { $merge: (_$merge = {}, _$merge[action.key] = action.value, _$merge) });
});

(0, _store.addReducer)(storageConst.STORE_PART, storageConst.SAVE_SESSION_ITEM, function () {
    var _$merge2;

    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];
    return (0, _reactAddonsUpdate2.default)(state, { $merge: (_$merge2 = {}, _$merge2[action.key] = action.value, _$merge2) });
});

// delete any item
(0, _store.addReducer)(storageConst.STORE_PART, storageConst.DELETE_ITEM, function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    var newState = Object.assign({}, state); // shallow copy
    delete newState[action.key]; // delete item
    return newState; // return
});

/**
 * saveLocalItem - Saves an item to localStorage
 *
 * @param  {string}     key         key to use
 * @param  {string}     value       value to store
 * @return {object}                 action
 */
function saveLocalItem(key, value) {
    if (typeof key !== 'string') {
        throw new Error(storageConst.INVALID_KEY_TYPE);
    }

    if (typeof value !== 'string') {
        throw new Error(storageConst.INVALID_VALUE_TYPE);
    }

    if (typeof window !== 'undefined' && window.localStorage && window.localStorage.setItem) {
        window.localStorage.setItem(key, value);
    }
    return { type: storageConst.SAVE_LOCAL_ITEM, key: key, value: value };
}

/**
 * saveSessionItem - Saves an item to sessionStorage
 *
 * @param  {string}     key         key to use
 * @param  {string}     value       value to store
 * @return {object}                 action
 */
function saveSessionItem(key, value) {
    if (typeof key !== 'string') {
        throw new Error(storageConst.INVALID_KEY_TYPE);
    }

    if (typeof value !== 'string') {
        throw new Error(storageConst.INVALID_VALUE_TYPE);
    }

    if (typeof window !== 'undefined' && window.sessionStorage && window.sessionStorage.setItem) {
        window.sessionStorage.setItem(key, value);
    }
    return { type: storageConst.SAVE_SESSION_ITEM, key: key, value: value };
}

/**
 * deleteItem - Removes an item from both localStorage and sessionStorage
 *
 * @param  {string}     key     item key to remove
 * @return {object}             action
 */
function removeItem(key) {
    if (typeof key !== 'string') {
        throw new Error(storageConst.INVALID_KEY_TYPE);
    }

    if (typeof window !== 'undefined' && window.localStorage && window.localStorage.removeItem) {
        window.localStorage.removeItem(key);
    }
    if (typeof window !== 'undefined' && window.sessionStorage && window.sessionStorage.removeItem) {
        window.sessionStorage.removeItem(key);
    }
    return { type: storageConst.DELETE_ITEM, key: key };
}

/***/ }),

/***/ 331:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.userTimezone = exports.moment = undefined;

var _momentTimezone = __webpack_require__(438);

var moment = _interopRequireWildcard(_momentTimezone);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

moment.tz.load({
    version: '2016fc-gmto',
    zones: ['GMT-0|GMT|0|0|', 'GMT-1|GMT-1|10|0|', 'GMT-2|GMT-2|20|0|', 'GMT-3|GMT-3|30|0|', 'GMT-4|GMT-4|40|0|', 'GMT-5|GMT-5|50|0|', 'GMT-6|GMT-6|60|0|', 'GMT-7|GMT-7|70|0|', 'GMT-8|GMT-8|80|0|', 'GMT-9|GMT-9|90|0|', 'GMT-10|GMT-10|a0|0|', 'GMT-11|GMT-11|b0|0|', 'GMT-12|GMT-12|c0|0|', 'GMT-13|GMT-13|d0|0|', 'GMT-14|GMT-14|e0|0|', 'GMT+1|GMT+1|-10|0|', 'GMT+2|GMT+2|-20|0|', 'GMT+3|GMT+3|-30|0|', 'GMT+4|GMT+4|-40|0|', 'GMT+5|GMT+5|-50|0|', 'GMT+6|GMT+6|-60|0|', 'GMT+7|GMT+7|-70|0|', 'GMT+8|GMT+8|-80|0|', 'GMT+9|GMT+9|-90|0|', 'GMT+10|GMT+10|-a0|0|', 'GMT+11|GMT+11|-b0|0|', 'GMT+12|GMT+12|-c0|0|', 'GMT+13|GMT+13|-d0|0|', 'GMT+14|GMT+14|-e0|0|'],
    links: ['GMT+0|GMT', 'GMT+0|GMT-0', 'GMT+0|GMT0', 'GMT+0|GMT', 'GMT+0|GMT+0', 'GMT+0|GMT-0', 'GMT+0|GMT0']
}); /**
    * This file initializes/exposes vendor libraries
    */

/* eslint import/prefer-default-export: 0 */


var GMTOffset = ~~(0 - new Date().getTimezoneOffset() / 60);
var userTimezone = 'GMT' + (GMTOffset > 0 && '+' + GMTOffset || GMTOffset < 0 && GMTOffset || '');
moment.tz.setDefault(userTimezone);

exports.moment = moment;
exports.userTimezone = userTimezone;

/***/ }),

/***/ 34:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(17);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = getRawTag;


/***/ }),

/***/ 35:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = objectToString;


/***/ }),

/***/ 36:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = overArg;


/***/ }),

/***/ 37:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(32);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = root;


/***/ }),

/***/ 38:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = isObjectLike;


/***/ }),

/***/ 39:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__(19);
/* harmony export (immutable) */ __webpack_exports__["a"] = applyMiddleware;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = __WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */].apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/***/ }),

/***/ 40:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bindActionCreators;
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/***/ }),

/***/ 41:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_warning__ = __webpack_require__(21);
/* harmony export (immutable) */ __webpack_exports__["a"] = combineReducers;




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === __WEBPACK_IMPORTED_MODULE_0__createStore__["b" /* ActionTypes */].INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__["a" /* default */])(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerSanity(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: __WEBPACK_IMPORTED_MODULE_0__createStore__["b" /* ActionTypes */].INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + __WEBPACK_IMPORTED_MODULE_0__createStore__["b" /* ActionTypes */].INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  if (false) {
    var unexpectedKeyCache = {};
  }

  var sanityError;
  try {
    assertReducerSanity(finalReducers);
  } catch (e) {
    sanityError = e;
  }

  return function combination() {
    var state = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
    var action = arguments[1];

    if (sanityError) {
      throw sanityError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var i = 0; i < finalReducerKeys.length; i++) {
      var key = finalReducerKeys[i];
      var reducer = finalReducers[key];
      var previousStateForKey = state[key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(key, action);
        throw new Error(errorMessage);
      }
      nextState[key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

/***/ }),

/***/ 42:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(43);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["a"] = result;

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(14), __webpack_require__(45)(module)))

/***/ }),

/***/ 43:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),

/***/ 438:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//! moment-timezone.js
//! version : 0.5.11
//! Copyright (c) JS Foundation and other contributors
//! license : MIT
//! github.com/moment/moment-timezone
!function(a,b){"use strict"; true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(439)], __WEBPACK_AMD_DEFINE_FACTORY__ = (b),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"object"==typeof module&&module.exports?module.exports=b(require("moment")):b(a.moment)}(this,function(a){"use strict";function b(a){return a>96?a-87:a>64?a-29:a-48}function c(a){var c,d=0,e=a.split("."),f=e[0],g=e[1]||"",h=1,i=0,j=1;for(45===a.charCodeAt(0)&&(d=1,j=-1),d;d<f.length;d++)c=b(f.charCodeAt(d)),i=60*i+c;for(d=0;d<g.length;d++)h/=60,c=b(g.charCodeAt(d)),i+=c*h;return i*j}function d(a){for(var b=0;b<a.length;b++)a[b]=c(a[b])}function e(a,b){for(var c=0;c<b;c++)a[c]=Math.round((a[c-1]||0)+6e4*a[c]);a[b-1]=1/0}function f(a,b){var c,d=[];for(c=0;c<b.length;c++)d[c]=a[b[c]];return d}function g(a){var b=a.split("|"),c=b[2].split(" "),g=b[3].split(""),h=b[4].split(" ");return d(c),d(g),d(h),e(h,g.length),{name:b[0],abbrs:f(b[1].split(" "),g),offsets:f(c,g),untils:h,population:0|b[5]}}function h(a){a&&this._set(g(a))}function i(a){var b=a.toTimeString(),c=b.match(/\([a-z ]+\)/i);c&&c[0]?(c=c[0].match(/[A-Z]/g),c=c?c.join(""):void 0):(c=b.match(/[A-Z]{3,5}/g),c=c?c[0]:void 0),"GMT"===c&&(c=void 0),this.at=+a,this.abbr=c,this.offset=a.getTimezoneOffset()}function j(a){this.zone=a,this.offsetScore=0,this.abbrScore=0}function k(a,b){for(var c,d;d=6e4*((b.at-a.at)/12e4|0);)c=new i(new Date(a.at+d)),c.offset===a.offset?a=c:b=c;return a}function l(){var a,b,c,d=(new Date).getFullYear()-2,e=new i(new Date(d,0,1)),f=[e];for(c=1;c<48;c++)b=new i(new Date(d,c,1)),b.offset!==e.offset&&(a=k(e,b),f.push(a),f.push(new i(new Date(a.at+6e4)))),e=b;for(c=0;c<4;c++)f.push(new i(new Date(d+c,0,1))),f.push(new i(new Date(d+c,6,1)));return f}function m(a,b){return a.offsetScore!==b.offsetScore?a.offsetScore-b.offsetScore:a.abbrScore!==b.abbrScore?a.abbrScore-b.abbrScore:b.zone.population-a.zone.population}function n(a,b){var c,e;for(d(b),c=0;c<b.length;c++)e=b[c],I[e]=I[e]||{},I[e][a]=!0}function o(a){var b,c,d,e=a.length,f={},g=[];for(b=0;b<e;b++){d=I[a[b].offset]||{};for(c in d)d.hasOwnProperty(c)&&(f[c]=!0)}for(b in f)f.hasOwnProperty(b)&&g.push(H[b]);return g}function p(){try{var a=Intl.DateTimeFormat().resolvedOptions().timeZone;if(a){var b=H[r(a)];if(b)return b;z("Moment Timezone found "+a+" from the Intl api, but did not have that data loaded.")}}catch(c){}var d,e,f,g=l(),h=g.length,i=o(g),k=[];for(e=0;e<i.length;e++){for(d=new j(t(i[e]),h),f=0;f<h;f++)d.scoreOffsetAt(g[f]);k.push(d)}return k.sort(m),k.length>0?k[0].zone.name:void 0}function q(a){return D&&!a||(D=p()),D}function r(a){return(a||"").toLowerCase().replace(/\//g,"_")}function s(a){var b,c,d,e;for("string"==typeof a&&(a=[a]),b=0;b<a.length;b++)d=a[b].split("|"),c=d[0],e=r(c),F[e]=a[b],H[e]=c,d[5]&&n(e,d[2].split(" "))}function t(a,b){a=r(a);var c,d=F[a];return d instanceof h?d:"string"==typeof d?(d=new h(d),F[a]=d,d):G[a]&&b!==t&&(c=t(G[a],t))?(d=F[a]=new h,d._set(c),d.name=H[a],d):null}function u(){var a,b=[];for(a in H)H.hasOwnProperty(a)&&(F[a]||F[G[a]])&&H[a]&&b.push(H[a]);return b.sort()}function v(a){var b,c,d,e;for("string"==typeof a&&(a=[a]),b=0;b<a.length;b++)c=a[b].split("|"),d=r(c[0]),e=r(c[1]),G[d]=e,H[d]=c[0],G[e]=d,H[e]=c[1]}function w(a){s(a.zones),v(a.links),A.dataVersion=a.version}function x(a){return x.didShowError||(x.didShowError=!0,z("moment.tz.zoneExists('"+a+"') has been deprecated in favor of !moment.tz.zone('"+a+"')")),!!t(a)}function y(a){return!(!a._a||void 0!==a._tzm)}function z(a){"undefined"!=typeof console&&"function"==typeof console.error&&console.error(a)}function A(b){var c=Array.prototype.slice.call(arguments,0,-1),d=arguments[arguments.length-1],e=t(d),f=a.utc.apply(null,c);return e&&!a.isMoment(b)&&y(f)&&f.add(e.parse(f),"minutes"),f.tz(d),f}function B(a){return function(){return this._z?this._z.abbr(this):a.call(this)}}function C(a){return function(){return this._z=null,a.apply(this,arguments)}}var D,E="0.5.11",F={},G={},H={},I={},J=a.version.split("."),K=+J[0],L=+J[1];(K<2||2===K&&L<6)&&z("Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js "+a.version+". See momentjs.com"),h.prototype={_set:function(a){this.name=a.name,this.abbrs=a.abbrs,this.untils=a.untils,this.offsets=a.offsets,this.population=a.population},_index:function(a){var b,c=+a,d=this.untils;for(b=0;b<d.length;b++)if(c<d[b])return b},parse:function(a){var b,c,d,e,f=+a,g=this.offsets,h=this.untils,i=h.length-1;for(e=0;e<i;e++)if(b=g[e],c=g[e+1],d=g[e?e-1:e],b<c&&A.moveAmbiguousForward?b=c:b>d&&A.moveInvalidForward&&(b=d),f<h[e]-6e4*b)return g[e];return g[i]},abbr:function(a){return this.abbrs[this._index(a)]},offset:function(a){return this.offsets[this._index(a)]}},j.prototype.scoreOffsetAt=function(a){this.offsetScore+=Math.abs(this.zone.offset(a.at)-a.offset),this.zone.abbr(a.at).replace(/[^A-Z]/g,"")!==a.abbr&&this.abbrScore++},A.version=E,A.dataVersion="",A._zones=F,A._links=G,A._names=H,A.add=s,A.link=v,A.load=w,A.zone=t,A.zoneExists=x,A.guess=q,A.names=u,A.Zone=h,A.unpack=g,A.unpackBase60=c,A.needsOffset=y,A.moveInvalidForward=!0,A.moveAmbiguousForward=!1;var M=a.fn;a.tz=A,a.defaultZone=null,a.updateOffset=function(b,c){var d,e=a.defaultZone;void 0===b._z&&(e&&y(b)&&!b._isUTC&&(b._d=a.utc(b._a)._d,b.utc().add(e.parse(b),"minutes")),b._z=e),b._z&&(d=b._z.offset(b),Math.abs(d)<16&&(d/=60),void 0!==b.utcOffset?b.utcOffset(-d,c):b.zone(d,c))},M.tz=function(b){return b?(this._z=t(b),this._z?a.updateOffset(this):z("Moment Timezone has no data for "+b+". See http://momentjs.com/timezone/docs/#/data-loading/."),this):this._z?this._z.name:void 0},M.zoneName=B(M.zoneName),M.zoneAbbr=B(M.zoneAbbr),M.utc=C(M.utc),a.tz.setDefault=function(b){return(K<2||2===K&&L<9)&&z("Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js "+a.version+"."),a.defaultZone=b?t(b):null,a};var N=a.momentProperties;return"[object Array]"===Object.prototype.toString.call(N)?(N.push("_z"),N.push("_a")):N&&(N._z=null),a});

/***/ }),

/***/ 439:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define(t):e.moment=t()}(this,function(){"use strict";var e,i;function c(){return e.apply(null,arguments)}function o(e){return e instanceof Array||"[object Array]"===Object.prototype.toString.call(e)}function u(e){return null!=e&&"[object Object]"===Object.prototype.toString.call(e)}function l(e){return void 0===e}function d(e){return"number"==typeof e||"[object Number]"===Object.prototype.toString.call(e)}function h(e){return e instanceof Date||"[object Date]"===Object.prototype.toString.call(e)}function f(e,t){var n,s=[];for(n=0;n<e.length;++n)s.push(t(e[n],n));return s}function m(e,t){return Object.prototype.hasOwnProperty.call(e,t)}function _(e,t){for(var n in t)m(t,n)&&(e[n]=t[n]);return m(t,"toString")&&(e.toString=t.toString),m(t,"valueOf")&&(e.valueOf=t.valueOf),e}function y(e,t,n,s){return Ot(e,t,n,s,!0).utc()}function g(e){return null==e._pf&&(e._pf={empty:!1,unusedTokens:[],unusedInput:[],overflow:-2,charsLeftOver:0,nullInput:!1,invalidMonth:null,invalidFormat:!1,userInvalidated:!1,iso:!1,parsedDateParts:[],meridiem:null,rfc2822:!1,weekdayMismatch:!1}),e._pf}function p(e){if(null==e._isValid){var t=g(e),n=i.call(t.parsedDateParts,function(e){return null!=e}),s=!isNaN(e._d.getTime())&&t.overflow<0&&!t.empty&&!t.invalidMonth&&!t.invalidWeekday&&!t.weekdayMismatch&&!t.nullInput&&!t.invalidFormat&&!t.userInvalidated&&(!t.meridiem||t.meridiem&&n);if(e._strict&&(s=s&&0===t.charsLeftOver&&0===t.unusedTokens.length&&void 0===t.bigHour),null!=Object.isFrozen&&Object.isFrozen(e))return s;e._isValid=s}return e._isValid}function v(e){var t=y(NaN);return null!=e?_(g(t),e):g(t).userInvalidated=!0,t}i=Array.prototype.some?Array.prototype.some:function(e){for(var t=Object(this),n=t.length>>>0,s=0;s<n;s++)if(s in t&&e.call(this,t[s],s,t))return!0;return!1};var r=c.momentProperties=[];function w(e,t){var n,s,i;if(l(t._isAMomentObject)||(e._isAMomentObject=t._isAMomentObject),l(t._i)||(e._i=t._i),l(t._f)||(e._f=t._f),l(t._l)||(e._l=t._l),l(t._strict)||(e._strict=t._strict),l(t._tzm)||(e._tzm=t._tzm),l(t._isUTC)||(e._isUTC=t._isUTC),l(t._offset)||(e._offset=t._offset),l(t._pf)||(e._pf=g(t)),l(t._locale)||(e._locale=t._locale),0<r.length)for(n=0;n<r.length;n++)l(i=t[s=r[n]])||(e[s]=i);return e}var t=!1;function M(e){w(this,e),this._d=new Date(null!=e._d?e._d.getTime():NaN),this.isValid()||(this._d=new Date(NaN)),!1===t&&(t=!0,c.updateOffset(this),t=!1)}function S(e){return e instanceof M||null!=e&&null!=e._isAMomentObject}function D(e){return e<0?Math.ceil(e)||0:Math.floor(e)}function k(e){var t=+e,n=0;return 0!==t&&isFinite(t)&&(n=D(t)),n}function a(e,t,n){var s,i=Math.min(e.length,t.length),r=Math.abs(e.length-t.length),a=0;for(s=0;s<i;s++)(n&&e[s]!==t[s]||!n&&k(e[s])!==k(t[s]))&&a++;return a+r}function Y(e){!1===c.suppressDeprecationWarnings&&"undefined"!=typeof console&&console.warn&&console.warn("Deprecation warning: "+e)}function n(i,r){var a=!0;return _(function(){if(null!=c.deprecationHandler&&c.deprecationHandler(null,i),a){for(var e,t=[],n=0;n<arguments.length;n++){if(e="","object"==typeof arguments[n]){for(var s in e+="\n["+n+"] ",arguments[0])e+=s+": "+arguments[0][s]+", ";e=e.slice(0,-2)}else e=arguments[n];t.push(e)}Y(i+"\nArguments: "+Array.prototype.slice.call(t).join("")+"\n"+(new Error).stack),a=!1}return r.apply(this,arguments)},r)}var s,O={};function T(e,t){null!=c.deprecationHandler&&c.deprecationHandler(e,t),O[e]||(Y(t),O[e]=!0)}function x(e){return e instanceof Function||"[object Function]"===Object.prototype.toString.call(e)}function b(e,t){var n,s=_({},e);for(n in t)m(t,n)&&(u(e[n])&&u(t[n])?(s[n]={},_(s[n],e[n]),_(s[n],t[n])):null!=t[n]?s[n]=t[n]:delete s[n]);for(n in e)m(e,n)&&!m(t,n)&&u(e[n])&&(s[n]=_({},s[n]));return s}function P(e){null!=e&&this.set(e)}c.suppressDeprecationWarnings=!1,c.deprecationHandler=null,s=Object.keys?Object.keys:function(e){var t,n=[];for(t in e)m(e,t)&&n.push(t);return n};var W={};function H(e,t){var n=e.toLowerCase();W[n]=W[n+"s"]=W[t]=e}function R(e){return"string"==typeof e?W[e]||W[e.toLowerCase()]:void 0}function C(e){var t,n,s={};for(n in e)m(e,n)&&(t=R(n))&&(s[t]=e[n]);return s}var F={};function L(e,t){F[e]=t}function U(e,t,n){var s=""+Math.abs(e),i=t-s.length;return(0<=e?n?"+":"":"-")+Math.pow(10,Math.max(0,i)).toString().substr(1)+s}var N=/(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,G=/(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,V={},E={};function I(e,t,n,s){var i=s;"string"==typeof s&&(i=function(){return this[s]()}),e&&(E[e]=i),t&&(E[t[0]]=function(){return U(i.apply(this,arguments),t[1],t[2])}),n&&(E[n]=function(){return this.localeData().ordinal(i.apply(this,arguments),e)})}function A(e,t){return e.isValid()?(t=j(t,e.localeData()),V[t]=V[t]||function(s){var e,i,t,r=s.match(N);for(e=0,i=r.length;e<i;e++)E[r[e]]?r[e]=E[r[e]]:r[e]=(t=r[e]).match(/\[[\s\S]/)?t.replace(/^\[|\]$/g,""):t.replace(/\\/g,"");return function(e){var t,n="";for(t=0;t<i;t++)n+=x(r[t])?r[t].call(e,s):r[t];return n}}(t),V[t](e)):e.localeData().invalidDate()}function j(e,t){var n=5;function s(e){return t.longDateFormat(e)||e}for(G.lastIndex=0;0<=n&&G.test(e);)e=e.replace(G,s),G.lastIndex=0,n-=1;return e}var Z=/\d/,z=/\d\d/,$=/\d{3}/,q=/\d{4}/,J=/[+-]?\d{6}/,B=/\d\d?/,Q=/\d\d\d\d?/,X=/\d\d\d\d\d\d?/,K=/\d{1,3}/,ee=/\d{1,4}/,te=/[+-]?\d{1,6}/,ne=/\d+/,se=/[+-]?\d+/,ie=/Z|[+-]\d\d:?\d\d/gi,re=/Z|[+-]\d\d(?::?\d\d)?/gi,ae=/[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,oe={};function ue(e,n,s){oe[e]=x(n)?n:function(e,t){return e&&s?s:n}}function le(e,t){return m(oe,e)?oe[e](t._strict,t._locale):new RegExp(de(e.replace("\\","").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,function(e,t,n,s,i){return t||n||s||i})))}function de(e){return e.replace(/[-\/\\^$*+?.()|[\]{}]/g,"\\$&")}var he={};function ce(e,n){var t,s=n;for("string"==typeof e&&(e=[e]),d(n)&&(s=function(e,t){t[n]=k(e)}),t=0;t<e.length;t++)he[e[t]]=s}function fe(e,i){ce(e,function(e,t,n,s){n._w=n._w||{},i(e,n._w,n,s)})}var me=0,_e=1,ye=2,ge=3,pe=4,ve=5,we=6,Me=7,Se=8;function De(e){return ke(e)?366:365}function ke(e){return e%4==0&&e%100!=0||e%400==0}I("Y",0,0,function(){var e=this.year();return e<=9999?""+e:"+"+e}),I(0,["YY",2],0,function(){return this.year()%100}),I(0,["YYYY",4],0,"year"),I(0,["YYYYY",5],0,"year"),I(0,["YYYYYY",6,!0],0,"year"),H("year","y"),L("year",1),ue("Y",se),ue("YY",B,z),ue("YYYY",ee,q),ue("YYYYY",te,J),ue("YYYYYY",te,J),ce(["YYYYY","YYYYYY"],me),ce("YYYY",function(e,t){t[me]=2===e.length?c.parseTwoDigitYear(e):k(e)}),ce("YY",function(e,t){t[me]=c.parseTwoDigitYear(e)}),ce("Y",function(e,t){t[me]=parseInt(e,10)}),c.parseTwoDigitYear=function(e){return k(e)+(68<k(e)?1900:2e3)};var Ye,Oe=Te("FullYear",!0);function Te(t,n){return function(e){return null!=e?(be(this,t,e),c.updateOffset(this,n),this):xe(this,t)}}function xe(e,t){return e.isValid()?e._d["get"+(e._isUTC?"UTC":"")+t]():NaN}function be(e,t,n){e.isValid()&&!isNaN(n)&&("FullYear"===t&&ke(e.year())&&1===e.month()&&29===e.date()?e._d["set"+(e._isUTC?"UTC":"")+t](n,e.month(),Pe(n,e.month())):e._d["set"+(e._isUTC?"UTC":"")+t](n))}function Pe(e,t){if(isNaN(e)||isNaN(t))return NaN;var n,s=(t%(n=12)+n)%n;return e+=(t-s)/12,1===s?ke(e)?29:28:31-s%7%2}Ye=Array.prototype.indexOf?Array.prototype.indexOf:function(e){var t;for(t=0;t<this.length;++t)if(this[t]===e)return t;return-1},I("M",["MM",2],"Mo",function(){return this.month()+1}),I("MMM",0,0,function(e){return this.localeData().monthsShort(this,e)}),I("MMMM",0,0,function(e){return this.localeData().months(this,e)}),H("month","M"),L("month",8),ue("M",B),ue("MM",B,z),ue("MMM",function(e,t){return t.monthsShortRegex(e)}),ue("MMMM",function(e,t){return t.monthsRegex(e)}),ce(["M","MM"],function(e,t){t[_e]=k(e)-1}),ce(["MMM","MMMM"],function(e,t,n,s){var i=n._locale.monthsParse(e,s,n._strict);null!=i?t[_e]=i:g(n).invalidMonth=e});var We=/D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,He="January_February_March_April_May_June_July_August_September_October_November_December".split("_");var Re="Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_");function Ce(e,t){var n;if(!e.isValid())return e;if("string"==typeof t)if(/^\d+$/.test(t))t=k(t);else if(!d(t=e.localeData().monthsParse(t)))return e;return n=Math.min(e.date(),Pe(e.year(),t)),e._d["set"+(e._isUTC?"UTC":"")+"Month"](t,n),e}function Fe(e){return null!=e?(Ce(this,e),c.updateOffset(this,!0),this):xe(this,"Month")}var Le=ae;var Ue=ae;function Ne(){function e(e,t){return t.length-e.length}var t,n,s=[],i=[],r=[];for(t=0;t<12;t++)n=y([2e3,t]),s.push(this.monthsShort(n,"")),i.push(this.months(n,"")),r.push(this.months(n,"")),r.push(this.monthsShort(n,""));for(s.sort(e),i.sort(e),r.sort(e),t=0;t<12;t++)s[t]=de(s[t]),i[t]=de(i[t]);for(t=0;t<24;t++)r[t]=de(r[t]);this._monthsRegex=new RegExp("^("+r.join("|")+")","i"),this._monthsShortRegex=this._monthsRegex,this._monthsStrictRegex=new RegExp("^("+i.join("|")+")","i"),this._monthsShortStrictRegex=new RegExp("^("+s.join("|")+")","i")}function Ge(e){var t=new Date(Date.UTC.apply(null,arguments));return e<100&&0<=e&&isFinite(t.getUTCFullYear())&&t.setUTCFullYear(e),t}function Ve(e,t,n){var s=7+t-n;return-((7+Ge(e,0,s).getUTCDay()-t)%7)+s-1}function Ee(e,t,n,s,i){var r,a,o=1+7*(t-1)+(7+n-s)%7+Ve(e,s,i);return o<=0?a=De(r=e-1)+o:o>De(e)?(r=e+1,a=o-De(e)):(r=e,a=o),{year:r,dayOfYear:a}}function Ie(e,t,n){var s,i,r=Ve(e.year(),t,n),a=Math.floor((e.dayOfYear()-r-1)/7)+1;return a<1?s=a+Ae(i=e.year()-1,t,n):a>Ae(e.year(),t,n)?(s=a-Ae(e.year(),t,n),i=e.year()+1):(i=e.year(),s=a),{week:s,year:i}}function Ae(e,t,n){var s=Ve(e,t,n),i=Ve(e+1,t,n);return(De(e)-s+i)/7}I("w",["ww",2],"wo","week"),I("W",["WW",2],"Wo","isoWeek"),H("week","w"),H("isoWeek","W"),L("week",5),L("isoWeek",5),ue("w",B),ue("ww",B,z),ue("W",B),ue("WW",B,z),fe(["w","ww","W","WW"],function(e,t,n,s){t[s.substr(0,1)]=k(e)});I("d",0,"do","day"),I("dd",0,0,function(e){return this.localeData().weekdaysMin(this,e)}),I("ddd",0,0,function(e){return this.localeData().weekdaysShort(this,e)}),I("dddd",0,0,function(e){return this.localeData().weekdays(this,e)}),I("e",0,0,"weekday"),I("E",0,0,"isoWeekday"),H("day","d"),H("weekday","e"),H("isoWeekday","E"),L("day",11),L("weekday",11),L("isoWeekday",11),ue("d",B),ue("e",B),ue("E",B),ue("dd",function(e,t){return t.weekdaysMinRegex(e)}),ue("ddd",function(e,t){return t.weekdaysShortRegex(e)}),ue("dddd",function(e,t){return t.weekdaysRegex(e)}),fe(["dd","ddd","dddd"],function(e,t,n,s){var i=n._locale.weekdaysParse(e,s,n._strict);null!=i?t.d=i:g(n).invalidWeekday=e}),fe(["d","e","E"],function(e,t,n,s){t[s]=k(e)});var je="Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_");var Ze="Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_");var ze="Su_Mo_Tu_We_Th_Fr_Sa".split("_");var $e=ae;var qe=ae;var Je=ae;function Be(){function e(e,t){return t.length-e.length}var t,n,s,i,r,a=[],o=[],u=[],l=[];for(t=0;t<7;t++)n=y([2e3,1]).day(t),s=this.weekdaysMin(n,""),i=this.weekdaysShort(n,""),r=this.weekdays(n,""),a.push(s),o.push(i),u.push(r),l.push(s),l.push(i),l.push(r);for(a.sort(e),o.sort(e),u.sort(e),l.sort(e),t=0;t<7;t++)o[t]=de(o[t]),u[t]=de(u[t]),l[t]=de(l[t]);this._weekdaysRegex=new RegExp("^("+l.join("|")+")","i"),this._weekdaysShortRegex=this._weekdaysRegex,this._weekdaysMinRegex=this._weekdaysRegex,this._weekdaysStrictRegex=new RegExp("^("+u.join("|")+")","i"),this._weekdaysShortStrictRegex=new RegExp("^("+o.join("|")+")","i"),this._weekdaysMinStrictRegex=new RegExp("^("+a.join("|")+")","i")}function Qe(){return this.hours()%12||12}function Xe(e,t){I(e,0,0,function(){return this.localeData().meridiem(this.hours(),this.minutes(),t)})}function Ke(e,t){return t._meridiemParse}I("H",["HH",2],0,"hour"),I("h",["hh",2],0,Qe),I("k",["kk",2],0,function(){return this.hours()||24}),I("hmm",0,0,function(){return""+Qe.apply(this)+U(this.minutes(),2)}),I("hmmss",0,0,function(){return""+Qe.apply(this)+U(this.minutes(),2)+U(this.seconds(),2)}),I("Hmm",0,0,function(){return""+this.hours()+U(this.minutes(),2)}),I("Hmmss",0,0,function(){return""+this.hours()+U(this.minutes(),2)+U(this.seconds(),2)}),Xe("a",!0),Xe("A",!1),H("hour","h"),L("hour",13),ue("a",Ke),ue("A",Ke),ue("H",B),ue("h",B),ue("k",B),ue("HH",B,z),ue("hh",B,z),ue("kk",B,z),ue("hmm",Q),ue("hmmss",X),ue("Hmm",Q),ue("Hmmss",X),ce(["H","HH"],ge),ce(["k","kk"],function(e,t,n){var s=k(e);t[ge]=24===s?0:s}),ce(["a","A"],function(e,t,n){n._isPm=n._locale.isPM(e),n._meridiem=e}),ce(["h","hh"],function(e,t,n){t[ge]=k(e),g(n).bigHour=!0}),ce("hmm",function(e,t,n){var s=e.length-2;t[ge]=k(e.substr(0,s)),t[pe]=k(e.substr(s)),g(n).bigHour=!0}),ce("hmmss",function(e,t,n){var s=e.length-4,i=e.length-2;t[ge]=k(e.substr(0,s)),t[pe]=k(e.substr(s,2)),t[ve]=k(e.substr(i)),g(n).bigHour=!0}),ce("Hmm",function(e,t,n){var s=e.length-2;t[ge]=k(e.substr(0,s)),t[pe]=k(e.substr(s))}),ce("Hmmss",function(e,t,n){var s=e.length-4,i=e.length-2;t[ge]=k(e.substr(0,s)),t[pe]=k(e.substr(s,2)),t[ve]=k(e.substr(i))});var et,tt=Te("Hours",!0),nt={calendar:{sameDay:"[Today at] LT",nextDay:"[Tomorrow at] LT",nextWeek:"dddd [at] LT",lastDay:"[Yesterday at] LT",lastWeek:"[Last] dddd [at] LT",sameElse:"L"},longDateFormat:{LTS:"h:mm:ss A",LT:"h:mm A",L:"MM/DD/YYYY",LL:"MMMM D, YYYY",LLL:"MMMM D, YYYY h:mm A",LLLL:"dddd, MMMM D, YYYY h:mm A"},invalidDate:"Invalid date",ordinal:"%d",dayOfMonthOrdinalParse:/\d{1,2}/,relativeTime:{future:"in %s",past:"%s ago",s:"a few seconds",ss:"%d seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"},months:He,monthsShort:Re,week:{dow:0,doy:6},weekdays:je,weekdaysMin:ze,weekdaysShort:Ze,meridiemParse:/[ap]\.?m?\.?/i},st={},it={};function rt(e){return e?e.toLowerCase().replace("_","-"):e}function at(e){var t=null;if(!st[e]&&"undefined"!=typeof module&&module&&module.exports)try{t=et._abbr,!(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND';; throw e; }()),ot(t)}catch(e){}return st[e]}function ot(e,t){var n;return e&&((n=l(t)?lt(e):ut(e,t))?et=n:"undefined"!=typeof console&&console.warn&&console.warn("Locale "+e+" not found. Did you forget to load it?")),et._abbr}function ut(e,t){if(null!==t){var n,s=nt;if(t.abbr=e,null!=st[e])T("defineLocaleOverride","use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."),s=st[e]._config;else if(null!=t.parentLocale)if(null!=st[t.parentLocale])s=st[t.parentLocale]._config;else{if(null==(n=at(t.parentLocale)))return it[t.parentLocale]||(it[t.parentLocale]=[]),it[t.parentLocale].push({name:e,config:t}),null;s=n._config}return st[e]=new P(b(s,t)),it[e]&&it[e].forEach(function(e){ut(e.name,e.config)}),ot(e),st[e]}return delete st[e],null}function lt(e){var t;if(e&&e._locale&&e._locale._abbr&&(e=e._locale._abbr),!e)return et;if(!o(e)){if(t=at(e))return t;e=[e]}return function(e){for(var t,n,s,i,r=0;r<e.length;){for(t=(i=rt(e[r]).split("-")).length,n=(n=rt(e[r+1]))?n.split("-"):null;0<t;){if(s=at(i.slice(0,t).join("-")))return s;if(n&&n.length>=t&&a(i,n,!0)>=t-1)break;t--}r++}return et}(e)}function dt(e){var t,n=e._a;return n&&-2===g(e).overflow&&(t=n[_e]<0||11<n[_e]?_e:n[ye]<1||n[ye]>Pe(n[me],n[_e])?ye:n[ge]<0||24<n[ge]||24===n[ge]&&(0!==n[pe]||0!==n[ve]||0!==n[we])?ge:n[pe]<0||59<n[pe]?pe:n[ve]<0||59<n[ve]?ve:n[we]<0||999<n[we]?we:-1,g(e)._overflowDayOfYear&&(t<me||ye<t)&&(t=ye),g(e)._overflowWeeks&&-1===t&&(t=Me),g(e)._overflowWeekday&&-1===t&&(t=Se),g(e).overflow=t),e}function ht(e,t,n){return null!=e?e:null!=t?t:n}function ct(e){var t,n,s,i,r,a=[];if(!e._d){var o,u;for(o=e,u=new Date(c.now()),s=o._useUTC?[u.getUTCFullYear(),u.getUTCMonth(),u.getUTCDate()]:[u.getFullYear(),u.getMonth(),u.getDate()],e._w&&null==e._a[ye]&&null==e._a[_e]&&function(e){var t,n,s,i,r,a,o,u;if(null!=(t=e._w).GG||null!=t.W||null!=t.E)r=1,a=4,n=ht(t.GG,e._a[me],Ie(Tt(),1,4).year),s=ht(t.W,1),((i=ht(t.E,1))<1||7<i)&&(u=!0);else{r=e._locale._week.dow,a=e._locale._week.doy;var l=Ie(Tt(),r,a);n=ht(t.gg,e._a[me],l.year),s=ht(t.w,l.week),null!=t.d?((i=t.d)<0||6<i)&&(u=!0):null!=t.e?(i=t.e+r,(t.e<0||6<t.e)&&(u=!0)):i=r}s<1||s>Ae(n,r,a)?g(e)._overflowWeeks=!0:null!=u?g(e)._overflowWeekday=!0:(o=Ee(n,s,i,r,a),e._a[me]=o.year,e._dayOfYear=o.dayOfYear)}(e),null!=e._dayOfYear&&(r=ht(e._a[me],s[me]),(e._dayOfYear>De(r)||0===e._dayOfYear)&&(g(e)._overflowDayOfYear=!0),n=Ge(r,0,e._dayOfYear),e._a[_e]=n.getUTCMonth(),e._a[ye]=n.getUTCDate()),t=0;t<3&&null==e._a[t];++t)e._a[t]=a[t]=s[t];for(;t<7;t++)e._a[t]=a[t]=null==e._a[t]?2===t?1:0:e._a[t];24===e._a[ge]&&0===e._a[pe]&&0===e._a[ve]&&0===e._a[we]&&(e._nextDay=!0,e._a[ge]=0),e._d=(e._useUTC?Ge:function(e,t,n,s,i,r,a){var o=new Date(e,t,n,s,i,r,a);return e<100&&0<=e&&isFinite(o.getFullYear())&&o.setFullYear(e),o}).apply(null,a),i=e._useUTC?e._d.getUTCDay():e._d.getDay(),null!=e._tzm&&e._d.setUTCMinutes(e._d.getUTCMinutes()-e._tzm),e._nextDay&&(e._a[ge]=24),e._w&&void 0!==e._w.d&&e._w.d!==i&&(g(e).weekdayMismatch=!0)}}var ft=/^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/,mt=/^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/,_t=/Z|[+-]\d\d(?::?\d\d)?/,yt=[["YYYYYY-MM-DD",/[+-]\d{6}-\d\d-\d\d/],["YYYY-MM-DD",/\d{4}-\d\d-\d\d/],["GGGG-[W]WW-E",/\d{4}-W\d\d-\d/],["GGGG-[W]WW",/\d{4}-W\d\d/,!1],["YYYY-DDD",/\d{4}-\d{3}/],["YYYY-MM",/\d{4}-\d\d/,!1],["YYYYYYMMDD",/[+-]\d{10}/],["YYYYMMDD",/\d{8}/],["GGGG[W]WWE",/\d{4}W\d{3}/],["GGGG[W]WW",/\d{4}W\d{2}/,!1],["YYYYDDD",/\d{7}/]],gt=[["HH:mm:ss.SSSS",/\d\d:\d\d:\d\d\.\d+/],["HH:mm:ss,SSSS",/\d\d:\d\d:\d\d,\d+/],["HH:mm:ss",/\d\d:\d\d:\d\d/],["HH:mm",/\d\d:\d\d/],["HHmmss.SSSS",/\d\d\d\d\d\d\.\d+/],["HHmmss,SSSS",/\d\d\d\d\d\d,\d+/],["HHmmss",/\d\d\d\d\d\d/],["HHmm",/\d\d\d\d/],["HH",/\d\d/]],pt=/^\/?Date\((\-?\d+)/i;function vt(e){var t,n,s,i,r,a,o=e._i,u=ft.exec(o)||mt.exec(o);if(u){for(g(e).iso=!0,t=0,n=yt.length;t<n;t++)if(yt[t][1].exec(u[1])){i=yt[t][0],s=!1!==yt[t][2];break}if(null==i)return void(e._isValid=!1);if(u[3]){for(t=0,n=gt.length;t<n;t++)if(gt[t][1].exec(u[3])){r=(u[2]||" ")+gt[t][0];break}if(null==r)return void(e._isValid=!1)}if(!s&&null!=r)return void(e._isValid=!1);if(u[4]){if(!_t.exec(u[4]))return void(e._isValid=!1);a="Z"}e._f=i+(r||"")+(a||""),kt(e)}else e._isValid=!1}var wt=/^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;function Mt(e,t,n,s,i,r){var a=[function(e){var t=parseInt(e,10);{if(t<=49)return 2e3+t;if(t<=999)return 1900+t}return t}(e),Re.indexOf(t),parseInt(n,10),parseInt(s,10),parseInt(i,10)];return r&&a.push(parseInt(r,10)),a}var St={UT:0,GMT:0,EDT:-240,EST:-300,CDT:-300,CST:-360,MDT:-360,MST:-420,PDT:-420,PST:-480};function Dt(e){var t,n,s,i=wt.exec(e._i.replace(/\([^)]*\)|[\n\t]/g," ").replace(/(\s\s+)/g," ").replace(/^\s\s*/,"").replace(/\s\s*$/,""));if(i){var r=Mt(i[4],i[3],i[2],i[5],i[6],i[7]);if(t=i[1],n=r,s=e,t&&Ze.indexOf(t)!==new Date(n[0],n[1],n[2]).getDay()&&(g(s).weekdayMismatch=!0,!(s._isValid=!1)))return;e._a=r,e._tzm=function(e,t,n){if(e)return St[e];if(t)return 0;var s=parseInt(n,10),i=s%100;return(s-i)/100*60+i}(i[8],i[9],i[10]),e._d=Ge.apply(null,e._a),e._d.setUTCMinutes(e._d.getUTCMinutes()-e._tzm),g(e).rfc2822=!0}else e._isValid=!1}function kt(e){if(e._f!==c.ISO_8601)if(e._f!==c.RFC_2822){e._a=[],g(e).empty=!0;var t,n,s,i,r,a,o,u,l=""+e._i,d=l.length,h=0;for(s=j(e._f,e._locale).match(N)||[],t=0;t<s.length;t++)i=s[t],(n=(l.match(le(i,e))||[])[0])&&(0<(r=l.substr(0,l.indexOf(n))).length&&g(e).unusedInput.push(r),l=l.slice(l.indexOf(n)+n.length),h+=n.length),E[i]?(n?g(e).empty=!1:g(e).unusedTokens.push(i),a=i,u=e,null!=(o=n)&&m(he,a)&&he[a](o,u._a,u,a)):e._strict&&!n&&g(e).unusedTokens.push(i);g(e).charsLeftOver=d-h,0<l.length&&g(e).unusedInput.push(l),e._a[ge]<=12&&!0===g(e).bigHour&&0<e._a[ge]&&(g(e).bigHour=void 0),g(e).parsedDateParts=e._a.slice(0),g(e).meridiem=e._meridiem,e._a[ge]=function(e,t,n){var s;if(null==n)return t;return null!=e.meridiemHour?e.meridiemHour(t,n):(null!=e.isPM&&((s=e.isPM(n))&&t<12&&(t+=12),s||12!==t||(t=0)),t)}(e._locale,e._a[ge],e._meridiem),ct(e),dt(e)}else Dt(e);else vt(e)}function Yt(e){var t,n,s,i,r=e._i,a=e._f;return e._locale=e._locale||lt(e._l),null===r||void 0===a&&""===r?v({nullInput:!0}):("string"==typeof r&&(e._i=r=e._locale.preparse(r)),S(r)?new M(dt(r)):(h(r)?e._d=r:o(a)?function(e){var t,n,s,i,r;if(0===e._f.length)return g(e).invalidFormat=!0,e._d=new Date(NaN);for(i=0;i<e._f.length;i++)r=0,t=w({},e),null!=e._useUTC&&(t._useUTC=e._useUTC),t._f=e._f[i],kt(t),p(t)&&(r+=g(t).charsLeftOver,r+=10*g(t).unusedTokens.length,g(t).score=r,(null==s||r<s)&&(s=r,n=t));_(e,n||t)}(e):a?kt(e):l(n=(t=e)._i)?t._d=new Date(c.now()):h(n)?t._d=new Date(n.valueOf()):"string"==typeof n?(s=t,null===(i=pt.exec(s._i))?(vt(s),!1===s._isValid&&(delete s._isValid,Dt(s),!1===s._isValid&&(delete s._isValid,c.createFromInputFallback(s)))):s._d=new Date(+i[1])):o(n)?(t._a=f(n.slice(0),function(e){return parseInt(e,10)}),ct(t)):u(n)?function(e){if(!e._d){var t=C(e._i);e._a=f([t.year,t.month,t.day||t.date,t.hour,t.minute,t.second,t.millisecond],function(e){return e&&parseInt(e,10)}),ct(e)}}(t):d(n)?t._d=new Date(n):c.createFromInputFallback(t),p(e)||(e._d=null),e))}function Ot(e,t,n,s,i){var r,a={};return!0!==n&&!1!==n||(s=n,n=void 0),(u(e)&&function(e){if(Object.getOwnPropertyNames)return 0===Object.getOwnPropertyNames(e).length;var t;for(t in e)if(e.hasOwnProperty(t))return!1;return!0}(e)||o(e)&&0===e.length)&&(e=void 0),a._isAMomentObject=!0,a._useUTC=a._isUTC=i,a._l=n,a._i=e,a._f=t,a._strict=s,(r=new M(dt(Yt(a))))._nextDay&&(r.add(1,"d"),r._nextDay=void 0),r}function Tt(e,t,n,s){return Ot(e,t,n,s,!1)}c.createFromInputFallback=n("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged and will be removed in an upcoming major release. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.",function(e){e._d=new Date(e._i+(e._useUTC?" UTC":""))}),c.ISO_8601=function(){},c.RFC_2822=function(){};var xt=n("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/",function(){var e=Tt.apply(null,arguments);return this.isValid()&&e.isValid()?e<this?this:e:v()}),bt=n("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/",function(){var e=Tt.apply(null,arguments);return this.isValid()&&e.isValid()?this<e?this:e:v()});function Pt(e,t){var n,s;if(1===t.length&&o(t[0])&&(t=t[0]),!t.length)return Tt();for(n=t[0],s=1;s<t.length;++s)t[s].isValid()&&!t[s][e](n)||(n=t[s]);return n}var Wt=["year","quarter","month","week","day","hour","minute","second","millisecond"];function Ht(e){var t=C(e),n=t.year||0,s=t.quarter||0,i=t.month||0,r=t.week||0,a=t.day||0,o=t.hour||0,u=t.minute||0,l=t.second||0,d=t.millisecond||0;this._isValid=function(e){for(var t in e)if(-1===Ye.call(Wt,t)||null!=e[t]&&isNaN(e[t]))return!1;for(var n=!1,s=0;s<Wt.length;++s)if(e[Wt[s]]){if(n)return!1;parseFloat(e[Wt[s]])!==k(e[Wt[s]])&&(n=!0)}return!0}(t),this._milliseconds=+d+1e3*l+6e4*u+1e3*o*60*60,this._days=+a+7*r,this._months=+i+3*s+12*n,this._data={},this._locale=lt(),this._bubble()}function Rt(e){return e instanceof Ht}function Ct(e){return e<0?-1*Math.round(-1*e):Math.round(e)}function Ft(e,n){I(e,0,0,function(){var e=this.utcOffset(),t="+";return e<0&&(e=-e,t="-"),t+U(~~(e/60),2)+n+U(~~e%60,2)})}Ft("Z",":"),Ft("ZZ",""),ue("Z",re),ue("ZZ",re),ce(["Z","ZZ"],function(e,t,n){n._useUTC=!0,n._tzm=Ut(re,e)});var Lt=/([\+\-]|\d\d)/gi;function Ut(e,t){var n=(t||"").match(e);if(null===n)return null;var s=((n[n.length-1]||[])+"").match(Lt)||["-",0,0],i=60*s[1]+k(s[2]);return 0===i?0:"+"===s[0]?i:-i}function Nt(e,t){var n,s;return t._isUTC?(n=t.clone(),s=(S(e)||h(e)?e.valueOf():Tt(e).valueOf())-n.valueOf(),n._d.setTime(n._d.valueOf()+s),c.updateOffset(n,!1),n):Tt(e).local()}function Gt(e){return 15*-Math.round(e._d.getTimezoneOffset()/15)}function Vt(){return!!this.isValid()&&(this._isUTC&&0===this._offset)}c.updateOffset=function(){};var Et=/^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/,It=/^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;function At(e,t){var n,s,i,r=e,a=null;return Rt(e)?r={ms:e._milliseconds,d:e._days,M:e._months}:d(e)?(r={},t?r[t]=e:r.milliseconds=e):(a=Et.exec(e))?(n="-"===a[1]?-1:1,r={y:0,d:k(a[ye])*n,h:k(a[ge])*n,m:k(a[pe])*n,s:k(a[ve])*n,ms:k(Ct(1e3*a[we]))*n}):(a=It.exec(e))?(n="-"===a[1]?-1:(a[1],1),r={y:jt(a[2],n),M:jt(a[3],n),w:jt(a[4],n),d:jt(a[5],n),h:jt(a[6],n),m:jt(a[7],n),s:jt(a[8],n)}):null==r?r={}:"object"==typeof r&&("from"in r||"to"in r)&&(i=function(e,t){var n;if(!e.isValid()||!t.isValid())return{milliseconds:0,months:0};t=Nt(t,e),e.isBefore(t)?n=Zt(e,t):((n=Zt(t,e)).milliseconds=-n.milliseconds,n.months=-n.months);return n}(Tt(r.from),Tt(r.to)),(r={}).ms=i.milliseconds,r.M=i.months),s=new Ht(r),Rt(e)&&m(e,"_locale")&&(s._locale=e._locale),s}function jt(e,t){var n=e&&parseFloat(e.replace(",","."));return(isNaN(n)?0:n)*t}function Zt(e,t){var n={milliseconds:0,months:0};return n.months=t.month()-e.month()+12*(t.year()-e.year()),e.clone().add(n.months,"M").isAfter(t)&&--n.months,n.milliseconds=+t-+e.clone().add(n.months,"M"),n}function zt(s,i){return function(e,t){var n;return null===t||isNaN(+t)||(T(i,"moment()."+i+"(period, number) is deprecated. Please use moment()."+i+"(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."),n=e,e=t,t=n),$t(this,At(e="string"==typeof e?+e:e,t),s),this}}function $t(e,t,n,s){var i=t._milliseconds,r=Ct(t._days),a=Ct(t._months);e.isValid()&&(s=null==s||s,a&&Ce(e,xe(e,"Month")+a*n),r&&be(e,"Date",xe(e,"Date")+r*n),i&&e._d.setTime(e._d.valueOf()+i*n),s&&c.updateOffset(e,r||a))}At.fn=Ht.prototype,At.invalid=function(){return At(NaN)};var qt=zt(1,"add"),Jt=zt(-1,"subtract");function Bt(e,t){var n=12*(t.year()-e.year())+(t.month()-e.month()),s=e.clone().add(n,"months");return-(n+(t-s<0?(t-s)/(s-e.clone().add(n-1,"months")):(t-s)/(e.clone().add(n+1,"months")-s)))||0}function Qt(e){var t;return void 0===e?this._locale._abbr:(null!=(t=lt(e))&&(this._locale=t),this)}c.defaultFormat="YYYY-MM-DDTHH:mm:ssZ",c.defaultFormatUtc="YYYY-MM-DDTHH:mm:ss[Z]";var Xt=n("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",function(e){return void 0===e?this.localeData():this.locale(e)});function Kt(){return this._locale}function en(e,t){I(0,[e,e.length],0,t)}function tn(e,t,n,s,i){var r;return null==e?Ie(this,s,i).year:((r=Ae(e,s,i))<t&&(t=r),function(e,t,n,s,i){var r=Ee(e,t,n,s,i),a=Ge(r.year,0,r.dayOfYear);return this.year(a.getUTCFullYear()),this.month(a.getUTCMonth()),this.date(a.getUTCDate()),this}.call(this,e,t,n,s,i))}I(0,["gg",2],0,function(){return this.weekYear()%100}),I(0,["GG",2],0,function(){return this.isoWeekYear()%100}),en("gggg","weekYear"),en("ggggg","weekYear"),en("GGGG","isoWeekYear"),en("GGGGG","isoWeekYear"),H("weekYear","gg"),H("isoWeekYear","GG"),L("weekYear",1),L("isoWeekYear",1),ue("G",se),ue("g",se),ue("GG",B,z),ue("gg",B,z),ue("GGGG",ee,q),ue("gggg",ee,q),ue("GGGGG",te,J),ue("ggggg",te,J),fe(["gggg","ggggg","GGGG","GGGGG"],function(e,t,n,s){t[s.substr(0,2)]=k(e)}),fe(["gg","GG"],function(e,t,n,s){t[s]=c.parseTwoDigitYear(e)}),I("Q",0,"Qo","quarter"),H("quarter","Q"),L("quarter",7),ue("Q",Z),ce("Q",function(e,t){t[_e]=3*(k(e)-1)}),I("D",["DD",2],"Do","date"),H("date","D"),L("date",9),ue("D",B),ue("DD",B,z),ue("Do",function(e,t){return e?t._dayOfMonthOrdinalParse||t._ordinalParse:t._dayOfMonthOrdinalParseLenient}),ce(["D","DD"],ye),ce("Do",function(e,t){t[ye]=k(e.match(B)[0])});var nn=Te("Date",!0);I("DDD",["DDDD",3],"DDDo","dayOfYear"),H("dayOfYear","DDD"),L("dayOfYear",4),ue("DDD",K),ue("DDDD",$),ce(["DDD","DDDD"],function(e,t,n){n._dayOfYear=k(e)}),I("m",["mm",2],0,"minute"),H("minute","m"),L("minute",14),ue("m",B),ue("mm",B,z),ce(["m","mm"],pe);var sn=Te("Minutes",!1);I("s",["ss",2],0,"second"),H("second","s"),L("second",15),ue("s",B),ue("ss",B,z),ce(["s","ss"],ve);var rn,an=Te("Seconds",!1);for(I("S",0,0,function(){return~~(this.millisecond()/100)}),I(0,["SS",2],0,function(){return~~(this.millisecond()/10)}),I(0,["SSS",3],0,"millisecond"),I(0,["SSSS",4],0,function(){return 10*this.millisecond()}),I(0,["SSSSS",5],0,function(){return 100*this.millisecond()}),I(0,["SSSSSS",6],0,function(){return 1e3*this.millisecond()}),I(0,["SSSSSSS",7],0,function(){return 1e4*this.millisecond()}),I(0,["SSSSSSSS",8],0,function(){return 1e5*this.millisecond()}),I(0,["SSSSSSSSS",9],0,function(){return 1e6*this.millisecond()}),H("millisecond","ms"),L("millisecond",16),ue("S",K,Z),ue("SS",K,z),ue("SSS",K,$),rn="SSSS";rn.length<=9;rn+="S")ue(rn,ne);function on(e,t){t[we]=k(1e3*("0."+e))}for(rn="S";rn.length<=9;rn+="S")ce(rn,on);var un=Te("Milliseconds",!1);I("z",0,0,"zoneAbbr"),I("zz",0,0,"zoneName");var ln=M.prototype;function dn(e){return e}ln.add=qt,ln.calendar=function(e,t){var n=e||Tt(),s=Nt(n,this).startOf("day"),i=c.calendarFormat(this,s)||"sameElse",r=t&&(x(t[i])?t[i].call(this,n):t[i]);return this.format(r||this.localeData().calendar(i,this,Tt(n)))},ln.clone=function(){return new M(this)},ln.diff=function(e,t,n){var s,i,r;if(!this.isValid())return NaN;if(!(s=Nt(e,this)).isValid())return NaN;switch(i=6e4*(s.utcOffset()-this.utcOffset()),t=R(t)){case"year":r=Bt(this,s)/12;break;case"month":r=Bt(this,s);break;case"quarter":r=Bt(this,s)/3;break;case"second":r=(this-s)/1e3;break;case"minute":r=(this-s)/6e4;break;case"hour":r=(this-s)/36e5;break;case"day":r=(this-s-i)/864e5;break;case"week":r=(this-s-i)/6048e5;break;default:r=this-s}return n?r:D(r)},ln.endOf=function(e){return void 0===(e=R(e))||"millisecond"===e?this:("date"===e&&(e="day"),this.startOf(e).add(1,"isoWeek"===e?"week":e).subtract(1,"ms"))},ln.format=function(e){e||(e=this.isUtc()?c.defaultFormatUtc:c.defaultFormat);var t=A(this,e);return this.localeData().postformat(t)},ln.from=function(e,t){return this.isValid()&&(S(e)&&e.isValid()||Tt(e).isValid())?At({to:this,from:e}).locale(this.locale()).humanize(!t):this.localeData().invalidDate()},ln.fromNow=function(e){return this.from(Tt(),e)},ln.to=function(e,t){return this.isValid()&&(S(e)&&e.isValid()||Tt(e).isValid())?At({from:this,to:e}).locale(this.locale()).humanize(!t):this.localeData().invalidDate()},ln.toNow=function(e){return this.to(Tt(),e)},ln.get=function(e){return x(this[e=R(e)])?this[e]():this},ln.invalidAt=function(){return g(this).overflow},ln.isAfter=function(e,t){var n=S(e)?e:Tt(e);return!(!this.isValid()||!n.isValid())&&("millisecond"===(t=R(l(t)?"millisecond":t))?this.valueOf()>n.valueOf():n.valueOf()<this.clone().startOf(t).valueOf())},ln.isBefore=function(e,t){var n=S(e)?e:Tt(e);return!(!this.isValid()||!n.isValid())&&("millisecond"===(t=R(l(t)?"millisecond":t))?this.valueOf()<n.valueOf():this.clone().endOf(t).valueOf()<n.valueOf())},ln.isBetween=function(e,t,n,s){return("("===(s=s||"()")[0]?this.isAfter(e,n):!this.isBefore(e,n))&&(")"===s[1]?this.isBefore(t,n):!this.isAfter(t,n))},ln.isSame=function(e,t){var n,s=S(e)?e:Tt(e);return!(!this.isValid()||!s.isValid())&&("millisecond"===(t=R(t||"millisecond"))?this.valueOf()===s.valueOf():(n=s.valueOf(),this.clone().startOf(t).valueOf()<=n&&n<=this.clone().endOf(t).valueOf()))},ln.isSameOrAfter=function(e,t){return this.isSame(e,t)||this.isAfter(e,t)},ln.isSameOrBefore=function(e,t){return this.isSame(e,t)||this.isBefore(e,t)},ln.isValid=function(){return p(this)},ln.lang=Xt,ln.locale=Qt,ln.localeData=Kt,ln.max=bt,ln.min=xt,ln.parsingFlags=function(){return _({},g(this))},ln.set=function(e,t){if("object"==typeof e)for(var n=function(e){var t=[];for(var n in e)t.push({unit:n,priority:F[n]});return t.sort(function(e,t){return e.priority-t.priority}),t}(e=C(e)),s=0;s<n.length;s++)this[n[s].unit](e[n[s].unit]);else if(x(this[e=R(e)]))return this[e](t);return this},ln.startOf=function(e){switch(e=R(e)){case"year":this.month(0);case"quarter":case"month":this.date(1);case"week":case"isoWeek":case"day":case"date":this.hours(0);case"hour":this.minutes(0);case"minute":this.seconds(0);case"second":this.milliseconds(0)}return"week"===e&&this.weekday(0),"isoWeek"===e&&this.isoWeekday(1),"quarter"===e&&this.month(3*Math.floor(this.month()/3)),this},ln.subtract=Jt,ln.toArray=function(){var e=this;return[e.year(),e.month(),e.date(),e.hour(),e.minute(),e.second(),e.millisecond()]},ln.toObject=function(){var e=this;return{years:e.year(),months:e.month(),date:e.date(),hours:e.hours(),minutes:e.minutes(),seconds:e.seconds(),milliseconds:e.milliseconds()}},ln.toDate=function(){return new Date(this.valueOf())},ln.toISOString=function(e){if(!this.isValid())return null;var t=!0!==e,n=t?this.clone().utc():this;return n.year()<0||9999<n.year()?A(n,t?"YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]":"YYYYYY-MM-DD[T]HH:mm:ss.SSSZ"):x(Date.prototype.toISOString)?t?this.toDate().toISOString():new Date(this.valueOf()+60*this.utcOffset()*1e3).toISOString().replace("Z",A(n,"Z")):A(n,t?"YYYY-MM-DD[T]HH:mm:ss.SSS[Z]":"YYYY-MM-DD[T]HH:mm:ss.SSSZ")},ln.inspect=function(){if(!this.isValid())return"moment.invalid(/* "+this._i+" */)";var e="moment",t="";this.isLocal()||(e=0===this.utcOffset()?"moment.utc":"moment.parseZone",t="Z");var n="["+e+'("]',s=0<=this.year()&&this.year()<=9999?"YYYY":"YYYYYY",i=t+'[")]';return this.format(n+s+"-MM-DD[T]HH:mm:ss.SSS"+i)},ln.toJSON=function(){return this.isValid()?this.toISOString():null},ln.toString=function(){return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ")},ln.unix=function(){return Math.floor(this.valueOf()/1e3)},ln.valueOf=function(){return this._d.valueOf()-6e4*(this._offset||0)},ln.creationData=function(){return{input:this._i,format:this._f,locale:this._locale,isUTC:this._isUTC,strict:this._strict}},ln.year=Oe,ln.isLeapYear=function(){return ke(this.year())},ln.weekYear=function(e){return tn.call(this,e,this.week(),this.weekday(),this.localeData()._week.dow,this.localeData()._week.doy)},ln.isoWeekYear=function(e){return tn.call(this,e,this.isoWeek(),this.isoWeekday(),1,4)},ln.quarter=ln.quarters=function(e){return null==e?Math.ceil((this.month()+1)/3):this.month(3*(e-1)+this.month()%3)},ln.month=Fe,ln.daysInMonth=function(){return Pe(this.year(),this.month())},ln.week=ln.weeks=function(e){var t=this.localeData().week(this);return null==e?t:this.add(7*(e-t),"d")},ln.isoWeek=ln.isoWeeks=function(e){var t=Ie(this,1,4).week;return null==e?t:this.add(7*(e-t),"d")},ln.weeksInYear=function(){var e=this.localeData()._week;return Ae(this.year(),e.dow,e.doy)},ln.isoWeeksInYear=function(){return Ae(this.year(),1,4)},ln.date=nn,ln.day=ln.days=function(e){if(!this.isValid())return null!=e?this:NaN;var t,n,s=this._isUTC?this._d.getUTCDay():this._d.getDay();return null!=e?(t=e,n=this.localeData(),e="string"!=typeof t?t:isNaN(t)?"number"==typeof(t=n.weekdaysParse(t))?t:null:parseInt(t,10),this.add(e-s,"d")):s},ln.weekday=function(e){if(!this.isValid())return null!=e?this:NaN;var t=(this.day()+7-this.localeData()._week.dow)%7;return null==e?t:this.add(e-t,"d")},ln.isoWeekday=function(e){if(!this.isValid())return null!=e?this:NaN;if(null!=e){var t=(n=e,s=this.localeData(),"string"==typeof n?s.weekdaysParse(n)%7||7:isNaN(n)?null:n);return this.day(this.day()%7?t:t-7)}return this.day()||7;var n,s},ln.dayOfYear=function(e){var t=Math.round((this.clone().startOf("day")-this.clone().startOf("year"))/864e5)+1;return null==e?t:this.add(e-t,"d")},ln.hour=ln.hours=tt,ln.minute=ln.minutes=sn,ln.second=ln.seconds=an,ln.millisecond=ln.milliseconds=un,ln.utcOffset=function(e,t,n){var s,i=this._offset||0;if(!this.isValid())return null!=e?this:NaN;if(null!=e){if("string"==typeof e){if(null===(e=Ut(re,e)))return this}else Math.abs(e)<16&&!n&&(e*=60);return!this._isUTC&&t&&(s=Gt(this)),this._offset=e,this._isUTC=!0,null!=s&&this.add(s,"m"),i!==e&&(!t||this._changeInProgress?$t(this,At(e-i,"m"),1,!1):this._changeInProgress||(this._changeInProgress=!0,c.updateOffset(this,!0),this._changeInProgress=null)),this}return this._isUTC?i:Gt(this)},ln.utc=function(e){return this.utcOffset(0,e)},ln.local=function(e){return this._isUTC&&(this.utcOffset(0,e),this._isUTC=!1,e&&this.subtract(Gt(this),"m")),this},ln.parseZone=function(){if(null!=this._tzm)this.utcOffset(this._tzm,!1,!0);else if("string"==typeof this._i){var e=Ut(ie,this._i);null!=e?this.utcOffset(e):this.utcOffset(0,!0)}return this},ln.hasAlignedHourOffset=function(e){return!!this.isValid()&&(e=e?Tt(e).utcOffset():0,(this.utcOffset()-e)%60==0)},ln.isDST=function(){return this.utcOffset()>this.clone().month(0).utcOffset()||this.utcOffset()>this.clone().month(5).utcOffset()},ln.isLocal=function(){return!!this.isValid()&&!this._isUTC},ln.isUtcOffset=function(){return!!this.isValid()&&this._isUTC},ln.isUtc=Vt,ln.isUTC=Vt,ln.zoneAbbr=function(){return this._isUTC?"UTC":""},ln.zoneName=function(){return this._isUTC?"Coordinated Universal Time":""},ln.dates=n("dates accessor is deprecated. Use date instead.",nn),ln.months=n("months accessor is deprecated. Use month instead",Fe),ln.years=n("years accessor is deprecated. Use year instead",Oe),ln.zone=n("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/",function(e,t){return null!=e?("string"!=typeof e&&(e=-e),this.utcOffset(e,t),this):-this.utcOffset()}),ln.isDSTShifted=n("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information",function(){if(!l(this._isDSTShifted))return this._isDSTShifted;var e={};if(w(e,this),(e=Yt(e))._a){var t=e._isUTC?y(e._a):Tt(e._a);this._isDSTShifted=this.isValid()&&0<a(e._a,t.toArray())}else this._isDSTShifted=!1;return this._isDSTShifted});var hn=P.prototype;function cn(e,t,n,s){var i=lt(),r=y().set(s,t);return i[n](r,e)}function fn(e,t,n){if(d(e)&&(t=e,e=void 0),e=e||"",null!=t)return cn(e,t,n,"month");var s,i=[];for(s=0;s<12;s++)i[s]=cn(e,s,n,"month");return i}function mn(e,t,n,s){"boolean"==typeof e?d(t)&&(n=t,t=void 0):(t=e,e=!1,d(n=t)&&(n=t,t=void 0)),t=t||"";var i,r=lt(),a=e?r._week.dow:0;if(null!=n)return cn(t,(n+a)%7,s,"day");var o=[];for(i=0;i<7;i++)o[i]=cn(t,(i+a)%7,s,"day");return o}hn.calendar=function(e,t,n){var s=this._calendar[e]||this._calendar.sameElse;return x(s)?s.call(t,n):s},hn.longDateFormat=function(e){var t=this._longDateFormat[e],n=this._longDateFormat[e.toUpperCase()];return t||!n?t:(this._longDateFormat[e]=n.replace(/MMMM|MM|DD|dddd/g,function(e){return e.slice(1)}),this._longDateFormat[e])},hn.invalidDate=function(){return this._invalidDate},hn.ordinal=function(e){return this._ordinal.replace("%d",e)},hn.preparse=dn,hn.postformat=dn,hn.relativeTime=function(e,t,n,s){var i=this._relativeTime[n];return x(i)?i(e,t,n,s):i.replace(/%d/i,e)},hn.pastFuture=function(e,t){var n=this._relativeTime[0<e?"future":"past"];return x(n)?n(t):n.replace(/%s/i,t)},hn.set=function(e){var t,n;for(n in e)x(t=e[n])?this[n]=t:this["_"+n]=t;this._config=e,this._dayOfMonthOrdinalParseLenient=new RegExp((this._dayOfMonthOrdinalParse.source||this._ordinalParse.source)+"|"+/\d{1,2}/.source)},hn.months=function(e,t){return e?o(this._months)?this._months[e.month()]:this._months[(this._months.isFormat||We).test(t)?"format":"standalone"][e.month()]:o(this._months)?this._months:this._months.standalone},hn.monthsShort=function(e,t){return e?o(this._monthsShort)?this._monthsShort[e.month()]:this._monthsShort[We.test(t)?"format":"standalone"][e.month()]:o(this._monthsShort)?this._monthsShort:this._monthsShort.standalone},hn.monthsParse=function(e,t,n){var s,i,r;if(this._monthsParseExact)return function(e,t,n){var s,i,r,a=e.toLocaleLowerCase();if(!this._monthsParse)for(this._monthsParse=[],this._longMonthsParse=[],this._shortMonthsParse=[],s=0;s<12;++s)r=y([2e3,s]),this._shortMonthsParse[s]=this.monthsShort(r,"").toLocaleLowerCase(),this._longMonthsParse[s]=this.months(r,"").toLocaleLowerCase();return n?"MMM"===t?-1!==(i=Ye.call(this._shortMonthsParse,a))?i:null:-1!==(i=Ye.call(this._longMonthsParse,a))?i:null:"MMM"===t?-1!==(i=Ye.call(this._shortMonthsParse,a))?i:-1!==(i=Ye.call(this._longMonthsParse,a))?i:null:-1!==(i=Ye.call(this._longMonthsParse,a))?i:-1!==(i=Ye.call(this._shortMonthsParse,a))?i:null}.call(this,e,t,n);for(this._monthsParse||(this._monthsParse=[],this._longMonthsParse=[],this._shortMonthsParse=[]),s=0;s<12;s++){if(i=y([2e3,s]),n&&!this._longMonthsParse[s]&&(this._longMonthsParse[s]=new RegExp("^"+this.months(i,"").replace(".","")+"$","i"),this._shortMonthsParse[s]=new RegExp("^"+this.monthsShort(i,"").replace(".","")+"$","i")),n||this._monthsParse[s]||(r="^"+this.months(i,"")+"|^"+this.monthsShort(i,""),this._monthsParse[s]=new RegExp(r.replace(".",""),"i")),n&&"MMMM"===t&&this._longMonthsParse[s].test(e))return s;if(n&&"MMM"===t&&this._shortMonthsParse[s].test(e))return s;if(!n&&this._monthsParse[s].test(e))return s}},hn.monthsRegex=function(e){return this._monthsParseExact?(m(this,"_monthsRegex")||Ne.call(this),e?this._monthsStrictRegex:this._monthsRegex):(m(this,"_monthsRegex")||(this._monthsRegex=Ue),this._monthsStrictRegex&&e?this._monthsStrictRegex:this._monthsRegex)},hn.monthsShortRegex=function(e){return this._monthsParseExact?(m(this,"_monthsRegex")||Ne.call(this),e?this._monthsShortStrictRegex:this._monthsShortRegex):(m(this,"_monthsShortRegex")||(this._monthsShortRegex=Le),this._monthsShortStrictRegex&&e?this._monthsShortStrictRegex:this._monthsShortRegex)},hn.week=function(e){return Ie(e,this._week.dow,this._week.doy).week},hn.firstDayOfYear=function(){return this._week.doy},hn.firstDayOfWeek=function(){return this._week.dow},hn.weekdays=function(e,t){return e?o(this._weekdays)?this._weekdays[e.day()]:this._weekdays[this._weekdays.isFormat.test(t)?"format":"standalone"][e.day()]:o(this._weekdays)?this._weekdays:this._weekdays.standalone},hn.weekdaysMin=function(e){return e?this._weekdaysMin[e.day()]:this._weekdaysMin},hn.weekdaysShort=function(e){return e?this._weekdaysShort[e.day()]:this._weekdaysShort},hn.weekdaysParse=function(e,t,n){var s,i,r;if(this._weekdaysParseExact)return function(e,t,n){var s,i,r,a=e.toLocaleLowerCase();if(!this._weekdaysParse)for(this._weekdaysParse=[],this._shortWeekdaysParse=[],this._minWeekdaysParse=[],s=0;s<7;++s)r=y([2e3,1]).day(s),this._minWeekdaysParse[s]=this.weekdaysMin(r,"").toLocaleLowerCase(),this._shortWeekdaysParse[s]=this.weekdaysShort(r,"").toLocaleLowerCase(),this._weekdaysParse[s]=this.weekdays(r,"").toLocaleLowerCase();return n?"dddd"===t?-1!==(i=Ye.call(this._weekdaysParse,a))?i:null:"ddd"===t?-1!==(i=Ye.call(this._shortWeekdaysParse,a))?i:null:-1!==(i=Ye.call(this._minWeekdaysParse,a))?i:null:"dddd"===t?-1!==(i=Ye.call(this._weekdaysParse,a))?i:-1!==(i=Ye.call(this._shortWeekdaysParse,a))?i:-1!==(i=Ye.call(this._minWeekdaysParse,a))?i:null:"ddd"===t?-1!==(i=Ye.call(this._shortWeekdaysParse,a))?i:-1!==(i=Ye.call(this._weekdaysParse,a))?i:-1!==(i=Ye.call(this._minWeekdaysParse,a))?i:null:-1!==(i=Ye.call(this._minWeekdaysParse,a))?i:-1!==(i=Ye.call(this._weekdaysParse,a))?i:-1!==(i=Ye.call(this._shortWeekdaysParse,a))?i:null}.call(this,e,t,n);for(this._weekdaysParse||(this._weekdaysParse=[],this._minWeekdaysParse=[],this._shortWeekdaysParse=[],this._fullWeekdaysParse=[]),s=0;s<7;s++){if(i=y([2e3,1]).day(s),n&&!this._fullWeekdaysParse[s]&&(this._fullWeekdaysParse[s]=new RegExp("^"+this.weekdays(i,"").replace(".","\\.?")+"$","i"),this._shortWeekdaysParse[s]=new RegExp("^"+this.weekdaysShort(i,"").replace(".","\\.?")+"$","i"),this._minWeekdaysParse[s]=new RegExp("^"+this.weekdaysMin(i,"").replace(".","\\.?")+"$","i")),this._weekdaysParse[s]||(r="^"+this.weekdays(i,"")+"|^"+this.weekdaysShort(i,"")+"|^"+this.weekdaysMin(i,""),this._weekdaysParse[s]=new RegExp(r.replace(".",""),"i")),n&&"dddd"===t&&this._fullWeekdaysParse[s].test(e))return s;if(n&&"ddd"===t&&this._shortWeekdaysParse[s].test(e))return s;if(n&&"dd"===t&&this._minWeekdaysParse[s].test(e))return s;if(!n&&this._weekdaysParse[s].test(e))return s}},hn.weekdaysRegex=function(e){return this._weekdaysParseExact?(m(this,"_weekdaysRegex")||Be.call(this),e?this._weekdaysStrictRegex:this._weekdaysRegex):(m(this,"_weekdaysRegex")||(this._weekdaysRegex=$e),this._weekdaysStrictRegex&&e?this._weekdaysStrictRegex:this._weekdaysRegex)},hn.weekdaysShortRegex=function(e){return this._weekdaysParseExact?(m(this,"_weekdaysRegex")||Be.call(this),e?this._weekdaysShortStrictRegex:this._weekdaysShortRegex):(m(this,"_weekdaysShortRegex")||(this._weekdaysShortRegex=qe),this._weekdaysShortStrictRegex&&e?this._weekdaysShortStrictRegex:this._weekdaysShortRegex)},hn.weekdaysMinRegex=function(e){return this._weekdaysParseExact?(m(this,"_weekdaysRegex")||Be.call(this),e?this._weekdaysMinStrictRegex:this._weekdaysMinRegex):(m(this,"_weekdaysMinRegex")||(this._weekdaysMinRegex=Je),this._weekdaysMinStrictRegex&&e?this._weekdaysMinStrictRegex:this._weekdaysMinRegex)},hn.isPM=function(e){return"p"===(e+"").toLowerCase().charAt(0)},hn.meridiem=function(e,t,n){return 11<e?n?"pm":"PM":n?"am":"AM"},ot("en",{dayOfMonthOrdinalParse:/\d{1,2}(th|st|nd|rd)/,ordinal:function(e){var t=e%10;return e+(1===k(e%100/10)?"th":1===t?"st":2===t?"nd":3===t?"rd":"th")}}),c.lang=n("moment.lang is deprecated. Use moment.locale instead.",ot),c.langData=n("moment.langData is deprecated. Use moment.localeData instead.",lt);var _n=Math.abs;function yn(e,t,n,s){var i=At(t,n);return e._milliseconds+=s*i._milliseconds,e._days+=s*i._days,e._months+=s*i._months,e._bubble()}function gn(e){return e<0?Math.floor(e):Math.ceil(e)}function pn(e){return 4800*e/146097}function vn(e){return 146097*e/4800}function wn(e){return function(){return this.as(e)}}var Mn=wn("ms"),Sn=wn("s"),Dn=wn("m"),kn=wn("h"),Yn=wn("d"),On=wn("w"),Tn=wn("M"),xn=wn("y");function bn(e){return function(){return this.isValid()?this._data[e]:NaN}}var Pn=bn("milliseconds"),Wn=bn("seconds"),Hn=bn("minutes"),Rn=bn("hours"),Cn=bn("days"),Fn=bn("months"),Ln=bn("years");var Un=Math.round,Nn={ss:44,s:45,m:45,h:22,d:26,M:11};var Gn=Math.abs;function Vn(e){return(0<e)-(e<0)||+e}function En(){if(!this.isValid())return this.localeData().invalidDate();var e,t,n=Gn(this._milliseconds)/1e3,s=Gn(this._days),i=Gn(this._months);t=D((e=D(n/60))/60),n%=60,e%=60;var r=D(i/12),a=i%=12,o=s,u=t,l=e,d=n?n.toFixed(3).replace(/\.?0+$/,""):"",h=this.asSeconds();if(!h)return"P0D";var c=h<0?"-":"",f=Vn(this._months)!==Vn(h)?"-":"",m=Vn(this._days)!==Vn(h)?"-":"",_=Vn(this._milliseconds)!==Vn(h)?"-":"";return c+"P"+(r?f+r+"Y":"")+(a?f+a+"M":"")+(o?m+o+"D":"")+(u||l||d?"T":"")+(u?_+u+"H":"")+(l?_+l+"M":"")+(d?_+d+"S":"")}var In=Ht.prototype;return In.isValid=function(){return this._isValid},In.abs=function(){var e=this._data;return this._milliseconds=_n(this._milliseconds),this._days=_n(this._days),this._months=_n(this._months),e.milliseconds=_n(e.milliseconds),e.seconds=_n(e.seconds),e.minutes=_n(e.minutes),e.hours=_n(e.hours),e.months=_n(e.months),e.years=_n(e.years),this},In.add=function(e,t){return yn(this,e,t,1)},In.subtract=function(e,t){return yn(this,e,t,-1)},In.as=function(e){if(!this.isValid())return NaN;var t,n,s=this._milliseconds;if("month"===(e=R(e))||"year"===e)return t=this._days+s/864e5,n=this._months+pn(t),"month"===e?n:n/12;switch(t=this._days+Math.round(vn(this._months)),e){case"week":return t/7+s/6048e5;case"day":return t+s/864e5;case"hour":return 24*t+s/36e5;case"minute":return 1440*t+s/6e4;case"second":return 86400*t+s/1e3;case"millisecond":return Math.floor(864e5*t)+s;default:throw new Error("Unknown unit "+e)}},In.asMilliseconds=Mn,In.asSeconds=Sn,In.asMinutes=Dn,In.asHours=kn,In.asDays=Yn,In.asWeeks=On,In.asMonths=Tn,In.asYears=xn,In.valueOf=function(){return this.isValid()?this._milliseconds+864e5*this._days+this._months%12*2592e6+31536e6*k(this._months/12):NaN},In._bubble=function(){var e,t,n,s,i,r=this._milliseconds,a=this._days,o=this._months,u=this._data;return 0<=r&&0<=a&&0<=o||r<=0&&a<=0&&o<=0||(r+=864e5*gn(vn(o)+a),o=a=0),u.milliseconds=r%1e3,e=D(r/1e3),u.seconds=e%60,t=D(e/60),u.minutes=t%60,n=D(t/60),u.hours=n%24,o+=i=D(pn(a+=D(n/24))),a-=gn(vn(i)),s=D(o/12),o%=12,u.days=a,u.months=o,u.years=s,this},In.clone=function(){return At(this)},In.get=function(e){return e=R(e),this.isValid()?this[e+"s"]():NaN},In.milliseconds=Pn,In.seconds=Wn,In.minutes=Hn,In.hours=Rn,In.days=Cn,In.weeks=function(){return D(this.days()/7)},In.months=Fn,In.years=Ln,In.humanize=function(e){if(!this.isValid())return this.localeData().invalidDate();var t,n,s,i,r,a,o,u,l,d,h,c=this.localeData(),f=(n=!e,s=c,i=At(t=this).abs(),r=Un(i.as("s")),a=Un(i.as("m")),o=Un(i.as("h")),u=Un(i.as("d")),l=Un(i.as("M")),d=Un(i.as("y")),(h=r<=Nn.ss&&["s",r]||r<Nn.s&&["ss",r]||a<=1&&["m"]||a<Nn.m&&["mm",a]||o<=1&&["h"]||o<Nn.h&&["hh",o]||u<=1&&["d"]||u<Nn.d&&["dd",u]||l<=1&&["M"]||l<Nn.M&&["MM",l]||d<=1&&["y"]||["yy",d])[2]=n,h[3]=0<+t,h[4]=s,function(e,t,n,s,i){return i.relativeTime(t||1,!!n,e,s)}.apply(null,h));return e&&(f=c.pastFuture(+this,f)),c.postformat(f)},In.toISOString=En,In.toString=En,In.toJSON=En,In.locale=Qt,In.localeData=Kt,In.toIsoString=n("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)",En),In.lang=Xt,I("X",0,0,"unix"),I("x",0,0,"valueOf"),ue("x",se),ue("X",/[+-]?\d+(\.\d{1,3})?/),ce("X",function(e,t,n){n._d=new Date(1e3*parseFloat(e,10))}),ce("x",function(e,t,n){n._d=new Date(k(e))}),c.version="2.22.2",e=Tt,c.fn=ln,c.min=function(){return Pt("isBefore",[].slice.call(arguments,0))},c.max=function(){return Pt("isAfter",[].slice.call(arguments,0))},c.now=function(){return Date.now?Date.now():+new Date},c.utc=y,c.unix=function(e){return Tt(1e3*e)},c.months=function(e,t){return fn(e,t,"months")},c.isDate=h,c.locale=ot,c.invalid=v,c.duration=At,c.isMoment=S,c.weekdays=function(e,t,n){return mn(e,t,n,"weekdays")},c.parseZone=function(){return Tt.apply(null,arguments).parseZone()},c.localeData=lt,c.isDuration=Rt,c.monthsShort=function(e,t){return fn(e,t,"monthsShort")},c.weekdaysMin=function(e,t,n){return mn(e,t,n,"weekdaysMin")},c.defineLocale=ut,c.updateLocale=function(e,t){if(null!=t){var n,s,i=nt;null!=(s=at(e))&&(i=s._config),(n=new P(t=b(i,t))).parentLocale=st[e],st[e]=n,ot(e)}else null!=st[e]&&(null!=st[e].parentLocale?st[e]=st[e].parentLocale:null!=st[e]&&delete st[e]);return st[e]},c.locales=function(){return s(st)},c.weekdaysShort=function(e,t,n){return mn(e,t,n,"weekdaysShort")},c.normalizeUnits=R,c.relativeTimeRounding=function(e){return void 0===e?Un:"function"==typeof e&&(Un=e,!0)},c.relativeTimeThreshold=function(e,t){return void 0!==Nn[e]&&(void 0===t?Nn[e]:(Nn[e]=t,"s"===e&&(Nn.ss=t-1),!0))},c.calendarFormat=function(e,t){var n=e.diff(t,"days",!0);return n<-6?"sameElse":n<-1?"lastWeek":n<0?"lastDay":n<1?"sameDay":n<2?"nextDay":n<7?"nextWeek":"sameElse"},c.prototype=ln,c.HTML5_FMT={DATETIME_LOCAL:"YYYY-MM-DDTHH:mm",DATETIME_LOCAL_SECONDS:"YYYY-MM-DDTHH:mm:ss",DATETIME_LOCAL_MS:"YYYY-MM-DDTHH:mm:ss.SSS",DATE:"YYYY-MM-DD",TIME:"HH:mm",TIME_SECONDS:"HH:mm:ss",TIME_MS:"HH:mm:ss.SSS",WEEK:"YYYY-[W]WW",MONTH:"YYYY-MM"},c});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(549)(module)))

/***/ }),

/***/ 45:
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),

/***/ 549:
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),

/***/ 552:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(295);


/***/ }),

/***/ 60:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

///////////////////////////////////////////////////////////////////////////////
//
//  AutobahnJS - http://autobahn.ws, http://wamp.ws
//
//  A JavaScript library for WAMP ("The Web Application Messaging Protocol").
//
//  Copyright (C) 2011-2014 Tavendo GmbH, http://tavendo.com
//
//  Licensed under the MIT License.
//  http://www.opensource.org/licenses/mit-license.php
//
///////////////////////////////////////////////////////////////////////////////

/* eslint spaced-comment:0,vars-on-top:0,no-var:0,camelcase:0,func-names:0,one-var:0,one-var-declaration-per-line:0,eqeqeq:0,
    no-multiple-empty-lines:0,prefer-rest-params:0,block-scoped-var:0,no-use-before-define:0,prefer-template:0,no-restricted-syntax:0,
    no-debugger:0,padded-blocks:0,no-else-return:0,quotes:0,object-curly-spacing:0,semi:0,space-infix-ops:0 */
/* global AUTOBAHN_DEBUG:true */

var rand_normal = function rand_normal(mean, sd) {
    // Derive a Gaussian from Uniform random variables
    // http://en.wikipedia.org/wiki/Box%E2%80%93Muller_transform
    var x1, x2, rad;

    do {
        x1 = 2 * Math.random() - 1;
        x2 = 2 * Math.random() - 1;
        rad = x1 * x1 + x2 * x2;
    } while (rad >= 1 || rad == 0);

    var c = Math.sqrt(-2 * Math.log(rad) / rad);

    return (mean || 0) + x1 * c * (sd || 1);
};

var assert = function assert(cond, text) {
    if (cond) {
        return;
    }
    if (assert.useDebugger || 'AUTOBAHN_DEBUG' in window && AUTOBAHN_DEBUG) {
        debugger;
    }

    throw new Error(text || "Assertion failed!");
};

/**
* Merge a list of objects from left to right
*
* For each object passed to the function, add to the previous object the keys
*     that are present in the former but not the latter. If the last argument
*     is a boolean, it sets whether or not to recursively merge objects.
*
* This function mutates the first passed object. To avopid this, you can pass
*     a new empty object as the first arg:
*
*     defaults({}, obj1, obj2, ...)
*
* @example
*     defaults({ a: 1 }, { a: 2, b: 2 }, { b: 3, c: 3 })
*     // { a: 1, b: 2, c: 3 }
*
*     defaults({ a: { k1: 1 } }, { a: { k2: 2 } })
*     // { a: { k1: 1 } }
*
*     defaults({ a: { k1: 1 } }, { a: { k2: 2 } })
*     // { a: { k1: 1 } }
*
* @param {Object} base The object to merge defaults to
* @param {Object} source[, ...] The default values source
* @param {Boolean} [recursive] Whether to recurse fro object values*
*     (default: false)
* @returns {Object} The mutated `base` object
*/
var defaults = function defaults() {
    // Return an empty object if no arguments are passed
    if (arguments.length === 0) return {};

    var base = arguments[0];
    var recursive = false;
    var len = arguments.length;

    // Check for recursive mode param
    if (typeof arguments[len - 1] === 'boolean') {
        recursive = arguments[len - 1];
        len -= 1; // Ignore the last arg
    }

    // Merging function used by Array#forEach()
    var do_merge = function do_merge(key) {
        var val = obj[key];

        // Set if unset
        if (!(key in base)) {
            base[key] = val;
            // If the value is an object and we use recursive mode, use defaults on
            // the value
        } else if (recursive && (typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object' && _typeof(base[key]) === 'object') {
            defaults(base[key], val);
        }
        // Otherwise ignore the value
    };

    // Iterate over source objects
    for (var i = 1; i < len; i++) {
        var obj = arguments[i];

        // Ignore falsy values
        if (!obj) continue;

        // Require object
        if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object') {
            throw new Error('Expected argument at index ' + i + ' to be an object');
        }

        // Merge keys
        Object.keys(obj).forEach(do_merge);
    }

    // Return the mutated base object
    return base;
};

/**
 * http_get_jsonp - retrieves jsonp data (cross-domain)
 *
 * @param  {string}             url = ''                        url of method to call
 * @param  {string}             funcParam = '%s'                substring URL callback function name
 * @param  {int}                [timeout = DEFAULT_TIMEOUT]     s/e, in milliseconds
 * @return {object}             Promise
 */
var scriptTarget = document.body;
var http_get_jsonp = function http_get_jsonp(url, funcParam, timeout) {
    return new Promise(function (resolve, reject) {
        // Timestamp & random factor
        var timestamp = Date.now && Date.now() || new Date().getTime();
        var generatedFunction = 'jsonp' + Math.round(timestamp + Math.random() * 1000001);

        // script tag
        var jsonpScript = null;

        // Delete window callback
        var cleanup = function cleanup() {
            scriptTarget.removeChild(jsonpScript);
            try {
                delete window[generatedFunction];
            } catch (e) {
                /* eslint no-undefined:0 */
                window[generatedFunction] = undefined; // IE8
            }
        };

        // Wait a while, then reject the promise
        var timeoutRejection = setTimeout(function () {
            cleanup();
            reject();
        }, timeout || 30000);

        // Attach generated function
        window[generatedFunction] = function (result) {
            cleanup();
            clearTimeout(timeoutRejection);
            resolve(result);
        };

        // Create <script> tag
        jsonpScript = document.createElement('script');
        jsonpScript.setAttribute('src', url.replace(funcParam, generatedFunction) + (url.indexOf('?') !== -1 ? '&' : '?') + 't' + timestamp + '=' + timestamp);

        // Locate a script target
        if (scriptTarget === null) {
            scriptTarget = document.head;
            if (!scriptTarget) {
                scriptTarget = document.body;
            }
        }

        // Append
        var appendJsonpScript = function appendJsonpScript() {
            scriptTarget.appendChild(jsonpScript);
            window.removeEventListener('load', appendJsonpScript);
        };
        if (scriptTarget) {
            appendJsonpScript();
        } else {
            window.addEventListener('load', appendJsonpScript);
        }
    });
};

/**
 * http_post_jsonp - sends jsonp data (cross-domain); always resolves
 *
 * @param  {string}             url = ''                        url of method to call
 * @param  {string}             data = {}                       data to be sent
 * @param  {int}                [timeout = DEFAULT_TIMEOUT]     s/e, in milliseconds
 * @return {object}             Promise
 */
var http_post_json = function http_post_json(url, data, timeout) {
    return new Promise(function (resolve, reject) {
        var timestamp = Date.now && Date.now() || new Date().getTime();
        var generatedName = 'iframe' + Math.round(timestamp + Math.random() * 1000001);
        var rejectionTimeout = null;

        // Iframe
        var iframe = document.createElement('iframe');
        var form = document.createElement('form');
        iframe.name = generatedName;
        iframe.style.display = 'none';

        // Cleanup
        var cleanup = function cleanup() {
            iframe.parentNode.removeChild(iframe);
            form.parentNode.removeChild(form);
            clearTimeout(rejectionTimeout);
        };

        // Form
        form.style.display = 'none';
        form.method = 'post';
        form.action = url;
        form.target = generatedName;

        for (var i in data) {
            if (data.hasOwnProperty(i)) {
                var input = document.createElement('input');
                input.type = 'hidden';
                input.name = i;
                input.value = data[i];
                form.appendChild(input);
            }
        }

        // Append
        var appendJsonpScript = function appendJsonpScript() {
            window.removeEventListener('load', appendJsonpScript);
            document.body.appendChild(iframe);
            document.body.appendChild(form);

            iframe.onload = function () {
                cleanup();
                resolve();
            };

            form.submit();
        };

        // Reject after specific interval
        rejectionTimeout = setTimeout(function () {
            window.removeEventListener('load', appendJsonpScript);
            cleanup();
            reject();
        }, timeout || 30000);

        // Do the job or wait
        if (document.body) {
            appendJsonpScript();
        } else {
            window.addEventListener('load', appendJsonpScript);
        }
    });
};

/**
 * Exports
 */
exports.http_get_jsonp = http_get_jsonp;
exports.http_post_json = http_post_json;
exports.rand_normal = rand_normal;
exports.assert = assert;
exports.defaults = defaults;

/***/ }),

/***/ 66:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),

/***/ 71:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.connect = connect;
exports.disconnect = disconnect;
exports.isConnected = isConnected;
exports.isConnecting = isConnecting;
exports.onConnect = onConnect;
exports.onDisconnect = onDisconnect;
exports.getSession = getSession;
exports.getConnection = getConnection;

var _autobahn = __webpack_require__(119);

var _autobahn2 = _interopRequireDefault(_autobahn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Connection State
 */
var connected = false;
var connecting = false;

var connectionOptions = {};

var currentConnection = null;
var currentSession = null;

/**
 * Handlers
 */
var handlersCounter = 0;

var onConnectHandlers = {};
var onDisconnectHandlers = {};

/**
 * addHandler - Adds a handler to a specific handlers object, returning a function that removes the handler when called
 * @private
 */
function addHandler(handlersObject, fn) {
    if (typeof fn !== 'function') {
        throw new Error('Invalid function supplied to onConnect');
    }

    var newHandlersObject = handlersObject;
    newHandlersObject[++handlersCounter] = fn;
    var fnIndex = handlersCounter;
    return function () {
        delete newHandlersObject[fnIndex];
    };
}

/**
 * callHandlers - Calls all handlers for a specific handlers object, with specified parameters
 * @private
 */
function callHandlers(handlersObject) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    for (var _iterator = Object.keys(handlersObject), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref;

        if (_isArray) {
            if (_i >= _iterator.length) break;
            _ref = _iterator[_i++];
        } else {
            _i = _iterator.next();
            if (_i.done) break;
            _ref = _i.value;
        }

        var handlerIndex = _ref;

        if (typeof handlersObject[handlerIndex] === 'function') {
            handlersObject[handlerIndex].apply(handlersObject, params);
        }
    }
}

/**
 * connect - Connects with supplied options; this will replace stored transport settings
 *
 * @param  {object} options                   connection options to be passed to an underlying autobahn Connection, some options are overridden to keep connection up indefinitely
 * @return {bool}                             true if the library begins connecting, false if it was already connecting or connected
 */
function connect(newOptions) {
    // validate options
    if (!newOptions) {
        throw new Error('Invalid options supplied to `connect()` ');
    }

    // merge defaults
    var options = _extends({}, newOptions, {

        use_es6_promises: true,
        max_retries: -1,
        retry_if_unreachable: true
    });

    // save options
    connectionOptions = options;

    // ignore connection attempt
    if (currentConnection || connected || connecting) {
        return false;
    }

    // set connection as connecting
    connecting = true;
    currentConnection = new _autobahn2.default.Connection(options);

    // attach handlers
    currentConnection.onopen = function (session) {
        // set internal state
        connecting = false;
        connected = true;
        currentSession = session;

        // call onConnectHandlers
        callHandlers(onConnectHandlers);
    };

    // disconnects
    currentConnection.onclose = function (reason, details) {
        // internal state
        connecting = currentConnection && currentConnection.isRetrying || details && details.will_retry || false;
        connected = false;
        currentSession = null;

        // call onDisconnectHandlers
        callHandlers(onDisconnectHandlers);

        // automatically reconnect if there is are no active retry efforts
        if (!connecting && !connected) {
            currentConnection = null;
            connect(connectionOptions);
        }
    };

    // open the connection
    currentConnection.open();

    // done
    return true;
}

/**
 * disconnect - drop current connection - will disconnect the current session and another reconnect attempt will be made automatically
 *
 * @param  {string} reason  optional WAMP URI providing a closing reason
 * @param  {string} details optional (human readable) closing message
 * @return {boolean|string}         string on connection closing error, true on success
 */
function disconnect(reason, details) {
    if ((connected || connecting) && currentConnection && currentConnection.close) {
        // close the connection
        var result = currentConnection.close(reason, details);
        return typeof result === 'undefined' && true || result;
    }
    return false;
}

/**
 * isConnected - check whether the library is connected
 *
 * @return {boolean}  true if the library is connected
 */
function isConnected() {
    return !!connected;
}

/**
 * isConnecting - check whether the library is connecting
 *
 * @return {boolean}  true if the library is connecting
 */

function isConnecting() {
    return !!connecting;
}

/**
 * onConnect - attach a handler to be executed once a session is established
 *
 * @param  {function} fn    handler
 * @return {function}       returns a function which removes the handler when called
 */
function onConnect(fn) {
    return addHandler(onConnectHandlers, fn);
}

/**
 * onDisconnect - attach a handler to be executed once a session is dropped or connection is closed
 *
 * @param  {function} fn    handler
 * @return {function}       returns a function which removes the handler when called
 */
function onDisconnect(fn) {
    return addHandler(onDisconnectHandlers, fn);
}

/**
 * getSession - (private) get current session
 *
 * @return {object}  null or autobahn subscription instance
 */
function getSession() {
    return currentSession;
}

/**
 * getConnection - (private) get current connection
 *
 * @return {object}  null or autobahn connection instance
 */
function getConnection() {
    return currentConnection;
}

/***/ }),

/***/ 85:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),

/***/ 86:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),

/***/ 87:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/* global hasOwnProperty:true */



var _prodInvariant = __webpack_require__(86),
    _assign = __webpack_require__(66);

var invariant = __webpack_require__(85);
var hasOwnProperty = {}.hasOwnProperty;

function shallowCopy(x) {
  if (Array.isArray(x)) {
    return x.concat();
  } else if (x && typeof x === 'object') {
    return _assign(new x.constructor(), x);
  } else {
    return x;
  }
}

var COMMAND_PUSH = '$push';
var COMMAND_UNSHIFT = '$unshift';
var COMMAND_SPLICE = '$splice';
var COMMAND_SET = '$set';
var COMMAND_MERGE = '$merge';
var COMMAND_APPLY = '$apply';

var ALL_COMMANDS_LIST = [COMMAND_PUSH, COMMAND_UNSHIFT, COMMAND_SPLICE, COMMAND_SET, COMMAND_MERGE, COMMAND_APPLY];

var ALL_COMMANDS_SET = {};

ALL_COMMANDS_LIST.forEach(function (command) {
  ALL_COMMANDS_SET[command] = true;
});

function invariantArrayCase(value, spec, command) {
  !Array.isArray(value) ?  false ? invariant(false, 'update(): expected target of %s to be an array; got %s.', command, value) : _prodInvariant('1', command, value) : void 0;
  var specValue = spec[command];
  !Array.isArray(specValue) ?  false ? invariant(false, 'update(): expected spec of %s to be an array; got %s. Did you forget to wrap your parameter in an array?', command, specValue) : _prodInvariant('2', command, specValue) : void 0;
}

/**
 * Returns a updated shallow copy of an object without mutating the original.
 * See https://facebook.github.io/react/docs/update.html for details.
 */
function update(value, spec) {
  !(typeof spec === 'object') ?  false ? invariant(false, 'update(): You provided a key path to update() that did not contain one of %s. Did you forget to include {%s: ...}?', ALL_COMMANDS_LIST.join(', '), COMMAND_SET) : _prodInvariant('3', ALL_COMMANDS_LIST.join(', '), COMMAND_SET) : void 0;

  if (hasOwnProperty.call(spec, COMMAND_SET)) {
    !(Object.keys(spec).length === 1) ?  false ? invariant(false, 'Cannot have more than one key in an object with %s', COMMAND_SET) : _prodInvariant('4', COMMAND_SET) : void 0;

    return spec[COMMAND_SET];
  }

  var nextValue = shallowCopy(value);

  if (hasOwnProperty.call(spec, COMMAND_MERGE)) {
    var mergeObj = spec[COMMAND_MERGE];
    !(mergeObj && typeof mergeObj === 'object') ?  false ? invariant(false, 'update(): %s expects a spec of type \'object\'; got %s', COMMAND_MERGE, mergeObj) : _prodInvariant('5', COMMAND_MERGE, mergeObj) : void 0;
    !(nextValue && typeof nextValue === 'object') ?  false ? invariant(false, 'update(): %s expects a target of type \'object\'; got %s', COMMAND_MERGE, nextValue) : _prodInvariant('6', COMMAND_MERGE, nextValue) : void 0;
    _assign(nextValue, spec[COMMAND_MERGE]);
  }

  if (hasOwnProperty.call(spec, COMMAND_PUSH)) {
    invariantArrayCase(value, spec, COMMAND_PUSH);
    spec[COMMAND_PUSH].forEach(function (item) {
      nextValue.push(item);
    });
  }

  if (hasOwnProperty.call(spec, COMMAND_UNSHIFT)) {
    invariantArrayCase(value, spec, COMMAND_UNSHIFT);
    spec[COMMAND_UNSHIFT].forEach(function (item) {
      nextValue.unshift(item);
    });
  }

  if (hasOwnProperty.call(spec, COMMAND_SPLICE)) {
    !Array.isArray(value) ?  false ? invariant(false, 'Expected %s target to be an array; got %s', COMMAND_SPLICE, value) : _prodInvariant('7', COMMAND_SPLICE, value) : void 0;
    !Array.isArray(spec[COMMAND_SPLICE]) ?  false ? invariant(false, 'update(): expected spec of %s to be an array of arrays; got %s. Did you forget to wrap your parameters in an array?', COMMAND_SPLICE, spec[COMMAND_SPLICE]) : _prodInvariant('8', COMMAND_SPLICE, spec[COMMAND_SPLICE]) : void 0;
    spec[COMMAND_SPLICE].forEach(function (args) {
      !Array.isArray(args) ?  false ? invariant(false, 'update(): expected spec of %s to be an array of arrays; got %s. Did you forget to wrap your parameters in an array?', COMMAND_SPLICE, spec[COMMAND_SPLICE]) : _prodInvariant('8', COMMAND_SPLICE, spec[COMMAND_SPLICE]) : void 0;
      nextValue.splice.apply(nextValue, args);
    });
  }

  if (hasOwnProperty.call(spec, COMMAND_APPLY)) {
    !(typeof spec[COMMAND_APPLY] === 'function') ?  false ? invariant(false, 'update(): expected spec of %s to be a function; got %s.', COMMAND_APPLY, spec[COMMAND_APPLY]) : _prodInvariant('9', COMMAND_APPLY, spec[COMMAND_APPLY]) : void 0;
    nextValue = spec[COMMAND_APPLY](nextValue);
  }

  for (var k in spec) {
    if (!(ALL_COMMANDS_SET.hasOwnProperty(k) && ALL_COMMANDS_SET[k])) {
      nextValue[k] = update(value[k], spec[k]);
    }
  }

  return nextValue;
}

module.exports = update;

/***/ }),

/***/ 89:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.store = exports.storeConst = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.getReducersFor = getReducersFor;
exports.addReducer = addReducer;
exports.getMiddlewares = getMiddlewares;
exports.addMiddleware = addMiddleware;
exports.addStorePart = addStorePart;

var _redux = __webpack_require__(11);

/**
 * Constants
 */
var storeConst = exports.storeConst = {
    ERROR_INVALID_ADD_REDUCER: 'Invalid signature used for addReducer.\n        Key should be string or symbol, type should be string or symbol and reducer should be a function.',

    ADD_STORE_PART_ACTION: 'OMFE_CORE_ADD_STORE_PART_ACTION'
};

/**
 * Reducers in effect
 */
var reducers = {};
var typelessReducerKey = Symbol();
var currentReducerId = 0; // we can removeReducerById()


/**
 * The store to be exported
 * - hoisting problems
 * - gets referenced in applyReducers since promises need to dispatch their own result actions on it
 */
var tempStore = false;

/**
 * getReducersFor - returns registered reducers for a certain store key
 *
 * @param  {string} key = '' key for which to return registered reducers
 * @return {callable}          function to pass on to combineReducers
 */
function getReducersFor() {
    var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    function applyReducers() {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var action = arguments[1];

        var newState = state;

        // handle action.type (basic action)
        if (typeof action.type === 'string' && _typeof(reducers[key]) === 'object') {
            // type-based reducers
            if (_typeof(reducers[key][action.type]) === 'object') {
                for (var _iterator = Object.keys(reducers[key][action.type]), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
                    var _ref;

                    if (_isArray) {
                        if (_i >= _iterator.length) break;
                        _ref = _iterator[_i++];
                    } else {
                        _i = _iterator.next();
                        if (_i.done) break;
                        _ref = _i.value;
                    }

                    var i = _ref;

                    if (typeof i === 'string' && typeof reducers[key][action.type][i] === 'function') {
                        newState = reducers[key][action.type][i](newState, action);
                    }
                }
            }

            // typeless reducers
            if (_typeof(reducers[key][typelessReducerKey]) === 'object') {
                for (var _iterator2 = Object.keys(reducers[key][typelessReducerKey]), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
                    var _ref2;

                    if (_isArray2) {
                        if (_i2 >= _iterator2.length) break;
                        _ref2 = _iterator2[_i2++];
                    } else {
                        _i2 = _iterator2.next();
                        if (_i2.done) break;
                        _ref2 = _i2.value;
                    }

                    var _i3 = _ref2;

                    if (typeof _i3 === 'string' && typeof reducers[key][typelessReducerKey][_i3] === 'function') {
                        newState = reducers[key][typelessReducerKey][_i3](newState, action);
                    }
                }
            }
        }

        // what's left after all those mutations
        return newState;
    }
    return applyReducers;
}

/**
 * addReducer - Adds a reducer/returns a function that removes the reducer
 *
 * @param  {string}     key        state key to operate on
 * @param  {string}     [type]     action type to respond to
 * @param  {function}   reducer    the store reducer, signature is (prevState, action)
 * @return {function}              a function that removes the reducer (no arguments)
 */
var registeredStoreKeys = {};
function addReducer(key, type, reducer) {
    if (typeof key === 'string' && !key.length || typeof key !== 'string' && (typeof key === 'undefined' ? 'undefined' : _typeof(key)) !== 'symbol' || typeof type === 'string' && !type.length || typeof type !== 'string' && (typeof type === 'undefined' ? 'undefined' : _typeof(type)) !== 'symbol' && typeof reducer === 'undefined' && typeof type !== 'function' || (typeof type === 'string' || (typeof type === 'undefined' ? 'undefined' : _typeof(type)) === 'symbol') && typeof reducer !== 'function') {
        throw new Error(storeConst.ERROR_INVALID_ADD_REDUCER);
    }

    var actualType = typeof type === 'function' ? typelessReducerKey : type;
    var actualReducer = typeof type === 'function' ? type : reducer;

    if (_typeof(reducers[key]) !== 'object' || reducers[key] === 'null') {
        reducers[key] = {};
    }

    if (_typeof(reducers[key][actualType]) !== 'object' || reducers[key][actualType] === 'null') {
        reducers[key][actualType] = {};
    }

    // register this key to combineReducers in case we didn't have it
    if (!registeredStoreKeys[key]) {
        registeredStoreKeys[key] = getReducersFor(key);
        tempStore.replaceReducer((0, _redux.combineReducers)(registeredStoreKeys));
    }

    var reducerId = currentReducerId++;
    reducers[key][actualType][reducerId] = actualReducer;
    var removed = false;

    // return said function
    return function () {
        if (!removed) {
            delete reducers[key][actualType][reducerId];
            removed = true;
            return true;
        }
        return false;
    };
}

/**
 * getMiddlewares - returns all the currently registered middlewares
 * - it's essentially a copy-paste from redux, the only difference is in the wrapped dispatch
 *
 * @return {function}  function that can be passed to createStore
 */
var middlewares = [];
var middlewaresChain = false;
function getMiddlewares() {
    var compose = function compose() {
        for (var _len = arguments.length, passedMiddlewares = Array(_len), _key = 0; _key < _len; _key++) {
            passedMiddlewares[_key] = arguments[_key];
        }

        return function () {
            if (passedMiddlewares.length === 0) {
                return arguments.length <= 0 ? undefined : arguments[0];
            }

            var last = passedMiddlewares[passedMiddlewares.length - 1];
            var rest = passedMiddlewares.slice(0, -1);

            return rest.reduceRight(function (composed, f) {
                return f(composed);
            }, last.apply(undefined, arguments));
        };
    };

    return function (createStoreParam) {
        return function (reducer, initialState, enhancer) {
            var newStore = createStoreParam(reducer, initialState, enhancer);
            var _dispatch = newStore.dispatch;

            var middlewareAPI = {
                getState: newStore.getState,
                dispatch: function dispatch(action) {
                    return _dispatch(action);
                }
            };
            var recomposeChain = function recomposeChain() {
                var chain = middlewares.map(function (middleware) {
                    return middleware(middlewareAPI);
                });
                return compose.apply(undefined, chain)(newStore.dispatch);
            };

            _dispatch = function _dispatch() {
                if (!middlewaresChain) {
                    middlewaresChain = recomposeChain();
                }
                return middlewaresChain.apply(undefined, arguments);
            };

            return _extends({}, newStore, {
                dispatch: _dispatch
            });
        };
    };
}

/**
 * addMiddleware - registers a middleware; LIFO-like behavior
 *
 * @param  {function}   middleware  the middleware function
 * @return {bool/int}               false on failure, middlewares length on success
 */
function addMiddleware(middleware) {
    if (typeof middleware !== 'function') {
        return false;
    }
    middlewares = [middleware].concat(middlewares);
    middlewaresChain = false;
    return middlewares.length;
}

/**
 * addStorePart - registers a new store part
 *
 * @param  {string} [STORE_PART = '']   store part (key)
 * @param  {object} initialState = {}   initial state for store part
 * @return {undefined}
 */
var storeParts = {};
function addStorePart() {
    var STORE_PART = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var initialState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (storeParts[STORE_PART]) {
        return false;
    }
    storeParts[STORE_PART] = true;
    var removeReducer = addReducer(STORE_PART, storeConst.ADD_STORE_PART_ACTION, function () {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;

        var nextState = Object.assign({}, state, initialState);
        removeReducer();
        return nextState;
    });
    return tempStore.dispatch({
        type: storeConst.ADD_STORE_PART_ACTION,
        STORE_PART: STORE_PART,
        initialState: initialState
    });
}

/**
 * Create a store and wrap the instance
 */
var reduxStore = (0, _redux.createStore)(getReducersFor(), getMiddlewares());
tempStore = {
    getStore: function getStore() {
        return reduxStore;
    },
    getState: function getState() {
        return reduxStore.getState();
    },
    dispatch: function dispatch(action) {
        if ((typeof action === 'undefined' ? 'undefined' : _typeof(action)) === 'object' && action !== null && typeof action.type === 'undefined') {
            var newAction = Object.assign({}, action);
            newAction.type = typelessReducerKey;
            return reduxStore.dispatch(newAction);
        }
        return reduxStore.dispatch(action);
    },
    subscribe: function subscribe(listener) {
        return reduxStore.subscribe(listener);
    },
    replaceReducer: function replaceReducer(nextReducer) {
        return reduxStore.replaceReducer(nextReducer);
    }
};

/**
 * We can finally export store
 */
var store = tempStore;
exports.store = store;

/***/ })

/******/ });


// WEBPACK FOOTER //
// OMFECore.js